var Li = Object.defineProperty;
var ki = (t, e, r) => e in t ? Li(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Mn = (t, e, r) => (ki(t, typeof e != "symbol" ? e + "" : e, r), r);
import * as C from "react";
import La, { createElement as at, isValidElement as Ar, Fragment as Oi, cloneElement as Di, Children as Ti, createContext as Hr, useContext as or, useState as je, useRef as ve, useEffect as Te, useCallback as En, Suspense as Sn, forwardRef as ka, useId as It, useMemo as Ai, useLayoutEffect as _i } from "react";
import * as Ii from "react-dom";
import Fi from "react-dom";
import Ft from "axios";
function $i(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var hn = { exports: {} }, Wt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Un;
function Mi() {
  if (Un)
    return Wt;
  Un = 1;
  var t = La, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, l, c) {
    var u, p = {}, h = null, b = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (b = l.ref);
    for (u in l)
      n.call(l, u) && !i.hasOwnProperty(u) && (p[u] = l[u]);
    if (o && o.defaultProps)
      for (u in l = o.defaultProps, l)
        p[u] === void 0 && (p[u] = l[u]);
    return { $$typeof: e, type: o, key: h, ref: b, props: p, _owner: a.current };
  }
  return Wt.Fragment = r, Wt.jsx = s, Wt.jsxs = s, Wt;
}
var Yt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vn;
function Ui() {
  return Vn || (Vn = 1, process.env.NODE_ENV !== "production" && function() {
    var t = La, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), S = Symbol.iterator, j = "@@iterator";
    function E(d) {
      if (d === null || typeof d != "object")
        return null;
      var x = S && d[S] || d[j];
      return typeof x == "function" ? x : null;
    }
    var P = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(d) {
      {
        for (var x = arguments.length, R = new Array(x > 1 ? x - 1 : 0), k = 1; k < x; k++)
          R[k - 1] = arguments[k];
        O("error", d, R);
      }
    }
    function O(d, x, R) {
      {
        var k = P.ReactDebugCurrentFrame, M = k.getStackAddendum();
        M !== "" && (x += "%s", R = R.concat([M]));
        var H = R.map(function(V) {
          return String(V);
        });
        H.unshift("Warning: " + x), Function.prototype.apply.call(console[d], console, H);
      }
    }
    var L = !1, D = !1, g = !1, T = !1, F = !1, I;
    I = Symbol.for("react.module.reference");
    function U(d) {
      return !!(typeof d == "string" || typeof d == "function" || d === n || d === i || F || d === a || d === c || d === u || T || d === b || L || D || g || typeof d == "object" && d !== null && (d.$$typeof === h || d.$$typeof === p || d.$$typeof === s || d.$$typeof === o || d.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      d.$$typeof === I || d.getModuleId !== void 0));
    }
    function W(d, x, R) {
      var k = d.displayName;
      if (k)
        return k;
      var M = x.displayName || x.name || "";
      return M !== "" ? R + "(" + M + ")" : R;
    }
    function G(d) {
      return d.displayName || "Context";
    }
    function q(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case o:
            var x = d;
            return G(x) + ".Consumer";
          case s:
            var R = d;
            return G(R._context) + ".Provider";
          case l:
            return W(d, d.render, "ForwardRef");
          case p:
            var k = d.displayName || null;
            return k !== null ? k : q(d.type) || "Memo";
          case h: {
            var M = d, H = M._payload, V = M._init;
            try {
              return q(V(H));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var J = Object.assign, Z = 0, Le, ne, se, be, we, Ee, Ye;
    function et() {
    }
    et.__reactDisabledLog = !0;
    function Ie() {
      {
        if (Z === 0) {
          Le = console.log, ne = console.info, se = console.warn, be = console.error, we = console.group, Ee = console.groupCollapsed, Ye = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: et,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        Z++;
      }
    }
    function Ge() {
      {
        if (Z--, Z === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: J({}, d, {
              value: Le
            }),
            info: J({}, d, {
              value: ne
            }),
            warn: J({}, d, {
              value: se
            }),
            error: J({}, d, {
              value: be
            }),
            group: J({}, d, {
              value: we
            }),
            groupCollapsed: J({}, d, {
              value: Ee
            }),
            groupEnd: J({}, d, {
              value: Ye
            })
          });
        }
        Z < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = P.ReactCurrentDispatcher, tt;
    function yt(d, x, R) {
      {
        if (tt === void 0)
          try {
            throw Error();
          } catch (M) {
            var k = M.stack.trim().match(/\n( *(at )?)/);
            tt = k && k[1] || "";
          }
        return `
` + tt + d;
      }
    }
    var Ut = !1, bt;
    {
      var pe = typeof WeakMap == "function" ? WeakMap : Map;
      bt = new pe();
    }
    function Ze(d, x) {
      if (!d || Ut)
        return "";
      {
        var R = bt.get(d);
        if (R !== void 0)
          return R;
      }
      var k;
      Ut = !0;
      var M = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var H;
      H = Fe.current, Fe.current = null, Ie();
      try {
        if (x) {
          var V = function() {
            throw Error();
          };
          if (Object.defineProperty(V.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(V, []);
            } catch (ce) {
              k = ce;
            }
            Reflect.construct(d, [], V);
          } else {
            try {
              V.call();
            } catch (ce) {
              k = ce;
            }
            d.call(V.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ce) {
            k = ce;
          }
          d();
        }
      } catch (ce) {
        if (ce && k && typeof ce.stack == "string") {
          for (var A = ce.stack.split(`
`), Y = k.stack.split(`
`), Q = A.length - 1, te = Y.length - 1; Q >= 1 && te >= 0 && A[Q] !== Y[te]; )
            te--;
          for (; Q >= 1 && te >= 0; Q--, te--)
            if (A[Q] !== Y[te]) {
              if (Q !== 1 || te !== 1)
                do
                  if (Q--, te--, te < 0 || A[Q] !== Y[te]) {
                    var ae = `
` + A[Q].replace(" at new ", " at ");
                    return d.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", d.displayName)), typeof d == "function" && bt.set(d, ae), ae;
                  }
                while (Q >= 1 && te >= 0);
              break;
            }
        }
      } finally {
        Ut = !1, Fe.current = H, Ge(), Error.prepareStackTrace = M;
      }
      var me = d ? d.displayName || d.name : "", Me = me ? yt(me) : "";
      return typeof d == "function" && bt.set(d, Me), Me;
    }
    function fr(d, x, R) {
      return Ze(d, !1);
    }
    function en(d) {
      var x = d.prototype;
      return !!(x && x.isReactComponent);
    }
    function ke(d, x, R) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return Ze(d, en(d));
      if (typeof d == "string")
        return yt(d);
      switch (d) {
        case c:
          return yt("Suspense");
        case u:
          return yt("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case l:
            return fr(d.render);
          case p:
            return ke(d.type, x, R);
          case h: {
            var k = d, M = k._payload, H = k._init;
            try {
              return ke(H(M), x, R);
            } catch {
            }
          }
        }
      return "";
    }
    var lt = Object.prototype.hasOwnProperty, hr = {}, Vt = P.ReactDebugCurrentFrame;
    function vt(d) {
      if (d) {
        var x = d._owner, R = ke(d.type, d._source, x ? x.type : null);
        Vt.setExtraStackFrame(R);
      } else
        Vt.setExtraStackFrame(null);
    }
    function tn(d, x, R, k, M) {
      {
        var H = Function.call.bind(lt);
        for (var V in d)
          if (H(d, V)) {
            var A = void 0;
            try {
              if (typeof d[V] != "function") {
                var Y = Error((k || "React class") + ": " + R + " type `" + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[V] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Y.name = "Invariant Violation", Y;
              }
              A = d[V](x, V, k, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              A = Q;
            }
            A && !(A instanceof Error) && (vt(M), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", R, V, typeof A), vt(null)), A instanceof Error && !(A.message in hr) && (hr[A.message] = !0, vt(M), v("Failed %s type: %s", R, A.message), vt(null));
          }
      }
    }
    var rn = Array.isArray;
    function zt(d) {
      return rn(d);
    }
    function Xe(d) {
      {
        var x = typeof Symbol == "function" && Symbol.toStringTag, R = x && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return R;
      }
    }
    function ct(d) {
      try {
        return Bt(d), !1;
      } catch {
        return !0;
      }
    }
    function Bt(d) {
      return "" + d;
    }
    function xt(d) {
      if (ct(d))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe(d)), Bt(d);
    }
    var Se = P.ReactCurrentOwner, $e = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Kt, ut, Ht;
    Ht = {};
    function Be(d) {
      if (lt.call(d, "ref")) {
        var x = Object.getOwnPropertyDescriptor(d, "ref").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return d.ref !== void 0;
    }
    function pr(d) {
      if (lt.call(d, "key")) {
        var x = Object.getOwnPropertyDescriptor(d, "key").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return d.key !== void 0;
    }
    function mr(d, x) {
      if (typeof d.ref == "string" && Se.current && x && Se.current.stateNode !== x) {
        var R = q(Se.current.type);
        Ht[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(Se.current.type), d.ref), Ht[R] = !0);
      }
    }
    function gr(d, x) {
      {
        var R = function() {
          Kt || (Kt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        R.isReactWarning = !0, Object.defineProperty(d, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function nn(d, x) {
      {
        var R = function() {
          ut || (ut = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        R.isReactWarning = !0, Object.defineProperty(d, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var yr = function(d, x, R, k, M, H, V) {
      var A = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: d,
        key: x,
        ref: R,
        props: V,
        // Record the component responsible for creating this element.
        _owner: H
      };
      return A._store = {}, Object.defineProperty(A._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(A, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(A, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.freeze && (Object.freeze(A.props), Object.freeze(A)), A;
    };
    function wt(d, x, R, k, M) {
      {
        var H, V = {}, A = null, Y = null;
        R !== void 0 && (xt(R), A = "" + R), pr(x) && (xt(x.key), A = "" + x.key), Be(x) && (Y = x.ref, mr(x, M));
        for (H in x)
          lt.call(x, H) && !$e.hasOwnProperty(H) && (V[H] = x[H]);
        if (d && d.defaultProps) {
          var Q = d.defaultProps;
          for (H in Q)
            V[H] === void 0 && (V[H] = Q[H]);
        }
        if (A || Y) {
          var te = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
          A && gr(V, te), Y && nn(V, te);
        }
        return yr(d, A, Y, M, k, Se.current, V);
      }
    }
    var Et = P.ReactCurrentOwner, St = P.ReactDebugCurrentFrame;
    function Ke(d) {
      if (d) {
        var x = d._owner, R = ke(d.type, d._source, x ? x.type : null);
        St.setExtraStackFrame(R);
      } else
        St.setExtraStackFrame(null);
    }
    var qt;
    qt = !1;
    function Rt(d) {
      return typeof d == "object" && d !== null && d.$$typeof === e;
    }
    function br() {
      {
        if (Et.current) {
          var d = q(Et.current.type);
          if (d)
            return `

Check the render method of \`` + d + "`.";
        }
        return "";
      }
    }
    function vr(d) {
      {
        if (d !== void 0) {
          var x = d.fileName.replace(/^.*[\\\/]/, ""), R = d.lineNumber;
          return `

Check your code at ` + x + ":" + R + ".";
        }
        return "";
      }
    }
    var dt = {};
    function jt(d) {
      {
        var x = br();
        if (!x) {
          var R = typeof d == "string" ? d : d.displayName || d.name;
          R && (x = `

Check the top-level render call using <` + R + ">.");
        }
        return x;
      }
    }
    function xr(d, x) {
      {
        if (!d._store || d._store.validated || d.key != null)
          return;
        d._store.validated = !0;
        var R = jt(x);
        if (dt[R])
          return;
        dt[R] = !0;
        var k = "";
        d && d._owner && d._owner !== Et.current && (k = " It was passed a child from " + q(d._owner.type) + "."), Ke(d), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, k), Ke(null);
      }
    }
    function wr(d, x) {
      {
        if (typeof d != "object")
          return;
        if (zt(d))
          for (var R = 0; R < d.length; R++) {
            var k = d[R];
            Rt(k) && xr(k, x);
          }
        else if (Rt(d))
          d._store && (d._store.validated = !0);
        else if (d) {
          var M = E(d);
          if (typeof M == "function" && M !== d.entries)
            for (var H = M.call(d), V; !(V = H.next()).done; )
              Rt(V.value) && xr(V.value, x);
        }
      }
    }
    function m(d) {
      {
        var x = d.type;
        if (x == null || typeof x == "string")
          return;
        var R;
        if (typeof x == "function")
          R = x.propTypes;
        else if (typeof x == "object" && (x.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        x.$$typeof === p))
          R = x.propTypes;
        else
          return;
        if (R) {
          var k = q(x);
          tn(R, d.props, "prop", k, d);
        } else if (x.PropTypes !== void 0 && !qt) {
          qt = !0;
          var M = q(x);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", M || "Unknown");
        }
        typeof x.getDefaultProps == "function" && !x.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function y(d) {
      {
        for (var x = Object.keys(d.props), R = 0; R < x.length; R++) {
          var k = x[R];
          if (k !== "children" && k !== "key") {
            Ke(d), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Ke(null);
            break;
          }
        }
        d.ref !== null && (Ke(d), v("Invalid attribute `ref` supplied to `React.Fragment`."), Ke(null));
      }
    }
    var w = {};
    function N(d, x, R, k, M, H) {
      {
        var V = U(d);
        if (!V) {
          var A = "";
          (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (A += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Y = vr(M);
          Y ? A += Y : A += br();
          var Q;
          d === null ? Q = "null" : zt(d) ? Q = "array" : d !== void 0 && d.$$typeof === e ? (Q = "<" + (q(d.type) || "Unknown") + " />", A = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof d, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, A);
        }
        var te = wt(d, x, R, M, H);
        if (te == null)
          return te;
        if (V) {
          var ae = x.children;
          if (ae !== void 0)
            if (k)
              if (zt(ae)) {
                for (var me = 0; me < ae.length; me++)
                  wr(ae[me], d);
                Object.freeze && Object.freeze(ae);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wr(ae, d);
        }
        if (lt.call(x, "key")) {
          var Me = q(d), ce = Object.keys(x).filter(function(Pt) {
            return Pt !== "key";
          }), Ue = ce.length > 0 ? "{key: someKey, " + ce.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!w[Me + Ue]) {
            var Ct = ce.length > 0 ? "{" + ce.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ue, Me, Ct, Me), w[Me + Ue] = !0;
          }
        }
        return d === n ? y(te) : m(te), te;
      }
    }
    function _(d, x, R) {
      return N(d, x, R, !0);
    }
    function B(d, x, R) {
      return N(d, x, R, !1);
    }
    var K = B, $ = _;
    Yt.Fragment = n, Yt.jsx = K, Yt.jsxs = $;
  }()), Yt;
}
process.env.NODE_ENV === "production" ? hn.exports = Mi() : hn.exports = Ui();
var f = hn.exports;
const Vi = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class _r {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, r);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = e || Vi, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, r, n, a) {
    return a && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[r](e));
  }
  create(e) {
    return new _r(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new _r(this.logger, e);
  }
}
var qe = new _r();
class qr {
  constructor() {
    this.observers = {};
  }
  on(e, r) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const a = this.observers[n].get(r) || 0;
      this.observers[n].set(r, a + 1);
    }), this;
  }
  off(e, r) {
    if (this.observers[e]) {
      if (!r) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(r);
    }
  }
  emit(e) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((s) => {
      let [o, l] = s;
      for (let c = 0; c < l; c++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [o, l] = s;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...n]);
    });
  }
}
const Gt = () => {
  let t, e;
  const r = new Promise((n, a) => {
    t = n, e = a;
  });
  return r.resolve = t, r.reject = e, r;
}, zn = (t) => t == null ? "" : "" + t, zi = (t, e, r) => {
  t.forEach((n) => {
    e[n] && (r[n] = e[n]);
  });
}, Bi = /###/g, Bn = (t) => t && t.indexOf("###") > -1 ? t.replace(Bi, ".") : t, Kn = (t) => !t || typeof t == "string", nr = (t, e, r) => {
  const n = typeof e != "string" ? e : e.split(".");
  let a = 0;
  for (; a < n.length - 1; ) {
    if (Kn(t))
      return {};
    const i = Bn(n[a]);
    !t[i] && r && (t[i] = new r()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++a;
  }
  return Kn(t) ? {} : {
    obj: t,
    k: Bn(n[a])
  };
}, Hn = (t, e, r) => {
  const {
    obj: n,
    k: a
  } = nr(t, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[a] = r;
    return;
  }
  let i = e[e.length - 1], s = e.slice(0, e.length - 1), o = nr(t, s, Object);
  for (; o.obj === void 0 && s.length; )
    i = `${s[s.length - 1]}.${i}`, s = s.slice(0, s.length - 1), o = nr(t, s, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = r;
}, Ki = (t, e, r, n) => {
  const {
    obj: a,
    k: i
  } = nr(t, e, Object);
  a[i] = a[i] || [], a[i].push(r);
}, Ir = (t, e) => {
  const {
    obj: r,
    k: n
  } = nr(t, e);
  if (r)
    return r[n];
}, Hi = (t, e, r) => {
  const n = Ir(t, r);
  return n !== void 0 ? n : Ir(e, r);
}, Oa = (t, e, r) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in t ? typeof t[n] == "string" || t[n] instanceof String || typeof e[n] == "string" || e[n] instanceof String ? r && (t[n] = e[n]) : Oa(t[n], e[n], r) : t[n] = e[n]);
  return t;
}, kt = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var qi = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Ji = (t) => typeof t == "string" ? t.replace(/[&<>"'\/]/g, (e) => qi[e]) : t;
class Wi {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const r = this.regExpMap.get(e);
    if (r !== void 0)
      return r;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const Yi = [" ", ",", "?", "!", ";"], Gi = new Wi(20), Zi = (t, e, r) => {
  e = e || "", r = r || "";
  const n = Yi.filter((s) => e.indexOf(s) < 0 && r.indexOf(s) < 0);
  if (n.length === 0)
    return !0;
  const a = Gi.getRegExp(`(${n.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let i = !a.test(t);
  if (!i) {
    const s = t.indexOf(r);
    s > 0 && !a.test(t.substring(0, s)) && (i = !0);
  }
  return i;
}, pn = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t)
    return;
  if (t[e])
    return t[e];
  const n = e.split(r);
  let a = t;
  for (let i = 0; i < n.length; ) {
    if (!a || typeof a != "object")
      return;
    let s, o = "";
    for (let l = i; l < n.length; ++l)
      if (l !== i && (o += r), o += n[l], s = a[o], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < n.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    a = s;
  }
  return a;
}, Fr = (t) => t && t.replace("_", "-");
class qn extends qr {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const r = this.options.ns.indexOf(e);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, s = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, r], n && (Array.isArray(n) ? o.push(...n) : typeof n == "string" && i ? o.push(...n.split(i)) : o.push(n)));
    const l = Ir(this.data, o);
    return !l && !r && !n && e.indexOf(".") > -1 && (e = o[0], r = o[1], n = o.slice(2).join(".")), l || !s || typeof n != "string" ? l : pn(this.data && this.data[e] && this.data[e][r], n, i);
  }
  addResource(e, r, n, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, r];
    n && (o = o.concat(s ? n.split(s) : n)), e.indexOf(".") > -1 && (o = e.split("."), a = r, r = o[1]), this.addNamespaces(r), Hn(this.data, o, a), i.silent || this.emit("added", e, r, n, a);
  }
  addResources(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (typeof n[i] == "string" || Array.isArray(n[i])) && this.addResource(e, r, i, n[i], {
        silent: !0
      });
    a.silent || this.emit("added", e, r, n);
  }
  addResourceBundle(e, r, n, a, i) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, r];
    e.indexOf(".") > -1 && (o = e.split("."), a = n, n = r, r = o[1]), this.addNamespaces(r);
    let l = Ir(this.data, o) || {};
    s.skipCopy || (n = JSON.parse(JSON.stringify(n))), a ? Oa(l, n, i) : l = {
      ...l,
      ...n
    }, Hn(this.data, o, l), s.silent || this.emit("added", e, r, n);
  }
  removeResourceBundle(e, r) {
    this.hasResourceBundle(e, r) && delete this.data[e][r], this.removeNamespaces(r), this.emit("removed", e, r);
  }
  hasResourceBundle(e, r) {
    return this.getResource(e, r) !== void 0;
  }
  getResourceBundle(e, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, r)
    } : this.getResource(e, r);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const r = this.getDataByLanguage(e);
    return !!(r && Object.keys(r) || []).find((a) => r[a] && Object.keys(r[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Da = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, r, n, a) {
    return t.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, r, n, a));
    }), e;
  }
};
const Jn = {};
class $r extends qr {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), zi(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = qe.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, r);
    return n && n.res !== void 0;
  }
  extractFromKey(e, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const s = n && e.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !Zi(e, n, a);
    if (s && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: i
        };
      const c = e.split(n);
      (n !== a || n === a && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), e = c.join(a);
    }
    return typeof i == "string" && (i = [i]), {
      key: e,
      namespaces: i
    };
  }
  translate(e, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const a = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], r), l = o[o.length - 1], c = r.lng || this.language, u = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const L = r.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${L}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${L}${s}`;
      }
      return a ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : s;
    }
    const p = this.resolve(e, r);
    let h = p && p.res;
    const b = p && p.usedKey || s, S = p && p.exactUsedKey || s, j = Object.prototype.toString.apply(h), E = ["[object Number]", "[object Function]", "[object RegExp]"], P = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (v && h && (typeof h != "string" && typeof h != "boolean" && typeof h != "number") && E.indexOf(j) < 0 && !(typeof P == "string" && Array.isArray(h))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const L = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, h, {
          ...r,
          ns: o
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return a ? (p.res = L, p.usedParams = this.getUsedParamsDetails(r), p) : L;
      }
      if (i) {
        const L = Array.isArray(h), D = L ? [] : {}, g = L ? S : b;
        for (const T in h)
          if (Object.prototype.hasOwnProperty.call(h, T)) {
            const F = `${g}${i}${T}`;
            D[T] = this.translate(F, {
              ...r,
              joinArrays: !1,
              ns: o
            }), D[T] === F && (D[T] = h[T]);
          }
        h = D;
      }
    } else if (v && typeof P == "string" && Array.isArray(h))
      h = h.join(P), h && (h = this.extendTranslation(h, e, r, n));
    else {
      let L = !1, D = !1;
      const g = r.count !== void 0 && typeof r.count != "string", T = $r.hasDefaultValue(r), F = g ? this.pluralResolver.getSuffix(c, r.count, r) : "", I = r.ordinal && g ? this.pluralResolver.getSuffix(c, r.count, {
        ordinal: !1
      }) : "", U = g && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), W = U && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${F}`] || r[`defaultValue${I}`] || r.defaultValue;
      !this.isValidLookup(h) && T && (L = !0, h = W), this.isValidLookup(h) || (D = !0, h = s);
      const q = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && D ? void 0 : h, J = T && W !== h && this.options.updateMissing;
      if (D || L || J) {
        if (this.logger.log(J ? "updateKey" : "missingKey", c, l, s, J ? W : h), i) {
          const se = this.resolve(s, {
            ...r,
            keySeparator: !1
          });
          se && se.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Z = [];
        const Le = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Le && Le[0])
          for (let se = 0; se < Le.length; se++)
            Z.push(Le[se]);
        else
          this.options.saveMissingTo === "all" ? Z = this.languageUtils.toResolveHierarchy(r.lng || this.language) : Z.push(r.lng || this.language);
        const ne = (se, be, we) => {
          const Ee = T && we !== h ? we : q;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(se, l, be, Ee, J, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(se, l, be, Ee, J, r), this.emit("missingKey", se, l, be, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && g ? Z.forEach((se) => {
          const be = this.pluralResolver.getSuffixes(se, r);
          U && r[`defaultValue${this.options.pluralSeparator}zero`] && be.indexOf(`${this.options.pluralSeparator}zero`) < 0 && be.push(`${this.options.pluralSeparator}zero`), be.forEach((we) => {
            ne([se], s + we, r[`defaultValue${we}`] || W);
          });
        }) : ne(Z, s, W));
      }
      h = this.extendTranslation(h, e, r, p, n), D && h === s && this.options.appendNamespaceToMissingKey && (h = `${l}:${s}`), (D || L) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${s}` : s, L ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return a ? (p.res = h, p.usedParams = this.getUsedParamsDetails(r), p) : h;
  }
  extendTranslation(e, r, n, a, i) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const c = typeof e == "string" && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let p = n.replace && typeof n.replace != "string" ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), e = this.interpolator.interpolate(e, p, n.lng || this.language || a.usedLng, n), c) {
        const h = e.match(this.interpolator.nestingRegexp), b = h && h.length;
        u < b && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (n.lng = this.language || a.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, b = new Array(h), S = 0; S < h; S++)
          b[S] = arguments[S];
        return i && i[0] === b[0] && !n.context ? (s.logger.warn(`It seems you are nesting recursively key: ${b[0]} in key: ${r[0]}`), null) : s.translate(...b, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = typeof o == "string" ? [o] : o;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = Da.handle(l, e, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, a, i, s, o;
    return typeof e == "string" && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n))
        return;
      const c = this.extractFromKey(l, r), u = c.key;
      a = u;
      let p = c.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const h = r.count !== void 0 && typeof r.count != "string", b = h && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), S = r.context !== void 0 && (typeof r.context == "string" || typeof r.context == "number") && r.context !== "", j = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      p.forEach((E) => {
        this.isValidLookup(n) || (o = E, !Jn[`${j[0]}-${E}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Jn[`${j[0]}-${E}`] = !0, this.logger.warn(`key "${a}" for languages "${j.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), j.forEach((P) => {
          if (this.isValidLookup(n))
            return;
          s = P;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, P, E, r);
          else {
            let L;
            h && (L = this.pluralResolver.getSuffix(P, r.count, r));
            const D = `${this.options.pluralSeparator}zero`, g = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (v.push(u + L), r.ordinal && L.indexOf(g) === 0 && v.push(u + L.replace(g, this.options.pluralSeparator)), b && v.push(u + D)), S) {
              const T = `${u}${this.options.contextSeparator}${r.context}`;
              v.push(T), h && (v.push(T + L), r.ordinal && L.indexOf(g) === 0 && v.push(T + L.replace(g, this.options.pluralSeparator)), b && v.push(T + D));
            }
          }
          let O;
          for (; O = v.pop(); )
            this.isValidLookup(n) || (i = O, n = this.getResource(P, E, O, r));
        }));
      });
    }), {
      res: n,
      usedKey: a,
      exactUsedKey: i,
      usedLng: s,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, r, n, a) : this.resourceStore.getResource(e, r, n, a);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && typeof e.replace != "string";
    let a = n ? e.replace : e;
    if (n && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !n) {
      a = {
        ...a
      };
      for (const i of r)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const r = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && r === n.substring(0, r.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
const an = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class Wn {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = qe.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Fr(e), !e || e.indexOf("-") < 0)
      return null;
    const r = e.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Fr(e), !e || e.indexOf("-") < 0)
      return e;
    const r = e.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(e)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((a) => a.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = an(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = an(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = an(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let r;
    return e.forEach((n) => {
      if (r)
        return;
      const a = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (r = a);
    }), !r && this.options.supportedLngs && e.forEach((n) => {
      if (r)
        return;
      const a = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(a))
        return r = a;
      r = this.options.supportedLngs.find((i) => {
        if (i === a)
          return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(e, r) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(r)), typeof e == "string" && (e = [e]), Array.isArray(e))
      return e;
    if (!r)
      return e.default || [];
    let n = e[r];
    return n || (n = e[this.getScriptPartFromCode(r)]), n || (n = e[this.formatLanguageCode(r)]), n || (n = e[this.getLanguagePartFromCode(r)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], e), a = [], i = (s) => {
      s && (this.isSupportedCode(s) ? a.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : typeof e == "string" && i(this.formatLanguageCode(e)), n.forEach((s) => {
      a.indexOf(s) < 0 && i(this.formatLanguageCode(s));
    }), a;
  }
}
let Xi = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Qi = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const es = ["v1", "v2", "v3"], ts = ["v4"], Yn = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, rs = () => {
  const t = {};
  return Xi.forEach((e) => {
    e.lngs.forEach((r) => {
      t[r] = {
        numbers: e.nr,
        plurals: Qi[e.fc]
      };
    });
  }), t;
};
class ns {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = r, this.logger = qe.create("pluralResolver"), (!this.options.compatibilityJSON || ts.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = rs(), this.pluralRulesCache = {};
  }
  addRule(e, r) {
    this.rules[e] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const n = Fr(e === "dev" ? "en" : e), a = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
          cleanedCode: n,
          type: a
        });
        if (i in this.pluralRulesCache)
          return this.pluralRulesCache[i];
        const s = new Intl.PluralRules(n, {
          type: a
        });
        return this.pluralRulesCache[i] = s, s;
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((a) => `${r}${a}`);
  }
  getSuffixes(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((a, i) => Yn[a] - Yn[i]).map((a) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : n.numbers.map((a) => this.getSuffix(e, a, r)) : [];
  }
  getSuffix(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(e, n);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(r)}` : this.getSuffixRetroCompatible(a, r) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, r) {
    const n = e.noAbs ? e.plurals(r) : e.plurals(Math.abs(r));
    let a = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !es.includes(this.options.compatibilityJSON);
  }
}
const Gn = function(t, e, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Hi(t, e, r);
  return !i && a && typeof r == "string" && (i = pn(t, r, n), i === void 0 && (i = pn(e, r, n))), i;
}, sn = (t) => t.replace(/\$/g, "$$$$");
class as {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = qe.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: s,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: p,
      nestingPrefix: h,
      nestingPrefixEscaped: b,
      nestingSuffix: S,
      nestingSuffixEscaped: j,
      nestingOptionsSeparator: E,
      maxReplaces: P,
      alwaysFormat: v
    } = e.interpolation;
    this.escape = r !== void 0 ? r : Ji, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? kt(i) : s || "{{", this.suffix = o ? kt(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? kt(h) : b || kt("$t("), this.nestingSuffix = S ? kt(S) : j || kt(")"), this.nestingOptionsSeparator = E || ",", this.maxReplaces = P || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, r, n, a) {
    let i, s, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const P = Gn(r, l, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(P, void 0, n, {
          ...a,
          ...r,
          interpolationkey: b
        }) : P;
      }
      const S = b.split(this.formatSeparator), j = S.shift().trim(), E = S.join(this.formatSeparator).trim();
      return this.format(Gn(r, l, j, this.options.keySeparator, this.options.ignoreJSONStructure), E, n, {
        ...a,
        ...r,
        interpolationkey: j
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, p = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => sn(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? sn(this.escape(b)) : sn(b)
    }].forEach((b) => {
      for (o = 0; i = b.regex.exec(e); ) {
        const S = i[1].trim();
        if (s = c(S), s === void 0)
          if (typeof u == "function") {
            const E = u(e, i, a);
            s = typeof E == "string" ? E : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, S))
            s = "";
          else if (p) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${S} for interpolating ${e}`), s = "";
        else
          typeof s != "string" && !this.useRawValueToEscape && (s = zn(s));
        const j = b.safeValue(s);
        if (e = e.replace(i[0], j), p ? (b.regex.lastIndex += s.length, b.regex.lastIndex -= i[0].length) : b.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, s;
    const o = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const p = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${p[1]}`;
      l = p[0], h = this.interpolate(h, s);
      const b = h.match(/'/g), S = h.match(/"/g);
      (b && b.length % 2 === 0 && !S || S.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        s = JSON.parse(h), c && (s = {
          ...c,
          ...s
        });
      } catch (j) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, j), `${l}${u}${h}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(e); ) {
      let l = [];
      s = {
        ...n
      }, s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((p) => p.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (i = r(o.call(this, a[1].trim(), s), s), i && a[0] === e && typeof i != "string")
        return i;
      typeof i != "string" && (i = zn(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), i = ""), c && (i = l.reduce((u, p) => this.format(u, p, n.lng, {
        ...n,
        interpolationkey: a[1].trim()
      }), i.trim())), e = e.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const is = (t) => {
  let e = t.toLowerCase().trim();
  const r = {};
  if (t.indexOf("(") > -1) {
    const n = t.split("(");
    e = n[0].toLowerCase().trim();
    const a = n[1].substring(0, n[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? r.currency || (r.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? r.range || (r.range = a.trim()) : a.split(";").forEach((s) => {
      if (s) {
        const [o, ...l] = s.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        r[u] || (r[u] = c), c === "false" && (r[u] = !1), c === "true" && (r[u] = !0), isNaN(c) || (r[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: r
  };
}, Ot = (t) => {
  const e = {};
  return (r, n, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const s = n + JSON.stringify(i);
    let o = e[s];
    return o || (o = t(Fr(n), a), e[s] = o), o(r);
  };
};
class ss {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = qe.create("formatter"), this.options = e, this.formats = {
      number: Ot((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      }),
      currency: Ot((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: Ot((r, n) => {
        const a = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      }),
      relativetime: Ot((r, n) => {
        const a = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (i) => a.format(i, n.range || "day");
      }),
      list: Ot((r, n) => {
        const a = new Intl.ListFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",";
  }
  add(e, r) {
    this.formats[e.toLowerCase().trim()] = r;
  }
  addCached(e, r) {
    this.formats[e.toLowerCase().trim()] = Ot(r);
  }
  format(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = is(l);
      if (this.formats[c]) {
        let p = o;
        try {
          const h = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, b = h.locale || h.lng || a.locale || a.lng || n;
          p = this.formats[c](o, b, {
            ...u,
            ...a,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const os = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class ls extends qr {
  constructor(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = a, this.logger = qe.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, a.backend, a);
  }
  queueLoad(e, r, n, a) {
    const i = {}, s = {}, o = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      r.forEach((p) => {
        const h = `${c}|${p}`;
        !n.reload && this.store.hasResourceBundle(c, p) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? s[h] === void 0 && (s[h] = !0) : (this.state[h] = 1, u = !1, s[h] === void 0 && (s[h] = !0), i[h] === void 0 && (i[h] = !0), l[p] === void 0 && (l[p] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(i).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, r, n) {
    const a = e.split("|"), i = a[0], s = a[1];
    r && this.emit("failedLoading", i, s, r), !r && n && this.store.addResourceBundle(i, s, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = r ? -1 : 2, r && n && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      Ki(l.loaded, [i], s), os(l, e), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((p) => {
          o[c][p] === void 0 && (o[c][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: r,
        fcName: n,
        tried: a,
        wait: i,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, r, n, a + 1, i * 2, s);
        }, i);
        return;
      }
      s(c, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, r);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, r, o);
  }
  prepareLoading(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof r == "string" && (r = [r]);
    const i = this.queueLoad(e, r, n, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(e, r, n) {
    this.prepareLoading(e, r, {}, n);
  }
  reload(e, r, n) {
    this.prepareLoading(e, r, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), a = n[0], i = n[1];
    this.read(a, i, "read", void 0, void 0, (s, o) => {
      s && this.logger.warn(`${r}loading namespace ${i} for language ${a} failed`, s), !s && o && this.logger.log(`${r}loaded namespace ${i} for language ${a}`, o), this.loaded(e, s, o);
    });
  }
  saveMissing(e, r, n, a, i) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...s,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, r, n, a, l) : u = c(e, r, n, a), u && typeof u.then == "function" ? u.then((p) => o(null, p)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(e, r, n, a, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], r, n, a);
    }
  }
}
const Zn = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), typeof t[1] == "string" && (e.defaultValue = t[1]), typeof t[2] == "string" && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const r = t[3] || t[2];
      Object.keys(r).forEach((n) => {
        e[n] = r[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Xn = (t) => (typeof t.ns == "string" && (t.ns = [t.ns]), typeof t.fallbackLng == "string" && (t.fallbackLng = [t.fallbackLng]), typeof t.fallbackNS == "string" && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), Er = () => {
}, cs = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((r) => {
    typeof t[r] == "function" && (t[r] = t[r].bind(t));
  });
};
class ar extends qr {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Xn(e), this.services = {}, this.logger = qe, this.modules = {
      external: []
    }, cs(this), r && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, r), this;
      setTimeout(() => {
        this.init(e, r);
      }, 0);
    }
  }
  init() {
    var e = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (typeof r.ns == "string" ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const a = Zn();
    this.options = {
      ...a,
      ...this.options,
      ...Xn(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? qe.init(i(this.modules.logger), this.options) : qe.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = ss);
      const p = new Wn(this.options);
      this.store = new qn(this.options.resources, this.options);
      const h = this.services;
      h.logger = qe, h.resourceStore = this.store, h.languageUtils = p, h.pluralResolver = new ns(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (h.formatter = i(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new as(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new ls(i(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(b) {
        for (var S = arguments.length, j = new Array(S > 1 ? S - 1 : 0), E = 1; E < S; E++)
          j[E - 1] = arguments[E];
        e.emit(b, ...j);
      }), this.modules.languageDetector && (h.languageDetector = i(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = i(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new $r(this.services, this.options), this.translator.on("*", function(b) {
        for (var S = arguments.length, j = new Array(S > 1 ? S - 1 : 0), E = 1; E < S; E++)
          j[E - 1] = arguments[E];
        e.emit(b, ...j);
      }), this.modules.external.forEach((b) => {
        b.init && b.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = Er), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Gt(), c = () => {
      const u = (p, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), n(p, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Er;
    const a = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const i = [], s = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      a ? s(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => s(l)), this.options.preload && this.options.preload.forEach((o) => s(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(e, r, n) {
    const a = Gt();
    return typeof e == "function" && (n = e, e = void 0), typeof r == "function" && (n = r, r = void 0), e || (e = this.languages), r || (r = this.options.ns), n || (n = Er), this.services.backendConnector.reload(e, r, (i) => {
      a.resolve(), n(i);
    }), a;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Da.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, r) {
    var n = this;
    this.isLanguageChangingTo = e;
    const a = Gt();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, s = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return n.t(...arguments);
      }), r && r(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        s(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), a;
  }
  getFixedT(e, r, n) {
    var a = this;
    const i = function(s, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), p = 2; p < c; p++)
          u[p - 2] = arguments[p];
        l = a.options.overloadTranslationOptionHandler([s, o].concat(u));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || i.keyPrefix);
      const h = a.options.keySeparator || ".";
      let b;
      return l.keyPrefix && Array.isArray(s) ? b = s.map((S) => `${l.keyPrefix}${h}${S}`) : b = l.keyPrefix ? `${l.keyPrefix}${h}${s}` : s, a.t(b, l);
    };
    return typeof e == "string" ? i.lng = e : i.lngs = e, i.ns = r, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const s = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (r.precheck) {
      const o = r.precheck(this, s);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(n, e) && (!a || s(i, e)));
  }
  loadNamespaces(e, r) {
    const n = Gt();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(e, r) {
    const n = Gt();
    typeof e == "string" && (e = [e]);
    const a = this.options.preload || [], i = e.filter((s) => a.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((s) => {
      n.resolve(), r && r(s);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new Wn(Zn());
    return r.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new ar(e, r);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Er;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new ar(a);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new qn(this.store.data, a), i.services.resourceStore = i.store), i.translator = new $r(i.services, a), i.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      i.emit(o, ...c);
    }), i.init(a, r), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ge = ar.createInstance();
ge.createInstance = ar.createInstance;
ge.createInstance;
ge.dir;
ge.init;
ge.loadResources;
ge.reloadResources;
ge.use;
ge.changeLanguage;
ge.getFixedT;
ge.t;
ge.exists;
ge.setDefaultNamespace;
ge.hasLoadedNamespace;
ge.loadNamespaces;
ge.loadLanguages;
var us = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const ds = /* @__PURE__ */ $i(us);
var fs = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Qn(t) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, r = t.match(/<\/?([^\s]+?)[/\s>]/);
  if (r && (e.name = r[1], (ds[r[1]] || t.charAt(t.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var n = t.indexOf("-->");
    return { type: "comment", comment: n !== -1 ? t.slice(4, n) : "" };
  }
  for (var a = new RegExp(fs), i = null; (i = a.exec(t)) !== null; )
    if (i[0].trim())
      if (i[1]) {
        var s = i[1].trim(), o = [s, ""];
        s.indexOf("=") > -1 && (o = s.split("=")), e.attrs[o[0]] = o[1], a.lastIndex--;
      } else
        i[2] && (e.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return e;
}
var hs = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, ps = /^\s*$/, ms = /* @__PURE__ */ Object.create(null);
function Ta(t, e) {
  switch (e.type) {
    case "text":
      return t + e.content;
    case "tag":
      return t += "<" + e.name + (e.attrs ? function(r) {
        var n = [];
        for (var a in r)
          n.push(a + '="' + r[a] + '"');
        return n.length ? " " + n.join(" ") : "";
      }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(Ta, "") + "</" + e.name + ">";
    case "comment":
      return t + "<!--" + e.comment + "-->";
  }
}
var gs = { parse: function(t, e) {
  e || (e = {}), e.components || (e.components = ms);
  var r, n = [], a = [], i = -1, s = !1;
  if (t.indexOf("<") !== 0) {
    var o = t.indexOf("<");
    n.push({ type: "text", content: o === -1 ? t : t.substring(0, o) });
  }
  return t.replace(hs, function(l, c) {
    if (s) {
      if (l !== "</" + r.name + ">")
        return;
      s = !1;
    }
    var u, p = l.charAt(1) !== "/", h = l.startsWith("<!--"), b = c + l.length, S = t.charAt(b);
    if (h) {
      var j = Qn(l);
      return i < 0 ? (n.push(j), n) : ((u = a[i]).children.push(j), n);
    }
    if (p && (i++, (r = Qn(l)).type === "tag" && e.components[r.name] && (r.type = "component", s = !0), r.voidElement || s || !S || S === "<" || r.children.push({ type: "text", content: t.slice(b, t.indexOf("<", b)) }), i === 0 && n.push(r), (u = a[i - 1]) && u.children.push(r), a[i] = r), (!p || r.voidElement) && (i > -1 && (r.voidElement || r.name === l.slice(2, -1)) && (i--, r = i === -1 ? n : a[i]), !s && S !== "<" && S)) {
      u = i === -1 ? n : a[i].children;
      var E = t.indexOf("<", b), P = t.slice(b, E === -1 ? void 0 : E);
      ps.test(P) && (P = " "), (E > -1 && i + u.length >= 0 || P !== " ") && u.push({ type: "text", content: P });
    }
  }), n;
}, stringify: function(t) {
  return t.reduce(function(e, r) {
    return e + Ta("", r);
  }, "");
} };
function Nr() {
  if (console && console.warn) {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    De(e[0]) && (e[0] = `react-i18next:: ${e[0]}`), console.warn(...e);
  }
}
const ea = {};
function Mr() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  De(e[0]) && ea[e[0]] || (De(e[0]) && (ea[e[0]] = /* @__PURE__ */ new Date()), Nr(...e));
}
const Aa = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const r = () => {
      setTimeout(() => {
        t.off("initialized", r);
      }, 0), e();
    };
    t.on("initialized", r);
  }
}, ta = (t, e, r) => {
  t.loadNamespaces(e, Aa(t, r));
}, ra = (t, e, r, n) => {
  De(r) && (r = [r]), r.forEach((a) => {
    t.options.ns.indexOf(a) < 0 && t.options.ns.push(a);
  }), t.loadLanguages(e, Aa(t, n));
}, ys = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const n = e.languages[0], a = e.options ? e.options.fallbackLng : !1, i = e.languages[e.languages.length - 1];
  if (n.toLowerCase() === "cimode")
    return !0;
  const s = (o, l) => {
    const c = e.services.backendConnector.state[`${o}|${l}`];
    return c === -1 || c === 2;
  };
  return r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !s(e.isLanguageChangingTo, t) ? !1 : !!(e.hasResourceBundle(n, t) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || s(n, t) && (!a || s(i, t)));
}, bs = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !e.languages || !e.languages.length ? (Mr("i18n.languages were undefined or empty", e.languages), !0) : e.options.ignoreJSONStructure !== void 0 ? e.hasLoadedNamespace(t, {
    lng: r.lng,
    precheck: (a, i) => {
      if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && a.services.backendConnector.backend && a.isLanguageChangingTo && !i(a.isLanguageChangingTo, t))
        return !1;
    }
  }) : ys(t, e, r);
}, De = (t) => typeof t == "string", Tt = (t) => typeof t == "object" && t !== null, vs = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, xs = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ws = (t) => xs[t], Es = (t) => t.replace(vs, ws);
let mn = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Es
};
const Ss = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  mn = {
    ...mn,
    ...t
  };
}, _a = () => mn;
let Ia;
const Rs = (t) => {
  Ia = t;
}, Rn = () => Ia, on = (t, e) => {
  if (!t)
    return !1;
  const r = t.props ? t.props.children : t.children;
  return e ? r.length > 0 : !!r;
}, ln = (t) => {
  if (!t)
    return [];
  const e = t.props ? t.props.children : t.children;
  return t.props && t.props.i18nIsDynamicList ? At(e) : e;
}, js = (t) => Array.isArray(t) && t.every(Ar), At = (t) => Array.isArray(t) ? t : [t], Cs = (t, e) => {
  const r = {
    ...e
  };
  return r.props = Object.assign(t.props, e.props), r;
}, Fa = (t, e) => {
  if (!t)
    return "";
  let r = "";
  const n = At(t), a = e.transSupportBasicHtmlNodes && e.transKeepBasicHtmlNodesFor ? e.transKeepBasicHtmlNodesFor : [];
  return n.forEach((i, s) => {
    if (De(i))
      r += `${i}`;
    else if (Ar(i)) {
      const {
        props: o,
        type: l
      } = i, c = Object.keys(o).length, u = a.indexOf(l) > -1, p = o.children;
      if (!p && u && !c)
        r += `<${l}/>`;
      else if (!p && (!u || c) || o.i18nIsDynamicList)
        r += `<${s}></${s}>`;
      else if (u && c === 1 && De(p))
        r += `<${l}>${p}</${l}>`;
      else {
        const h = Fa(p, e);
        r += `<${s}>${h}</${s}>`;
      }
    } else if (i === null)
      Nr("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (Tt(i)) {
      const {
        format: o,
        ...l
      } = i, c = Object.keys(l);
      if (c.length === 1) {
        const u = o ? `${c[0]}, ${o}` : c[0];
        r += `{{${u}}}`;
      } else
        Nr("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", i);
    } else
      Nr("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", i);
  }), r;
}, Ps = (t, e, r, n, a, i) => {
  if (e === "")
    return [];
  const s = n.transKeepBasicHtmlNodesFor || [], o = e && new RegExp(s.map((E) => `<${E}`).join("|")).test(e);
  if (!t && !o && !i)
    return [e];
  const l = {}, c = (E) => {
    At(E).forEach((v) => {
      De(v) || (on(v) ? c(ln(v)) : Tt(v) && !Ar(v) && Object.assign(l, v));
    });
  };
  c(t);
  const u = gs.parse(`<0>${e}</0>`), p = {
    ...l,
    ...a
  }, h = (E, P, v) => {
    const O = ln(E), L = S(O, P.children, v);
    return js(O) && L.length === 0 || E.props && E.props.i18nIsDynamicList ? O : L;
  }, b = (E, P, v, O, L) => {
    E.dummy ? (E.children = P, v.push(Di(E, {
      key: O
    }, L ? void 0 : P))) : v.push(...Ti.map([E], (D) => {
      const g = {
        ...D.props
      };
      return delete g.i18nIsDynamicList, at(D.type, {
        ...g,
        key: O,
        ref: D.ref
      }, L ? null : P);
    }));
  }, S = (E, P, v) => {
    const O = At(E);
    return At(P).reduce((D, g, T) => {
      const F = g.children && g.children[0] && g.children[0].content && r.services.interpolator.interpolate(g.children[0].content, p, r.language);
      if (g.type === "tag") {
        let I = O[parseInt(g.name, 10)];
        v.length === 1 && !I && (I = v[0][g.name]), I || (I = {});
        const U = Object.keys(g.attrs).length !== 0 ? Cs({
          props: g.attrs
        }, I) : I, W = Ar(U), G = W && on(g, !0) && !g.voidElement, q = o && Tt(U) && U.dummy && !W, J = Tt(t) && Object.hasOwnProperty.call(t, g.name);
        if (De(U)) {
          const Z = r.services.interpolator.interpolate(U, p, r.language);
          D.push(Z);
        } else if (on(U) || G) {
          const Z = h(U, g, v);
          b(U, Z, D, T);
        } else if (q) {
          const Z = S(O, g.children, v);
          b(U, Z, D, T);
        } else if (Number.isNaN(parseFloat(g.name)))
          if (J) {
            const Z = h(U, g, v);
            b(U, Z, D, T, g.voidElement);
          } else if (n.transSupportBasicHtmlNodes && s.indexOf(g.name) > -1)
            if (g.voidElement)
              D.push(at(g.name, {
                key: `${g.name}-${T}`
              }));
            else {
              const Z = S(O, g.children, v);
              D.push(at(g.name, {
                key: `${g.name}-${T}`
              }, Z));
            }
          else if (g.voidElement)
            D.push(`<${g.name} />`);
          else {
            const Z = S(O, g.children, v);
            D.push(`<${g.name}>${Z}</${g.name}>`);
          }
        else if (Tt(U) && !W) {
          const Z = g.children[0] ? F : null;
          Z && D.push(Z);
        } else
          b(U, F, D, T, g.children.length !== 1 || !F);
      } else if (g.type === "text") {
        const I = n.transWrapTextNodes, U = i ? n.unescape(r.services.interpolator.interpolate(g.content, p, r.language)) : r.services.interpolator.interpolate(g.content, p, r.language);
        I ? D.push(at(I, {
          key: `${g.name}-${T}`
        }, U)) : D.push(U);
      }
      return D;
    }, []);
  }, j = S([{
    dummy: !0,
    children: t || []
  }], u, At(t || []));
  return ln(j[0]);
};
function Ns(t) {
  let {
    children: e,
    count: r,
    parent: n,
    i18nKey: a,
    context: i,
    tOptions: s = {},
    values: o,
    defaults: l,
    components: c,
    ns: u,
    i18n: p,
    t: h,
    shouldUnescape: b,
    ...S
  } = t;
  const j = p || Rn();
  if (!j)
    return Mr("You will need to pass in an i18next instance by using i18nextReactModule"), e;
  const E = h || j.t.bind(j) || ((G) => G), P = {
    ..._a(),
    ...j.options && j.options.react
  };
  let v = u || E.ns || j.options && j.options.defaultNS;
  v = De(v) ? [v] : v || ["translation"];
  const O = Fa(e, P), L = l || O || P.transEmptyNodeValue || a, {
    hashTransKey: D
  } = P, g = a || (D ? D(O || L) : O || L);
  j.options && j.options.interpolation && j.options.interpolation.defaultVariables && (o = o && Object.keys(o).length > 0 ? {
    ...o,
    ...j.options.interpolation.defaultVariables
  } : {
    ...j.options.interpolation.defaultVariables
  });
  const T = o || r !== void 0 || !e ? s.interpolation : {
    interpolation: {
      ...s.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, F = {
    ...s,
    context: i || s.context,
    count: r,
    ...o,
    ...T,
    defaultValue: L,
    ns: v
  }, I = g ? E(g, F) : L;
  c && Object.keys(c).forEach((G) => {
    const q = c[G];
    if (typeof q.type == "function" || !q.props || !q.props.children || I.indexOf(`${G}/>`) < 0 && I.indexOf(`${G} />`) < 0)
      return;
    function J() {
      return at(Oi, null, q);
    }
    c[G] = at(J);
  });
  const U = Ps(c || e, I, j, P, F, b), W = n !== void 0 ? n : P.defaultTransParent;
  return W ? at(W, S, U) : U;
}
const Ls = {
  type: "3rdParty",
  init(t) {
    Ss(t.options.react), Rs(t);
  }
}, $a = Hr();
class ks {
  constructor() {
    Mn(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((r) => {
      this.usedNamespaces[r] || (this.usedNamespaces[r] = !0);
    });
  }
}
function gn(t) {
  let {
    children: e,
    count: r,
    parent: n,
    i18nKey: a,
    context: i,
    tOptions: s = {},
    values: o,
    defaults: l,
    components: c,
    ns: u,
    i18n: p,
    t: h,
    shouldUnescape: b,
    ...S
  } = t;
  const {
    i18n: j,
    defaultNS: E
  } = or($a) || {}, P = p || j || Rn(), v = h || P && P.t.bind(P);
  return Ns({
    children: e,
    count: r,
    parent: n,
    i18nKey: a,
    context: i,
    tOptions: s,
    values: o,
    defaults: l,
    components: c,
    ns: u || v && v.ns || E || P && P.options && P.options.defaultNS,
    i18n: P,
    t: h,
    shouldUnescape: b,
    ...S
  });
}
const Os = (t, e) => {
  const r = ve();
  return Te(() => {
    r.current = e ? r.current : t;
  }, [t, e]), r.current;
}, Ma = (t, e, r, n) => t.getFixedT(e, r, n), Ds = (t, e, r, n) => En(Ma(t, e, r, n), [t, e, r, n]), le = function(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: r
  } = e, {
    i18n: n,
    defaultNS: a
  } = or($a) || {}, i = r || n || Rn();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new ks()), !i) {
    Mr("You will need to pass in an i18next instance by using initReactI18next");
    const L = (g, T) => De(T) ? T : Tt(T) && De(T.defaultValue) ? T.defaultValue : Array.isArray(g) ? g[g.length - 1] : g, D = [L, {}, !1];
    return D.t = L, D.i18n = {}, D.ready = !1, D;
  }
  i.options.react && i.options.react.wait !== void 0 && Mr("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const s = {
    ..._a(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: o,
    keyPrefix: l
  } = s;
  let c = t || a || i.options && i.options.defaultNS;
  c = De(c) ? [c] : c || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(c);
  const u = (i.isInitialized || i.initializedStoreOnce) && c.every((L) => bs(L, i, s)), p = Ds(i, e.lng || null, s.nsMode === "fallback" ? c : c[0], l), h = () => p, b = () => Ma(i, e.lng || null, s.nsMode === "fallback" ? c : c[0], l), [S, j] = je(h);
  let E = c.join();
  e.lng && (E = `${e.lng}${E}`);
  const P = Os(E), v = ve(!0);
  Te(() => {
    const {
      bindI18n: L,
      bindI18nStore: D
    } = s;
    v.current = !0, !u && !o && (e.lng ? ra(i, e.lng, c, () => {
      v.current && j(b);
    }) : ta(i, c, () => {
      v.current && j(b);
    })), u && P && P !== E && v.current && j(b);
    const g = () => {
      v.current && j(b);
    };
    return L && i && i.on(L, g), D && i && i.store.on(D, g), () => {
      v.current = !1, L && i && L.split(" ").forEach((T) => i.off(T, g)), D && i && D.split(" ").forEach((T) => i.store.off(T, g));
    };
  }, [i, E]), Te(() => {
    v.current && u && j(h);
  }, [i, l, u]);
  const O = [S, i, u];
  if (O.t = S, O.i18n = i, O.ready = u, u || !u && !o)
    return O;
  throw new Promise((L) => {
    e.lng ? ra(i, e.lng, c, () => L()) : ta(i, c, () => L());
  });
}, Ts = {
  application: {
    generic: "Application",
    referralEnabled: "Deine Bewerbung",
    hiddenPosition: "Dein Kontakt Mit Reply"
  }
}, As = {
  meta: {
    description: "Karriere bei Reply - Job Search",
    keywords: "",
    title: "Karriere bei Reply - Job Search"
  },
  placeholder: "Finde deinen Job...",
  filters: {
    open: "Filter öffnen",
    close: "Filter schließen",
    clearAll: "Alle Filter löschen",
    all: {
      city: "Alle Standorte",
      company: "Alle Reply Companies",
      role: "Alle Erfahrungslevel",
      area: "Alle Bereiche",
      interest: "Alle Innovationsthemen"
    }
  },
  results: {
    opportunities: "Stellenanzeige",
    locations: "Stadt",
    companies: "Reply company",
    noResults: "Es konnten leider keine Stellenanzeigen gefunden werden, die mit deiner Suchanfrage übereinstimmen."
  }
}, _s = {
  apply: "Jetzt bewerben",
  back: "Zurück"
}, Is = {
  step: "Bewerbung Schritt #{{count}}",
  apply1: "Bewirb dich jetzt",
  apply2: "Jetzt bewerben",
  modify: "Bearbeiten",
  info: {
    generic: "Vielen Dank für dein Interesse an unserer Stellenanzeige!<br/>Wir freuen uns auf deine Bewerbung inklusive Lebenslauf und relevanter Dokumente<br/>(Zeugnisse, Zertifikate etc.).<br/>Nachdem deine Bewerbung bei uns eingegangen ist, erhältst du eine automatische Bestätigung per Mail, in der ggf. auf fehlende Dokumente hingewiesen wird.<br/>Wir bemühen uns dir innerhalb von 1-2 Wochen Feedback zu deiner Bewerbung zu geben.<br/>Ist es ein Match, laden wir dich gerne zu einem ersten Kennenlernen ein.<br/>Im weiteren Prozess sind Gespräche mit dem Fachbereich und dem verantwortlichen Recruiter vorgesehen, um dir einen umfassenden Einblick in deinen Aufgabenbereich, die Technologien und unser Unternehmen zu geben.",
    referralEnabled: "Wir freuen uns, dass du Teil unseres Reply Netzwerkes werden möchtest.<br/><br/>Bitte sende uns deine Bewerbung zusammen mit deinem Lebenslauf sowie den relevanten Unterlagen (Zeugnisse, Zertifikate etc.). Du erhältst eine automatische Bestätigung per E-Mail, die dich gegebenenfalls auf fehlende Dokumente hinweist.<br/><br/>Wir bemühen uns, dir innerhalb von 1-2 Wochen Rückmeldung zu geben.<br/>Sind wir ein Match, laden wir dich gerne zu einem ersten Gespräch ein.<br/>Anschließend folgen weitere Gespräche mit dem Fachbereich sowie einem Reply Recruiter, um dir einen detaillierten Einblick in deinen Aufgabenbereich, die verwendeten Technologien und unser Unternehmen zu geben.",
    hiddenPosition: "Wir freuen uns sehr, dass du Interesse an weiterführenden Gesprächen mit dem Reply-Netzwerk hast.<br/><br/>Bitte lade deine Bewerbungsunterlagen, einschließlich deines Lebenslaufs und gegebenenfalls weiterer relevanter Dokumente (z. B. Zeugnisse, Zertifikate), über dieses Formular hoch. Du erhältst umgehend eine automatische Bestätigung per E-Mail.<br/><br/>Anschließend starten wir die interne „Reply Navigation“: Wir versuchen, dich mit den passenden Unternehmen innerhalb des Reply-Netzwerks zu verbinden, die deinen Fähigkeiten und Karrierezielen am besten entsprechen.<br/><br/>Wenn dein Profil auf Interesse stößt, begleiten wir dich durch den Interviewprozess und vernetzen dich mit unseren Kolleg*innen, die dir detaillierte Einblicke in mögliche Aufgabenbereiche, verwendete Technologien und unser Unternehmen geben können. Unser Ziel ist es, den Bewerbungsprozess so effizient und transparent wie möglich zu gestalten, damit du schnell eine Rückmeldung erhältst und weitere Schritte einleiten kannst.<br/><br/>Im Notizfeld kannst du gerne Informationen zum Gespräch mit der Recruiting-Abteilung hinzufügen sowie weiterführende Informationen darüber, welche Themengebiete und welche Rolle für dich interessant sein könnten oder welchen Standort du bevorzugst.<br/><br/>Dein Reply-Recruiting-Team"
  },
  requiredInfo: "Mit * markierte Felder bitte vollständig ausfüllen.",
  firstName: "Vorname{{required, required}}",
  lastName: "Nachname{{required, required}}",
  email: "E-Mail{{required, required}}",
  telephone: "Telefon{{required, required}} (z.B. +49 xxx xxxxxxx)",
  linkedin: "LinkedIn Profil{{required, required}}",
  xing: "Xing Profil{{required, required}}",
  cv: "Lebenslauf{{required, required}}",
  otherDoc: "Sonstige Dokumente{{required, required}}",
  replyReferent: "Empfohlen von (Name | Reply Company){{required, required}}",
  candidatePreferences: "Dein bevorzugter Standort, Technologien und/oder gewünschte Position{{required, required}}",
  privacy: {
    title: "Datenschutz{{required, required}}",
    info: {
      generic: "Hiermit erkläre ich, dass ich die <1>Datenschutzerklärung</1> und die Hinweise zur globalen <3>Datenschutz & Cookie Policy</3> gelesen und verstanden habe."
    },
    consent: "Ich stimme zu"
  },
  textError: "Es ist ein Fehler aufgetreten",
  file: {
    error: {
      size: "Datei zu groß",
      generic: "Beim Laden des Anhangs ist ein Fehler aufgetreten. Bitte erneut versuchen.",
      format: "Dateiformat wird nicht unterstützt"
    }
  },
  alreadyAppliedFeedback: "Wir haben kürzlich deine Bewerbung erhalten. Diese wird von uns auf alle offenen Positionen geprüft, bevor wir uns mit Feedback zurückmelden. Solltest du zu deinem Bewerbungsstatus Rückfragen haben, melde dich gerne unter",
  end: {
    info: "Schau in deinen Mails nach der<br />Eingangsbestätigung mit den nächsten Schritten.<br />Uns ist die Auswahl geeigneter Mitarbeiter sehr wichtig.<br />Darum nehmen wir uns Zeit für dich, indem wir deine Bewerbung sorgfältig prüfen und uns so schnell wie möglich bei dir melden."
  }
}, Fs = {
  back: "Zurück"
}, $s = {
  header: Ts,
  jobSearch: As,
  jobDetails: _s,
  jobApplication: Is,
  generic: Fs
}, Ms = {
  application: {
    generic: "Application",
    referralEnabled: "Application",
    hiddenPosition: "Your Contact With Reply"
  },
  thankyou: "Thank you"
}, Us = {
  meta: {
    description: "Jobs for IT experts and IT, job market for specialists and executives in the IT, digital. Jobs Security, Cloud, Quantum Computing, SAP, IoT, Industry 4.0",
    keywords: "IT Jobs, IT Job, Developer Job, Developer Job, Consultant Jobs, Consultant Jobs, Machine Learning Jobs, DEVOPS Developer, Java Developer, Java Developer, Java Developer, Software Developer Full Stack, Software Developer Java, CLOUD SITE RELIABILITY ENGINEER, Solution Architect Java, Cloud Architect, Cloud Architect, Frontend Developer, Cyber Security Job, AI Jobs, jobs, graduate, entry-level positions, AI Jobs, DATA ENGINEER Jobs, Data Science, IoT, Consultant SAP IBP, Consultant SAP S/4HANA, Mul",
    title: "Reply Jobs, job market for specialists and executives, university graduates in IT"
  },
  placeholder: "Search your job...",
  filters: {
    open: "Open filters",
    close: "Close filters",
    clearAll: "Clear all filters",
    ariaLabel: "Search filters",
    all: {
      city: "All Locations",
      company: "All Reply Companies",
      role: "All Seniority Levels",
      area: "All Areas",
      interest: "All Interests"
    },
    select: {
      country: "Select country",
      city: "Select location",
      company: "Select Reply company",
      role: "Select seniority level",
      area: "Select area",
      interest: "Select interest"
    },
    role: {
      student: "Student",
      career_starter: "Career Starter",
      professional: "Professional"
    }
  },
  results: {
    opportunities: "Career opportunities",
    locations: "City",
    companies: "Reply company",
    noResults: "Unfortunately, no career opportunities could be found that match your search query."
  }
}, Vs = {
  apply: "Apply now",
  back: "Return to search"
}, zs = {
  step: "Application Step #{{count}}",
  apply1: "Apply now",
  apply2: "Apply now",
  modify: "Edit",
  info: {
    generic: "Thank you for your interest in our job opportunity!<br/>We look forward to receiving your application including your resume and relevant documents (references, certificates, optionally a cover letter). Upon receipt of your resume, if it is a match, we look forward to meeting you in a first interview. In the interview you will learn more about the opportunity and business area to provide you a comprehensive insight into your area of responsibility, the technologies and our company.",
    referralEnabled: "We are happy that you would like to become part of our Reply network.<br/><br/>We look forward to receiving your application including your resume and relevant documents (references, certificates, optionally a cover letter). Upon receipt of your resume, if it is a match, we look forward to meeting you in a first interview. In the interview you will learn more about the opportunity and business area to provide you a comprehensive insight into your area of responsibility, the technologies and our company.",
    hiddenPosition: 'We are very pleased that you are interested in further conversations with the Reply network.<br/><br/>Please upload your application documents, including your resume and any other relevant documents (e.g. certificates, references), via this form. You will immediately receive an automatic confirmation by email.<br/><br/>We will then begin the internal "Reply Navigation" process: we will try to connect you with the Reply Companies that best match your skills and career goals.<br/><br/>If your profile attracts interest, we will guide you through the interview process and connect you with our colleagues who can provide you with detailed insights into possible areas of responsibility, technologies used and our company.<br/><br/>Our goal is to make the application process as efficient and transparent as possible, so that you can quickly receive feedback and take the next steps.<br/><br/>In the notes section, feel free to add information about your conversation with our recruiters, as well as further details about which areas of interest or roles you may be looking for, or which location you prefer.<br/><br/>Your Reply Recruiting Team'
  },
  requiredInfo: "Please complete all fields marked with *.",
  firstName: "First Name{{required, required}}",
  lastName: "Surname{{required, required}}",
  email: "E-Mail{{required, required}}",
  telephone: "Telephone{{required, required}} (i.e. +1 xxx xxxxxxx)",
  linkedin: "LinkedIn profile{{required, required}}",
  cv: "Resume{{required, required}}",
  otherDoc: "Other document{{required, required}}",
  replyReferent: "Referred by{{required, required}}",
  candidatePreferences: "Your preferred location, technologies and/or desired position{{required, required}}",
  privacy: {
    title: "Privacy{{required, required}}",
    info: {
      generic: "I hereby declare that I have read and understood the <1>Privacy Policy</1> and the <3>Global Privacy and Cookie Policy</3>.",
      pl: "I hereby declare that I have read and understood the <1>Privacy Policy for Poland</1> and the <3>Global Privacy and Cookie Policy</3>."
    },
    consent: "I consent"
  },
  DIStatement: {
    title: "Diversity and Inclusion Statement{{required, required}}",
    info: "Reply Group and our network of companies is an Equal Opportunity Employer. We celebrate our diversity and promote an inclusive culture. Please accept our Diversity and Inclusion Statement."
  },
  textError: "Something’s not right",
  file: {
    error: {
      size: "File too large",
      generic: "Something went wrong with the attachment loading. Try again.",
      format: "Unsupported file format"
    }
  },
  alreadyAppliedFeedback: "We have recently received your application. We will review it for all open positions before contacting you with feedback. If you have any questions about the status of your application, please contact us at",
  end: {
    info: "Thank you very much for your application!<br />Please check in your e-mail box whether you have received the confirmation of receipt with the next steps. If you have not received a confirmation, please contact {{email}}. We will carefully review your application and get back to you as soon as possible. We appreciate your patience with our process as we receive an increased number of applications."
  }
}, Bs = {
  apply: "Apply",
  back: "Back",
  careers: "Reply Careers"
}, Ks = {
  header: Ms,
  jobSearch: Us,
  jobDetails: Vs,
  jobApplication: zs,
  generic: Bs
}, Hs = {
  meta: {
    description: "Reply Careers - Job Search",
    keywords: "",
    title: "Reply Careers - Job Search"
  },
  placeholder: "Recherche...",
  filters: {
    all: {
      city: "Tous nos sites",
      company: "Toutes les sociétés Reply",
      role: "Experience",
      area: "Domaine",
      interest: "Spécialisation"
    },
    role: {
      career_starter: "Début de carrière",
      professional: "Professionel"
    }
  },
  results: {
    opportunities: "Offre d'emplois",
    locations: "Ville",
    companies: "Société Reply",
    noResults: "Malheureusement, aucune offre d'emploi correspondant à votre recherche n'a pu être trouvée."
  }
}, qs = {
  jobSearch: Hs
}, Js = {
  meta: {
    description: "Posizioni per professionals, studenti e neolaureati. Cybersecurity, Machine Learning, IoT, Automotive, Cloud, Quantum Computing, SAP, Industry 4.0",
    keywords: "IT Jobs, IT Job, Developer Job, Developer Job, Consultant Jobs, Consultant Jobs, Machine Learning Jobs, DEVOPS Developer, Java Developer, Java Developer, Java Developer, Software Developer Full Stack, Software Developer Java, CLOUD SITE RELIABILITY ENGINEER, Solution Architect Java, Cloud Architect, Cloud Architect, Frontend Developer, Cyber Security Job, AI Jobs, jobs, graduate, entry-level positions, AI Jobs, DATA ENGINEER Jobs, Data Science, IoT, Consultant SAP IBP, Consultant SAP S/4HANA, Mul",
    title: "Opportunità in Reply per professionals, studenti e neolaureati"
  },
  placeholder: "Ricerca la tua opportunità...",
  filters: {
    all: {
      city: "Tutte le località",
      company: "Tutte le aziende Reply",
      role: "Tutti i livelli di esperienza",
      area: "Tutte le aree",
      interest: "Tutti i temi di interesse"
    },
    select: {
      country: "Seleziona il Paese",
      city: "Seleziona la località",
      company: "Seleziona l'azienda Reply",
      role: "Seleziona il livello di esperienza",
      area: "Seleziona l'area",
      interest: "Seleziona il tema d'interesse"
    },
    role: {
      student: "Studente",
      career_starter: "Neolaureato",
      professional: "Esperto"
    }
  },
  results: {
    opportunities: "Posizione aperta",
    locations: "Località",
    companies: "Azienda",
    noResults: "Non ci sono posizioni aperte corrispondenti ai criteri di ricerca immessi."
  }
}, Ws = {
  jobSearch: Js
}, Ys = {
  meta: {
    description: "Oportunidades para pessoas especialistas e executivas no mercado de TI, digital. Oportunidades para área de Segurança, Cloud, SAP, IOT, Testes, Desenvolvimento e Industria 4.0",
    keywords: "Pessoa Desenvolvedora Java, Pessoa Desenvolvedora Fullstack, Pessoa de Engenharia em Confiabilidade Cloud, Pessoa de Arquitetura Java, Pessoa Arquiteta Java, Pessoa Arquiteta Cloud, Pessoa Desenvolvedora Frontend, Cyber Security, Pessoa de Inteligência Artificial, Oportunidades, Pessoas recém-formadas, pessoas iniciantes, Pessoa de Inteligencia Artificial, Data Engineer, Data Scince, IOT, Pessoa Consultora em SAP IBP, Pessoa Consutlora SAPS/4Hana, Pessoa Consultora Mulesoft, Pessoa Desenvolvedora",
    title: "Oportunidades na Reply para Especialistas e executivos, estudantes, graduados em TI"
  },
  placeholder: "Encontre seu emprego...",
  filters: {
    open: "Filtros abertos",
    close: "Fechar filtros",
    clearAll: "Limpar filtros",
    all: {
      city: "Todas as localidades",
      company: "Todas as empresas da Reply",
      role: "Senioridade",
      area: "Áreas",
      interest: "Interesses"
    },
    role: {
      student: "Estudante",
      career_starter: "Recém-formado",
      professional: "Profissional"
    }
  },
  results: {
    opportunities: "Oportunidades em aberto",
    locations: "Citade",
    companies: "Empresa da Reply",
    noResults: "Desculpe, mas não encontramos uma oportunidade de acordo com a sua busca."
  }
}, Gs = {
  apply: "Inscreva agora",
  back: "Retornar"
}, Zs = {
  step: "Passo #{{count}} Sua Inscrição",
  apply1: "Inscreva-se",
  apply2: "Inscreva-se",
  modify: "Editar",
  info: {
    generic: "Para inscrição, preencha o formulário e faça o upload dos seus documentos (CV, carta de apresentação, certificados). Após o recebimento da sua solicitação, você receberá uma confirmação por e-mail, na qual serão apontados quaisquer documentos ausentes.<br/>Dentro de uma a duas semanas, você receberá um feedback pessoal e os candidatos promissores serão convidados para uma primeira triagem. Poucos dias depois, haverá uma ou mais entrevistas adicionais com os respectivos departamentos, nas quais detalhes como área de responsabilidade e detalhes do contrato serão esclarecidos.",
    referralEnabled: "Para inscrição, preencha o formulário e faça o upload dos seus documentos (CV, carta de apresentação, certificados). Após o recebimento da sua solicitação, você receberá uma confirmação por e-mail, na qual serão apontados quaisquer documentos ausentes.<br/>Dentro de uma a duas semanas, você receberá um feedback pessoal e os candidatos promissores serão convidados para uma primeira triagem. Poucos dias depois, haverá uma ou mais entrevistas adicionais com os respectivos departamentos, nas quais detalhes como área de responsabilidade e detalhes do contrato serão esclarecidos."
  },
  requiredInfo: "Por favor, preencha todos os campos marcados com *.",
  firstName: "Primeiro Nome{{required, required}}",
  lastName: "Último Nome{{required, required}}",
  email: "E-Mail{{required, required}}",
  telephone: "Celular{{required, required}} (+55 xx xxxxxxxxx)",
  linkedin: "LinkedIn Perfil{{required, required}}",
  cv: "CV{{required, required}}",
  otherDoc: "Outro documento{{required, required}}",
  privacy: {
    title: "Privacidade{{required, required}}",
    info: {
      generic: "Declaro que li e entendi a <1>Aviso de Privacidade</1> e a <3>Política de Privacidade e Cookies Global</3>."
    },
    consent: "Eu autorizo"
  },
  textError: "Algo não está certo",
  file: {
    error: {
      size: "Ficheiro demasiado grande",
      generic: "Algo correu mal com o carregamento do anexo. Tente novamente.",
      format: "Ficheiro não suportado"
    }
  },
  end: {
    info: "Verifique sua caixa de entrada com nosso e-mail de confirmação das próximas etapas<br />A seleção de Colaboradores adequados é muito importante para nós.<br />É por isso que reservamos um tempo para você, verificando cuidadosamente sua disponibilidade e entrando em contato com você o mais rápido possível."
  }
}, Xs = {
  back: "Retornar"
}, Qs = {
  jobSearch: Ys,
  jobDetails: Gs,
  jobApplication: Zs,
  generic: Xs
};
ge.use(Ls).init({
  resources: { de: $s, en: Ks, fr: qs, it: Ws, pt: Qs },
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  }
});
var Na;
(Na = ge.services.formatter) == null || Na.add("required", (t) => t ? "*" : "");
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function re() {
  return re = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, re.apply(this, arguments);
}
var oe;
(function(t) {
  t.Pop = "POP", t.Push = "PUSH", t.Replace = "REPLACE";
})(oe || (oe = {}));
const na = "popstate";
function eo(t) {
  t === void 0 && (t = {});
  function e(n, a) {
    let {
      pathname: i,
      search: s,
      hash: o
    } = n.location;
    return ir(
      "",
      {
        pathname: i,
        search: s,
        hash: o
      },
      // state defaults to `null` because `window.history.state` does
      a.state && a.state.usr || null,
      a.state && a.state.key || "default"
    );
  }
  function r(n, a) {
    return typeof a == "string" ? a : st(a);
  }
  return ro(e, r, null, t);
}
function z(t, e) {
  if (t === !1 || t === null || typeof t > "u")
    throw new Error(e);
}
function he(t, e) {
  if (!t) {
    typeof console < "u" && console.warn(e);
    try {
      throw new Error(e);
    } catch {
    }
  }
}
function to() {
  return Math.random().toString(36).substr(2, 8);
}
function aa(t, e) {
  return {
    usr: t.state,
    key: t.key,
    idx: e
  };
}
function ir(t, e, r, n) {
  return r === void 0 && (r = null), re({
    pathname: typeof t == "string" ? t : t.pathname,
    search: "",
    hash: ""
  }, typeof e == "string" ? Qe(e) : e, {
    state: r,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: e && e.key || n || to()
  });
}
function st(t) {
  let {
    pathname: e = "/",
    search: r = "",
    hash: n = ""
  } = t;
  return r && r !== "?" && (e += r.charAt(0) === "?" ? r : "?" + r), n && n !== "#" && (e += n.charAt(0) === "#" ? n : "#" + n), e;
}
function Qe(t) {
  let e = {};
  if (t) {
    let r = t.indexOf("#");
    r >= 0 && (e.hash = t.substr(r), t = t.substr(0, r));
    let n = t.indexOf("?");
    n >= 0 && (e.search = t.substr(n), t = t.substr(0, n)), t && (e.pathname = t);
  }
  return e;
}
function ro(t, e, r, n) {
  n === void 0 && (n = {});
  let {
    window: a = document.defaultView,
    v5Compat: i = !1
  } = n, s = a.history, o = oe.Pop, l = null, c = u();
  c == null && (c = 0, s.replaceState(re({}, s.state, {
    idx: c
  }), ""));
  function u() {
    return (s.state || {
      idx: null
    }).idx;
  }
  function p() {
    o = oe.Pop;
    let E = u(), P = E == null ? null : E - c;
    c = E, l && l({
      action: o,
      location: j.location,
      delta: P
    });
  }
  function h(E, P) {
    o = oe.Push;
    let v = ir(j.location, E, P);
    r && r(v, E), c = u() + 1;
    let O = aa(v, c), L = j.createHref(v);
    try {
      s.pushState(O, "", L);
    } catch (D) {
      if (D instanceof DOMException && D.name === "DataCloneError")
        throw D;
      a.location.assign(L);
    }
    i && l && l({
      action: o,
      location: j.location,
      delta: 1
    });
  }
  function b(E, P) {
    o = oe.Replace;
    let v = ir(j.location, E, P);
    r && r(v, E), c = u();
    let O = aa(v, c), L = j.createHref(v);
    s.replaceState(O, "", L), i && l && l({
      action: o,
      location: j.location,
      delta: 0
    });
  }
  function S(E) {
    let P = a.location.origin !== "null" ? a.location.origin : a.location.href, v = typeof E == "string" ? E : st(E);
    return v = v.replace(/ $/, "%20"), z(P, "No window.location.(origin|href) available to create URL for href: " + v), new URL(v, P);
  }
  let j = {
    get action() {
      return o;
    },
    get location() {
      return t(a, s);
    },
    listen(E) {
      if (l)
        throw new Error("A history only accepts one active listener");
      return a.addEventListener(na, p), l = E, () => {
        a.removeEventListener(na, p), l = null;
      };
    },
    createHref(E) {
      return e(a, E);
    },
    createURL: S,
    encodeLocation(E) {
      let P = S(E);
      return {
        pathname: P.pathname,
        search: P.search,
        hash: P.hash
      };
    },
    push: h,
    replace: b,
    go(E) {
      return s.go(E);
    }
  };
  return j;
}
var ee;
(function(t) {
  t.data = "data", t.deferred = "deferred", t.redirect = "redirect", t.error = "error";
})(ee || (ee = {}));
const no = /* @__PURE__ */ new Set(["lazy", "caseSensitive", "path", "id", "index", "children"]);
function ao(t) {
  return t.index === !0;
}
function Ur(t, e, r, n) {
  return r === void 0 && (r = []), n === void 0 && (n = {}), t.map((a, i) => {
    let s = [...r, String(i)], o = typeof a.id == "string" ? a.id : s.join("-");
    if (z(a.index !== !0 || !a.children, "Cannot specify children on an index route"), z(!n[o], 'Found a route id collision on id "' + o + `".  Route id's must be globally unique within Data Router usages`), ao(a)) {
      let l = re({}, a, e(a), {
        id: o
      });
      return n[o] = l, l;
    } else {
      let l = re({}, a, e(a), {
        id: o,
        children: void 0
      });
      return n[o] = l, a.children && (l.children = Ur(a.children, e, s, n)), l;
    }
  });
}
function ft(t, e, r) {
  return r === void 0 && (r = "/"), Lr(t, e, r, !1);
}
function Lr(t, e, r, n) {
  let a = typeof e == "string" ? Qe(e) : e, i = ze(a.pathname || "/", r);
  if (i == null)
    return null;
  let s = Ua(t);
  so(s);
  let o = null;
  for (let l = 0; o == null && l < s.length; ++l) {
    let c = bo(i);
    o = go(s[l], c, n);
  }
  return o;
}
function io(t, e) {
  let {
    route: r,
    pathname: n,
    params: a
  } = t;
  return {
    id: r.id,
    pathname: n,
    params: a,
    data: e[r.id],
    handle: r.handle
  };
}
function Ua(t, e, r, n) {
  e === void 0 && (e = []), r === void 0 && (r = []), n === void 0 && (n = "");
  let a = (i, s, o) => {
    let l = {
      relativePath: o === void 0 ? i.path || "" : o,
      caseSensitive: i.caseSensitive === !0,
      childrenIndex: s,
      route: i
    };
    l.relativePath.startsWith("/") && (z(l.relativePath.startsWith(n), 'Absolute route path "' + l.relativePath + '" nested under path ' + ('"' + n + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), l.relativePath = l.relativePath.slice(n.length));
    let c = Je([n, l.relativePath]), u = r.concat(l);
    i.children && i.children.length > 0 && (z(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      i.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + c + '".')
    ), Ua(i.children, e, u, c)), !(i.path == null && !i.index) && e.push({
      path: c,
      score: po(c, i.index),
      routesMeta: u
    });
  };
  return t.forEach((i, s) => {
    var o;
    if (i.path === "" || !((o = i.path) != null && o.includes("?")))
      a(i, s);
    else
      for (let l of Va(i.path))
        a(i, s, l);
  }), e;
}
function Va(t) {
  let e = t.split("/");
  if (e.length === 0)
    return [];
  let [r, ...n] = e, a = r.endsWith("?"), i = r.replace(/\?$/, "");
  if (n.length === 0)
    return a ? [i, ""] : [i];
  let s = Va(n.join("/")), o = [];
  return o.push(...s.map((l) => l === "" ? i : [i, l].join("/"))), a && o.push(...s), o.map((l) => t.startsWith("/") && l === "" ? "/" : l);
}
function so(t) {
  t.sort((e, r) => e.score !== r.score ? r.score - e.score : mo(e.routesMeta.map((n) => n.childrenIndex), r.routesMeta.map((n) => n.childrenIndex)));
}
const oo = /^:[\w-]+$/, lo = 3, co = 2, uo = 1, fo = 10, ho = -2, ia = (t) => t === "*";
function po(t, e) {
  let r = t.split("/"), n = r.length;
  return r.some(ia) && (n += ho), e && (n += co), r.filter((a) => !ia(a)).reduce((a, i) => a + (oo.test(i) ? lo : i === "" ? uo : fo), n);
}
function mo(t, e) {
  return t.length === e.length && t.slice(0, -1).every((n, a) => n === e[a]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    t[t.length - 1] - e[e.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function go(t, e, r) {
  r === void 0 && (r = !1);
  let {
    routesMeta: n
  } = t, a = {}, i = "/", s = [];
  for (let o = 0; o < n.length; ++o) {
    let l = n[o], c = o === n.length - 1, u = i === "/" ? e : e.slice(i.length) || "/", p = Vr({
      path: l.relativePath,
      caseSensitive: l.caseSensitive,
      end: c
    }, u), h = l.route;
    if (!p && c && r && !n[n.length - 1].route.index && (p = Vr({
      path: l.relativePath,
      caseSensitive: l.caseSensitive,
      end: !1
    }, u)), !p)
      return null;
    Object.assign(a, p.params), s.push({
      // TODO: Can this as be avoided?
      params: a,
      pathname: Je([i, p.pathname]),
      pathnameBase: wo(Je([i, p.pathnameBase])),
      route: h
    }), p.pathnameBase !== "/" && (i = Je([i, p.pathnameBase]));
  }
  return s;
}
function Vr(t, e) {
  typeof t == "string" && (t = {
    path: t,
    caseSensitive: !1,
    end: !0
  });
  let [r, n] = yo(t.path, t.caseSensitive, t.end), a = e.match(r);
  if (!a)
    return null;
  let i = a[0], s = i.replace(/(.)\/+$/, "$1"), o = a.slice(1);
  return {
    params: n.reduce((c, u, p) => {
      let {
        paramName: h,
        isOptional: b
      } = u;
      if (h === "*") {
        let j = o[p] || "";
        s = i.slice(0, i.length - j.length).replace(/(.)\/+$/, "$1");
      }
      const S = o[p];
      return b && !S ? c[h] = void 0 : c[h] = (S || "").replace(/%2F/g, "/"), c;
    }, {}),
    pathname: i,
    pathnameBase: s,
    pattern: t
  };
}
function yo(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !0), he(t === "*" || !t.endsWith("*") || t.endsWith("/*"), 'Route path "' + t + '" will be treated as if it were ' + ('"' + t.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + t.replace(/\*$/, "/*") + '".'));
  let n = [], a = "^" + t.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (s, o, l) => (n.push({
    paramName: o,
    isOptional: l != null
  }), l ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return t.endsWith("*") ? (n.push({
    paramName: "*"
  }), a += t === "*" || t === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : r ? a += "\\/*$" : t !== "" && t !== "/" && (a += "(?:(?=\\/|$))"), [new RegExp(a, e ? void 0 : "i"), n];
}
function bo(t) {
  try {
    return t.split("/").map((e) => decodeURIComponent(e).replace(/\//g, "%2F")).join("/");
  } catch (e) {
    return he(!1, 'The URL path "' + t + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + e + ").")), t;
  }
}
function ze(t, e) {
  if (e === "/")
    return t;
  if (!t.toLowerCase().startsWith(e.toLowerCase()))
    return null;
  let r = e.endsWith("/") ? e.length - 1 : e.length, n = t.charAt(r);
  return n && n !== "/" ? null : t.slice(r) || "/";
}
function vo(t, e) {
  e === void 0 && (e = "/");
  let {
    pathname: r,
    search: n = "",
    hash: a = ""
  } = typeof t == "string" ? Qe(t) : t;
  return {
    pathname: r ? r.startsWith("/") ? r : xo(r, e) : e,
    search: Eo(n),
    hash: So(a)
  };
}
function xo(t, e) {
  let r = e.replace(/\/+$/, "").split("/");
  return t.split("/").forEach((a) => {
    a === ".." ? r.length > 1 && r.pop() : a !== "." && r.push(a);
  }), r.length > 1 ? r.join("/") : "/";
}
function cn(t, e, r, n) {
  return "Cannot include a '" + t + "' character in a manually specified " + ("`to." + e + "` field [" + JSON.stringify(n) + "].  Please separate it out to the ") + ("`to." + r + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function za(t) {
  return t.filter((e, r) => r === 0 || e.route.path && e.route.path.length > 0);
}
function Jr(t, e) {
  let r = za(t);
  return e ? r.map((n, a) => a === r.length - 1 ? n.pathname : n.pathnameBase) : r.map((n) => n.pathnameBase);
}
function Wr(t, e, r, n) {
  n === void 0 && (n = !1);
  let a;
  typeof t == "string" ? a = Qe(t) : (a = re({}, t), z(!a.pathname || !a.pathname.includes("?"), cn("?", "pathname", "search", a)), z(!a.pathname || !a.pathname.includes("#"), cn("#", "pathname", "hash", a)), z(!a.search || !a.search.includes("#"), cn("#", "search", "hash", a)));
  let i = t === "" || a.pathname === "", s = i ? "/" : a.pathname, o;
  if (s == null)
    o = r;
  else {
    let p = e.length - 1;
    if (!n && s.startsWith("..")) {
      let h = s.split("/");
      for (; h[0] === ".."; )
        h.shift(), p -= 1;
      a.pathname = h.join("/");
    }
    o = p >= 0 ? e[p] : "/";
  }
  let l = vo(a, o), c = s && s !== "/" && s.endsWith("/"), u = (i || s === ".") && r.endsWith("/");
  return !l.pathname.endsWith("/") && (c || u) && (l.pathname += "/"), l;
}
const Je = (t) => t.join("/").replace(/\/\/+/g, "/"), wo = (t) => t.replace(/\/+$/, "").replace(/^\/*/, "/"), Eo = (t) => !t || t === "?" ? "" : t.startsWith("?") ? t : "?" + t, So = (t) => !t || t === "#" ? "" : t.startsWith("#") ? t : "#" + t, Ro = function(e, r) {
  r === void 0 && (r = {});
  let n = typeof r == "number" ? {
    status: r
  } : r, a = new Headers(n.headers);
  return a.has("Content-Type") || a.set("Content-Type", "application/json; charset=utf-8"), new Response(JSON.stringify(e), re({}, n, {
    headers: a
  }));
};
class yn extends Error {
}
class jo {
  constructor(e, r) {
    this.pendingKeysSet = /* @__PURE__ */ new Set(), this.subscribers = /* @__PURE__ */ new Set(), this.deferredKeys = [], z(e && typeof e == "object" && !Array.isArray(e), "defer() only accepts plain objects");
    let n;
    this.abortPromise = new Promise((i, s) => n = s), this.controller = new AbortController();
    let a = () => n(new yn("Deferred data aborted"));
    this.unlistenAbortSignal = () => this.controller.signal.removeEventListener("abort", a), this.controller.signal.addEventListener("abort", a), this.data = Object.entries(e).reduce((i, s) => {
      let [o, l] = s;
      return Object.assign(i, {
        [o]: this.trackPromise(o, l)
      });
    }, {}), this.done && this.unlistenAbortSignal(), this.init = r;
  }
  trackPromise(e, r) {
    if (!(r instanceof Promise))
      return r;
    this.deferredKeys.push(e), this.pendingKeysSet.add(e);
    let n = Promise.race([r, this.abortPromise]).then((a) => this.onSettle(n, e, void 0, a), (a) => this.onSettle(n, e, a));
    return n.catch(() => {
    }), Object.defineProperty(n, "_tracked", {
      get: () => !0
    }), n;
  }
  onSettle(e, r, n, a) {
    if (this.controller.signal.aborted && n instanceof yn)
      return this.unlistenAbortSignal(), Object.defineProperty(e, "_error", {
        get: () => n
      }), Promise.reject(n);
    if (this.pendingKeysSet.delete(r), this.done && this.unlistenAbortSignal(), n === void 0 && a === void 0) {
      let i = new Error('Deferred data for key "' + r + '" resolved/rejected with `undefined`, you must resolve/reject with a value or `null`.');
      return Object.defineProperty(e, "_error", {
        get: () => i
      }), this.emit(!1, r), Promise.reject(i);
    }
    return a === void 0 ? (Object.defineProperty(e, "_error", {
      get: () => n
    }), this.emit(!1, r), Promise.reject(n)) : (Object.defineProperty(e, "_data", {
      get: () => a
    }), this.emit(!1, r), a);
  }
  emit(e, r) {
    this.subscribers.forEach((n) => n(e, r));
  }
  subscribe(e) {
    return this.subscribers.add(e), () => this.subscribers.delete(e);
  }
  cancel() {
    this.controller.abort(), this.pendingKeysSet.forEach((e, r) => this.pendingKeysSet.delete(r)), this.emit(!0);
  }
  async resolveData(e) {
    let r = !1;
    if (!this.done) {
      let n = () => this.cancel();
      e.addEventListener("abort", n), r = await new Promise((a) => {
        this.subscribe((i) => {
          e.removeEventListener("abort", n), (i || this.done) && a(i);
        });
      });
    }
    return r;
  }
  get done() {
    return this.pendingKeysSet.size === 0;
  }
  get unwrappedData() {
    return z(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds"), Object.entries(this.data).reduce((e, r) => {
      let [n, a] = r;
      return Object.assign(e, {
        [n]: Po(a)
      });
    }, {});
  }
  get pendingKeys() {
    return Array.from(this.pendingKeysSet);
  }
}
function Co(t) {
  return t instanceof Promise && t._tracked === !0;
}
function Po(t) {
  if (!Co(t))
    return t;
  if (t._error)
    throw t._error;
  return t._data;
}
const Ba = function(e, r) {
  r === void 0 && (r = {});
  let n = typeof r == "number" ? {
    status: r
  } : r;
  return new jo(e, n);
}, No = function(e, r) {
  r === void 0 && (r = 302);
  let n = r;
  typeof n == "number" ? n = {
    status: n
  } : typeof n.status > "u" && (n.status = 302);
  let a = new Headers(n.headers);
  return a.set("Location", e), new Response(null, re({}, n, {
    headers: a
  }));
};
class zr {
  constructor(e, r, n, a) {
    a === void 0 && (a = !1), this.status = e, this.statusText = r || "", this.internal = a, n instanceof Error ? (this.data = n.toString(), this.error = n) : this.data = n;
  }
}
function Yr(t) {
  return t != null && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.internal == "boolean" && "data" in t;
}
const Ka = ["post", "put", "patch", "delete"], Lo = new Set(Ka), ko = ["get", ...Ka], Oo = new Set(ko), Do = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]), To = /* @__PURE__ */ new Set([307, 308]), un = {
  state: "idle",
  location: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Ao = {
  state: "idle",
  data: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Zt = {
  state: "unblocked",
  proceed: void 0,
  reset: void 0,
  location: void 0
}, jn = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, _o = (t) => ({
  hasErrorBoundary: !!t.hasErrorBoundary
}), Ha = "remix-router-transitions";
function Io(t) {
  const e = t.window ? t.window : typeof window < "u" ? window : void 0, r = typeof e < "u" && typeof e.document < "u" && typeof e.document.createElement < "u", n = !r;
  z(t.routes.length > 0, "You must provide a non-empty routes array to createRouter");
  let a;
  if (t.mapRouteProperties)
    a = t.mapRouteProperties;
  else if (t.detectErrorBoundary) {
    let m = t.detectErrorBoundary;
    a = (y) => ({
      hasErrorBoundary: m(y)
    });
  } else
    a = _o;
  let i = {}, s = Ur(t.routes, a, void 0, i), o, l = t.basename || "/", c = t.dataStrategy || Uo, u = t.patchRoutesOnNavigation, p = re({
    v7_fetcherPersist: !1,
    v7_normalizeFormMethod: !1,
    v7_partialHydration: !1,
    v7_prependBasename: !1,
    v7_relativeSplatPath: !1,
    v7_skipActionErrorRevalidation: !1
  }, t.future), h = null, b = /* @__PURE__ */ new Set(), S = null, j = null, E = null, P = t.hydrationData != null, v = ft(s, t.history.location, l), O = null;
  if (v == null && !u) {
    let m = Re(404, {
      pathname: t.history.location.pathname
    }), {
      matches: y,
      route: w
    } = ga(s);
    v = y, O = {
      [w.id]: m
    };
  }
  v && !t.hydrationData && dt(v, s, t.history.location.pathname).active && (v = null);
  let L;
  if (v)
    if (v.some((m) => m.route.lazy))
      L = !1;
    else if (!v.some((m) => m.route.loader))
      L = !0;
    else if (p.v7_partialHydration) {
      let m = t.hydrationData ? t.hydrationData.loaderData : null, y = t.hydrationData ? t.hydrationData.errors : null;
      if (y) {
        let w = v.findIndex((N) => y[N.route.id] !== void 0);
        L = v.slice(0, w + 1).every((N) => !vn(N.route, m, y));
      } else
        L = v.every((w) => !vn(w.route, m, y));
    } else
      L = t.hydrationData != null;
  else if (L = !1, v = [], p.v7_partialHydration) {
    let m = dt(null, s, t.history.location.pathname);
    m.active && m.matches && (v = m.matches);
  }
  let D, g = {
    historyAction: t.history.action,
    location: t.history.location,
    matches: v,
    initialized: L,
    navigation: un,
    // Don't restore on initial updateState() if we were SSR'd
    restoreScrollPosition: t.hydrationData != null ? !1 : null,
    preventScrollReset: !1,
    revalidation: "idle",
    loaderData: t.hydrationData && t.hydrationData.loaderData || {},
    actionData: t.hydrationData && t.hydrationData.actionData || null,
    errors: t.hydrationData && t.hydrationData.errors || O,
    fetchers: /* @__PURE__ */ new Map(),
    blockers: /* @__PURE__ */ new Map()
  }, T = oe.Pop, F = !1, I, U = !1, W = /* @__PURE__ */ new Map(), G = null, q = !1, J = !1, Z = [], Le = /* @__PURE__ */ new Set(), ne = /* @__PURE__ */ new Map(), se = 0, be = -1, we = /* @__PURE__ */ new Map(), Ee = /* @__PURE__ */ new Set(), Ye = /* @__PURE__ */ new Map(), et = /* @__PURE__ */ new Map(), Ie = /* @__PURE__ */ new Set(), Ge = /* @__PURE__ */ new Map(), Fe = /* @__PURE__ */ new Map(), tt;
  function yt() {
    if (h = t.history.listen((m) => {
      let {
        action: y,
        location: w,
        delta: N
      } = m;
      if (tt) {
        tt(), tt = void 0;
        return;
      }
      he(Fe.size === 0 || N != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
      let _ = Et({
        currentLocation: g.location,
        nextLocation: w,
        historyAction: y
      });
      if (_ && N != null) {
        let B = new Promise((K) => {
          tt = K;
        });
        t.history.go(N * -1), wt(_, {
          state: "blocked",
          location: w,
          proceed() {
            wt(_, {
              state: "proceeding",
              proceed: void 0,
              reset: void 0,
              location: w
            }), B.then(() => t.history.go(N));
          },
          reset() {
            let K = new Map(g.blockers);
            K.set(_, Zt), pe({
              blockers: K
            });
          }
        });
        return;
      }
      return ke(y, w);
    }), r) {
      el(e, W);
      let m = () => tl(e, W);
      e.addEventListener("pagehide", m), G = () => e.removeEventListener("pagehide", m);
    }
    return g.initialized || ke(oe.Pop, g.location, {
      initialHydration: !0
    }), D;
  }
  function Ut() {
    h && h(), G && G(), b.clear(), I && I.abort(), g.fetchers.forEach((m, y) => ut(y)), g.blockers.forEach((m, y) => yr(y));
  }
  function bt(m) {
    return b.add(m), () => b.delete(m);
  }
  function pe(m, y) {
    y === void 0 && (y = {}), g = re({}, g, m);
    let w = [], N = [];
    p.v7_fetcherPersist && g.fetchers.forEach((_, B) => {
      _.state === "idle" && (Ie.has(B) ? N.push(B) : w.push(B));
    }), [...b].forEach((_) => _(g, {
      deletedFetchers: N,
      viewTransitionOpts: y.viewTransitionOpts,
      flushSync: y.flushSync === !0
    })), p.v7_fetcherPersist && (w.forEach((_) => g.fetchers.delete(_)), N.forEach((_) => ut(_)));
  }
  function Ze(m, y, w) {
    var N, _;
    let {
      flushSync: B
    } = w === void 0 ? {} : w, K = g.actionData != null && g.navigation.formMethod != null && Ve(g.navigation.formMethod) && g.navigation.state === "loading" && ((N = m.state) == null ? void 0 : N._isRedirect) !== !0, $;
    y.actionData ? Object.keys(y.actionData).length > 0 ? $ = y.actionData : $ = null : K ? $ = g.actionData : $ = null;
    let d = y.loaderData ? pa(g.loaderData, y.loaderData, y.matches || [], y.errors) : g.loaderData, x = g.blockers;
    x.size > 0 && (x = new Map(x), x.forEach((M, H) => x.set(H, Zt)));
    let R = F === !0 || g.navigation.formMethod != null && Ve(g.navigation.formMethod) && ((_ = m.state) == null ? void 0 : _._isRedirect) !== !0;
    o && (s = o, o = void 0), q || T === oe.Pop || (T === oe.Push ? t.history.push(m, m.state) : T === oe.Replace && t.history.replace(m, m.state));
    let k;
    if (T === oe.Pop) {
      let M = W.get(g.location.pathname);
      M && M.has(m.pathname) ? k = {
        currentLocation: g.location,
        nextLocation: m
      } : W.has(m.pathname) && (k = {
        currentLocation: m,
        nextLocation: g.location
      });
    } else if (U) {
      let M = W.get(g.location.pathname);
      M ? M.add(m.pathname) : (M = /* @__PURE__ */ new Set([m.pathname]), W.set(g.location.pathname, M)), k = {
        currentLocation: g.location,
        nextLocation: m
      };
    }
    pe(re({}, y, {
      actionData: $,
      loaderData: d,
      historyAction: T,
      location: m,
      initialized: !0,
      navigation: un,
      revalidation: "idle",
      restoreScrollPosition: vr(m, y.matches || g.matches),
      preventScrollReset: R,
      blockers: x
    }), {
      viewTransitionOpts: k,
      flushSync: B === !0
    }), T = oe.Pop, F = !1, U = !1, q = !1, J = !1, Z = [];
  }
  async function fr(m, y) {
    if (typeof m == "number") {
      t.history.go(m);
      return;
    }
    let w = bn(g.location, g.matches, l, p.v7_prependBasename, m, p.v7_relativeSplatPath, y == null ? void 0 : y.fromRouteId, y == null ? void 0 : y.relative), {
      path: N,
      submission: _,
      error: B
    } = sa(p.v7_normalizeFormMethod, !1, w, y), K = g.location, $ = ir(g.location, N, y && y.state);
    $ = re({}, $, t.history.encodeLocation($));
    let d = y && y.replace != null ? y.replace : void 0, x = oe.Push;
    d === !0 ? x = oe.Replace : d === !1 || _ != null && Ve(_.formMethod) && _.formAction === g.location.pathname + g.location.search && (x = oe.Replace);
    let R = y && "preventScrollReset" in y ? y.preventScrollReset === !0 : void 0, k = (y && y.flushSync) === !0, M = Et({
      currentLocation: K,
      nextLocation: $,
      historyAction: x
    });
    if (M) {
      wt(M, {
        state: "blocked",
        location: $,
        proceed() {
          wt(M, {
            state: "proceeding",
            proceed: void 0,
            reset: void 0,
            location: $
          }), fr(m, y);
        },
        reset() {
          let H = new Map(g.blockers);
          H.set(M, Zt), pe({
            blockers: H
          });
        }
      });
      return;
    }
    return await ke(x, $, {
      submission: _,
      // Send through the formData serialization error if we have one so we can
      // render at the right error boundary after we match routes
      pendingError: B,
      preventScrollReset: R,
      replace: y && y.replace,
      enableViewTransition: y && y.viewTransition,
      flushSync: k
    });
  }
  function en() {
    if (xt(), pe({
      revalidation: "loading"
    }), g.navigation.state !== "submitting") {
      if (g.navigation.state === "idle") {
        ke(g.historyAction, g.location, {
          startUninterruptedRevalidation: !0
        });
        return;
      }
      ke(T || g.historyAction, g.navigation.location, {
        overrideNavigation: g.navigation,
        // Proxy through any rending view transition
        enableViewTransition: U === !0
      });
    }
  }
  async function ke(m, y, w) {
    I && I.abort(), I = null, T = m, q = (w && w.startUninterruptedRevalidation) === !0, br(g.location, g.matches), F = (w && w.preventScrollReset) === !0, U = (w && w.enableViewTransition) === !0;
    let N = o || s, _ = w && w.overrideNavigation, B = ft(N, y, l), K = (w && w.flushSync) === !0, $ = dt(B, N, y.pathname);
    if ($.active && $.matches && (B = $.matches), !B) {
      let {
        error: V,
        notFoundMatches: A,
        route: Y
      } = St(y.pathname);
      Ze(y, {
        matches: A,
        loaderData: {},
        errors: {
          [Y.id]: V
        }
      }, {
        flushSync: K
      });
      return;
    }
    if (g.initialized && !J && qo(g.location, y) && !(w && w.submission && Ve(w.submission.formMethod))) {
      Ze(y, {
        matches: B
      }, {
        flushSync: K
      });
      return;
    }
    I = new AbortController();
    let d = Dt(t.history, y, I.signal, w && w.submission), x;
    if (w && w.pendingError)
      x = [ht(B).route.id, {
        type: ee.error,
        error: w.pendingError
      }];
    else if (w && w.submission && Ve(w.submission.formMethod)) {
      let V = await lt(d, y, w.submission, B, $.active, {
        replace: w.replace,
        flushSync: K
      });
      if (V.shortCircuited)
        return;
      if (V.pendingActionResult) {
        let [A, Y] = V.pendingActionResult;
        if (Ne(Y) && Yr(Y.error) && Y.error.status === 404) {
          I = null, Ze(y, {
            matches: V.matches,
            loaderData: {},
            errors: {
              [A]: Y.error
            }
          });
          return;
        }
      }
      B = V.matches || B, x = V.pendingActionResult, _ = dn(y, w.submission), K = !1, $.active = !1, d = Dt(t.history, d.url, d.signal);
    }
    let {
      shortCircuited: R,
      matches: k,
      loaderData: M,
      errors: H
    } = await hr(d, y, B, $.active, _, w && w.submission, w && w.fetcherSubmission, w && w.replace, w && w.initialHydration === !0, K, x);
    R || (I = null, Ze(y, re({
      matches: k || B
    }, ma(x), {
      loaderData: M,
      errors: H
    })));
  }
  async function lt(m, y, w, N, _, B) {
    B === void 0 && (B = {}), xt();
    let K = Xo(y, w);
    if (pe({
      navigation: K
    }, {
      flushSync: B.flushSync === !0
    }), _) {
      let x = await jt(N, y.pathname, m.signal);
      if (x.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (x.type === "error") {
        let R = ht(x.partialMatches).route.id;
        return {
          matches: x.partialMatches,
          pendingActionResult: [R, {
            type: ee.error,
            error: x.error
          }]
        };
      } else if (x.matches)
        N = x.matches;
      else {
        let {
          notFoundMatches: R,
          error: k,
          route: M
        } = St(y.pathname);
        return {
          matches: R,
          pendingActionResult: [M.id, {
            type: ee.error,
            error: k
          }]
        };
      }
    }
    let $, d = tr(N, y);
    if (!d.route.action && !d.route.lazy)
      $ = {
        type: ee.error,
        error: Re(405, {
          method: m.method,
          pathname: y.pathname,
          routeId: d.route.id
        })
      };
    else if ($ = (await ct("action", g, m, [d], N, null))[d.route.id], m.signal.aborted)
      return {
        shortCircuited: !0
      };
    if (pt($)) {
      let x;
      return B && B.replace != null ? x = B.replace : x = da($.response.headers.get("Location"), new URL(m.url), l) === g.location.pathname + g.location.search, await Xe(m, $, !0, {
        submission: w,
        replace: x
      }), {
        shortCircuited: !0
      };
    }
    if (it($))
      throw Re(400, {
        type: "defer-action"
      });
    if (Ne($)) {
      let x = ht(N, d.route.id);
      return (B && B.replace) !== !0 && (T = oe.Push), {
        matches: N,
        pendingActionResult: [x.route.id, $]
      };
    }
    return {
      matches: N,
      pendingActionResult: [d.route.id, $]
    };
  }
  async function hr(m, y, w, N, _, B, K, $, d, x, R) {
    let k = _ || dn(y, B), M = B || K || ba(k), H = !q && (!p.v7_partialHydration || !d);
    if (N) {
      if (H) {
        let ie = Vt(R);
        pe(re({
          navigation: k
        }, ie !== void 0 ? {
          actionData: ie
        } : {}), {
          flushSync: x
        });
      }
      let X = await jt(w, y.pathname, m.signal);
      if (X.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (X.type === "error") {
        let ie = ht(X.partialMatches).route.id;
        return {
          matches: X.partialMatches,
          loaderData: {},
          errors: {
            [ie]: X.error
          }
        };
      } else if (X.matches)
        w = X.matches;
      else {
        let {
          error: ie,
          notFoundMatches: Nt,
          route: Jt
        } = St(y.pathname);
        return {
          matches: Nt,
          loaderData: {},
          errors: {
            [Jt.id]: ie
          }
        };
      }
    }
    let V = o || s, [A, Y] = la(t.history, g, w, M, y, p.v7_partialHydration && d === !0, p.v7_skipActionErrorRevalidation, J, Z, Le, Ie, Ye, Ee, V, l, R);
    if (Ke((X) => !(w && w.some((ie) => ie.route.id === X)) || A && A.some((ie) => ie.route.id === X)), be = ++se, A.length === 0 && Y.length === 0) {
      let X = mr();
      return Ze(y, re({
        matches: w,
        loaderData: {},
        // Commit pending error if we're short circuiting
        errors: R && Ne(R[1]) ? {
          [R[0]]: R[1].error
        } : null
      }, ma(R), X ? {
        fetchers: new Map(g.fetchers)
      } : {}), {
        flushSync: x
      }), {
        shortCircuited: !0
      };
    }
    if (H) {
      let X = {};
      if (!N) {
        X.navigation = k;
        let ie = Vt(R);
        ie !== void 0 && (X.actionData = ie);
      }
      Y.length > 0 && (X.fetchers = vt(Y)), pe(X, {
        flushSync: x
      });
    }
    Y.forEach((X) => {
      Be(X.key), X.controller && ne.set(X.key, X.controller);
    });
    let Q = () => Y.forEach((X) => Be(X.key));
    I && I.signal.addEventListener("abort", Q);
    let {
      loaderResults: te,
      fetcherResults: ae
    } = await Bt(g, w, A, Y, m);
    if (m.signal.aborted)
      return {
        shortCircuited: !0
      };
    I && I.signal.removeEventListener("abort", Q), Y.forEach((X) => ne.delete(X.key));
    let me = Sr(te);
    if (me)
      return await Xe(m, me.result, !0, {
        replace: $
      }), {
        shortCircuited: !0
      };
    if (me = Sr(ae), me)
      return Ee.add(me.key), await Xe(m, me.result, !0, {
        replace: $
      }), {
        shortCircuited: !0
      };
    let {
      loaderData: Me,
      errors: ce
    } = ha(g, w, te, R, Y, ae, Ge);
    Ge.forEach((X, ie) => {
      X.subscribe((Nt) => {
        (Nt || X.done) && Ge.delete(ie);
      });
    }), p.v7_partialHydration && d && g.errors && (ce = re({}, g.errors, ce));
    let Ue = mr(), Ct = gr(be), Pt = Ue || Ct || Y.length > 0;
    return re({
      matches: w,
      loaderData: Me,
      errors: ce
    }, Pt ? {
      fetchers: new Map(g.fetchers)
    } : {});
  }
  function Vt(m) {
    if (m && !Ne(m[1]))
      return {
        [m[0]]: m[1].data
      };
    if (g.actionData)
      return Object.keys(g.actionData).length === 0 ? null : g.actionData;
  }
  function vt(m) {
    return m.forEach((y) => {
      let w = g.fetchers.get(y.key), N = Xt(void 0, w ? w.data : void 0);
      g.fetchers.set(y.key, N);
    }), new Map(g.fetchers);
  }
  function tn(m, y, w, N) {
    if (n)
      throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
    Be(m);
    let _ = (N && N.flushSync) === !0, B = o || s, K = bn(g.location, g.matches, l, p.v7_prependBasename, w, p.v7_relativeSplatPath, y, N == null ? void 0 : N.relative), $ = ft(B, K, l), d = dt($, B, K);
    if (d.active && d.matches && ($ = d.matches), !$) {
      $e(m, y, Re(404, {
        pathname: K
      }), {
        flushSync: _
      });
      return;
    }
    let {
      path: x,
      submission: R,
      error: k
    } = sa(p.v7_normalizeFormMethod, !0, K, N);
    if (k) {
      $e(m, y, k, {
        flushSync: _
      });
      return;
    }
    let M = tr($, x), H = (N && N.preventScrollReset) === !0;
    if (R && Ve(R.formMethod)) {
      rn(m, y, x, M, $, d.active, _, H, R);
      return;
    }
    Ye.set(m, {
      routeId: y,
      path: x
    }), zt(m, y, x, M, $, d.active, _, H, R);
  }
  async function rn(m, y, w, N, _, B, K, $, d) {
    xt(), Ye.delete(m);
    function x(ue) {
      if (!ue.route.action && !ue.route.lazy) {
        let Lt = Re(405, {
          method: d.formMethod,
          pathname: w,
          routeId: y
        });
        return $e(m, y, Lt, {
          flushSync: K
        }), !0;
      }
      return !1;
    }
    if (!B && x(N))
      return;
    let R = g.fetchers.get(m);
    Se(m, Qo(d, R), {
      flushSync: K
    });
    let k = new AbortController(), M = Dt(t.history, w, k.signal, d);
    if (B) {
      let ue = await jt(_, w, M.signal);
      if (ue.type === "aborted")
        return;
      if (ue.type === "error") {
        $e(m, y, ue.error, {
          flushSync: K
        });
        return;
      } else if (ue.matches) {
        if (_ = ue.matches, N = tr(_, w), x(N))
          return;
      } else {
        $e(m, y, Re(404, {
          pathname: w
        }), {
          flushSync: K
        });
        return;
      }
    }
    ne.set(m, k);
    let H = se, A = (await ct("action", g, M, [N], _, m))[N.route.id];
    if (M.signal.aborted) {
      ne.get(m) === k && ne.delete(m);
      return;
    }
    if (p.v7_fetcherPersist && Ie.has(m)) {
      if (pt(A) || Ne(A)) {
        Se(m, rt(void 0));
        return;
      }
    } else {
      if (pt(A))
        if (ne.delete(m), be > H) {
          Se(m, rt(void 0));
          return;
        } else
          return Ee.add(m), Se(m, Xt(d)), Xe(M, A, !1, {
            fetcherSubmission: d,
            preventScrollReset: $
          });
      if (Ne(A)) {
        $e(m, y, A.error);
        return;
      }
    }
    if (it(A))
      throw Re(400, {
        type: "defer-action"
      });
    let Y = g.navigation.location || g.location, Q = Dt(t.history, Y, k.signal), te = o || s, ae = g.navigation.state !== "idle" ? ft(te, g.navigation.location, l) : g.matches;
    z(ae, "Didn't find any matches after fetcher action");
    let me = ++se;
    we.set(m, me);
    let Me = Xt(d, A.data);
    g.fetchers.set(m, Me);
    let [ce, Ue] = la(t.history, g, ae, d, Y, !1, p.v7_skipActionErrorRevalidation, J, Z, Le, Ie, Ye, Ee, te, l, [N.route.id, A]);
    Ue.filter((ue) => ue.key !== m).forEach((ue) => {
      let Lt = ue.key, $n = g.fetchers.get(Lt), Ni = Xt(void 0, $n ? $n.data : void 0);
      g.fetchers.set(Lt, Ni), Be(Lt), ue.controller && ne.set(Lt, ue.controller);
    }), pe({
      fetchers: new Map(g.fetchers)
    });
    let Ct = () => Ue.forEach((ue) => Be(ue.key));
    k.signal.addEventListener("abort", Ct);
    let {
      loaderResults: Pt,
      fetcherResults: X
    } = await Bt(g, ae, ce, Ue, Q);
    if (k.signal.aborted)
      return;
    k.signal.removeEventListener("abort", Ct), we.delete(m), ne.delete(m), Ue.forEach((ue) => ne.delete(ue.key));
    let ie = Sr(Pt);
    if (ie)
      return Xe(Q, ie.result, !1, {
        preventScrollReset: $
      });
    if (ie = Sr(X), ie)
      return Ee.add(ie.key), Xe(Q, ie.result, !1, {
        preventScrollReset: $
      });
    let {
      loaderData: Nt,
      errors: Jt
    } = ha(g, ae, Pt, void 0, Ue, X, Ge);
    if (g.fetchers.has(m)) {
      let ue = rt(A.data);
      g.fetchers.set(m, ue);
    }
    gr(me), g.navigation.state === "loading" && me > be ? (z(T, "Expected pending action"), I && I.abort(), Ze(g.navigation.location, {
      matches: ae,
      loaderData: Nt,
      errors: Jt,
      fetchers: new Map(g.fetchers)
    })) : (pe({
      errors: Jt,
      loaderData: pa(g.loaderData, Nt, ae, Jt),
      fetchers: new Map(g.fetchers)
    }), J = !1);
  }
  async function zt(m, y, w, N, _, B, K, $, d) {
    let x = g.fetchers.get(m);
    Se(m, Xt(d, x ? x.data : void 0), {
      flushSync: K
    });
    let R = new AbortController(), k = Dt(t.history, w, R.signal);
    if (B) {
      let A = await jt(_, w, k.signal);
      if (A.type === "aborted")
        return;
      if (A.type === "error") {
        $e(m, y, A.error, {
          flushSync: K
        });
        return;
      } else if (A.matches)
        _ = A.matches, N = tr(_, w);
      else {
        $e(m, y, Re(404, {
          pathname: w
        }), {
          flushSync: K
        });
        return;
      }
    }
    ne.set(m, R);
    let M = se, V = (await ct("loader", g, k, [N], _, m))[N.route.id];
    if (it(V) && (V = await Cn(V, k.signal, !0) || V), ne.get(m) === R && ne.delete(m), !k.signal.aborted) {
      if (Ie.has(m)) {
        Se(m, rt(void 0));
        return;
      }
      if (pt(V))
        if (be > M) {
          Se(m, rt(void 0));
          return;
        } else {
          Ee.add(m), await Xe(k, V, !1, {
            preventScrollReset: $
          });
          return;
        }
      if (Ne(V)) {
        $e(m, y, V.error);
        return;
      }
      z(!it(V), "Unhandled fetcher deferred data"), Se(m, rt(V.data));
    }
  }
  async function Xe(m, y, w, N) {
    let {
      submission: _,
      fetcherSubmission: B,
      preventScrollReset: K,
      replace: $
    } = N === void 0 ? {} : N;
    y.response.headers.has("X-Remix-Revalidate") && (J = !0);
    let d = y.response.headers.get("Location");
    z(d, "Expected a Location header on the redirect Response"), d = da(d, new URL(m.url), l);
    let x = ir(g.location, d, {
      _isRedirect: !0
    });
    if (r) {
      let A = !1;
      if (y.response.headers.has("X-Remix-Reload-Document"))
        A = !0;
      else if (jn.test(d)) {
        const Y = t.history.createURL(d);
        A = // Hard reload if it's an absolute URL to a new origin
        Y.origin !== e.location.origin || // Hard reload if it's an absolute URL that does not match our basename
        ze(Y.pathname, l) == null;
      }
      if (A) {
        $ ? e.location.replace(d) : e.location.assign(d);
        return;
      }
    }
    I = null;
    let R = $ === !0 || y.response.headers.has("X-Remix-Replace") ? oe.Replace : oe.Push, {
      formMethod: k,
      formAction: M,
      formEncType: H
    } = g.navigation;
    !_ && !B && k && M && H && (_ = ba(g.navigation));
    let V = _ || B;
    if (To.has(y.response.status) && V && Ve(V.formMethod))
      await ke(R, x, {
        submission: re({}, V, {
          formAction: d
        }),
        // Preserve these flags across redirects
        preventScrollReset: K || F,
        enableViewTransition: w ? U : void 0
      });
    else {
      let A = dn(x, _);
      await ke(R, x, {
        overrideNavigation: A,
        // Send fetcher submissions through for shouldRevalidate
        fetcherSubmission: B,
        // Preserve these flags across redirects
        preventScrollReset: K || F,
        enableViewTransition: w ? U : void 0
      });
    }
  }
  async function ct(m, y, w, N, _, B) {
    let K, $ = {};
    try {
      K = await Vo(c, m, y, w, N, _, B, i, a);
    } catch (d) {
      return N.forEach((x) => {
        $[x.route.id] = {
          type: ee.error,
          error: d
        };
      }), $;
    }
    for (let [d, x] of Object.entries(K))
      if (Jo(x)) {
        let R = x.result;
        $[d] = {
          type: ee.redirect,
          response: Ko(R, w, d, _, l, p.v7_relativeSplatPath)
        };
      } else
        $[d] = await Bo(x);
    return $;
  }
  async function Bt(m, y, w, N, _) {
    let B = m.matches, K = ct("loader", m, _, w, y, null), $ = Promise.all(N.map(async (R) => {
      if (R.matches && R.match && R.controller) {
        let M = (await ct("loader", m, Dt(t.history, R.path, R.controller.signal), [R.match], R.matches, R.key))[R.match.route.id];
        return {
          [R.key]: M
        };
      } else
        return Promise.resolve({
          [R.key]: {
            type: ee.error,
            error: Re(404, {
              pathname: R.path
            })
          }
        });
    })), d = await K, x = (await $).reduce((R, k) => Object.assign(R, k), {});
    return await Promise.all([Go(y, d, _.signal, B, m.loaderData), Zo(y, x, N)]), {
      loaderResults: d,
      fetcherResults: x
    };
  }
  function xt() {
    J = !0, Z.push(...Ke()), Ye.forEach((m, y) => {
      ne.has(y) && Le.add(y), Be(y);
    });
  }
  function Se(m, y, w) {
    w === void 0 && (w = {}), g.fetchers.set(m, y), pe({
      fetchers: new Map(g.fetchers)
    }, {
      flushSync: (w && w.flushSync) === !0
    });
  }
  function $e(m, y, w, N) {
    N === void 0 && (N = {});
    let _ = ht(g.matches, y);
    ut(m), pe({
      errors: {
        [_.route.id]: w
      },
      fetchers: new Map(g.fetchers)
    }, {
      flushSync: (N && N.flushSync) === !0
    });
  }
  function Kt(m) {
    return p.v7_fetcherPersist && (et.set(m, (et.get(m) || 0) + 1), Ie.has(m) && Ie.delete(m)), g.fetchers.get(m) || Ao;
  }
  function ut(m) {
    let y = g.fetchers.get(m);
    ne.has(m) && !(y && y.state === "loading" && we.has(m)) && Be(m), Ye.delete(m), we.delete(m), Ee.delete(m), Ie.delete(m), Le.delete(m), g.fetchers.delete(m);
  }
  function Ht(m) {
    if (p.v7_fetcherPersist) {
      let y = (et.get(m) || 0) - 1;
      y <= 0 ? (et.delete(m), Ie.add(m)) : et.set(m, y);
    } else
      ut(m);
    pe({
      fetchers: new Map(g.fetchers)
    });
  }
  function Be(m) {
    let y = ne.get(m);
    y && (y.abort(), ne.delete(m));
  }
  function pr(m) {
    for (let y of m) {
      let w = Kt(y), N = rt(w.data);
      g.fetchers.set(y, N);
    }
  }
  function mr() {
    let m = [], y = !1;
    for (let w of Ee) {
      let N = g.fetchers.get(w);
      z(N, "Expected fetcher: " + w), N.state === "loading" && (Ee.delete(w), m.push(w), y = !0);
    }
    return pr(m), y;
  }
  function gr(m) {
    let y = [];
    for (let [w, N] of we)
      if (N < m) {
        let _ = g.fetchers.get(w);
        z(_, "Expected fetcher: " + w), _.state === "loading" && (Be(w), we.delete(w), y.push(w));
      }
    return pr(y), y.length > 0;
  }
  function nn(m, y) {
    let w = g.blockers.get(m) || Zt;
    return Fe.get(m) !== y && Fe.set(m, y), w;
  }
  function yr(m) {
    g.blockers.delete(m), Fe.delete(m);
  }
  function wt(m, y) {
    let w = g.blockers.get(m) || Zt;
    z(w.state === "unblocked" && y.state === "blocked" || w.state === "blocked" && y.state === "blocked" || w.state === "blocked" && y.state === "proceeding" || w.state === "blocked" && y.state === "unblocked" || w.state === "proceeding" && y.state === "unblocked", "Invalid blocker state transition: " + w.state + " -> " + y.state);
    let N = new Map(g.blockers);
    N.set(m, y), pe({
      blockers: N
    });
  }
  function Et(m) {
    let {
      currentLocation: y,
      nextLocation: w,
      historyAction: N
    } = m;
    if (Fe.size === 0)
      return;
    Fe.size > 1 && he(!1, "A router only supports one blocker at a time");
    let _ = Array.from(Fe.entries()), [B, K] = _[_.length - 1], $ = g.blockers.get(B);
    if (!($ && $.state === "proceeding") && K({
      currentLocation: y,
      nextLocation: w,
      historyAction: N
    }))
      return B;
  }
  function St(m) {
    let y = Re(404, {
      pathname: m
    }), w = o || s, {
      matches: N,
      route: _
    } = ga(w);
    return Ke(), {
      notFoundMatches: N,
      route: _,
      error: y
    };
  }
  function Ke(m) {
    let y = [];
    return Ge.forEach((w, N) => {
      (!m || m(N)) && (w.cancel(), y.push(N), Ge.delete(N));
    }), y;
  }
  function qt(m, y, w) {
    if (S = m, E = y, j = w || null, !P && g.navigation === un) {
      P = !0;
      let N = vr(g.location, g.matches);
      N != null && pe({
        restoreScrollPosition: N
      });
    }
    return () => {
      S = null, E = null, j = null;
    };
  }
  function Rt(m, y) {
    return j && j(m, y.map((N) => io(N, g.loaderData))) || m.key;
  }
  function br(m, y) {
    if (S && E) {
      let w = Rt(m, y);
      S[w] = E();
    }
  }
  function vr(m, y) {
    if (S) {
      let w = Rt(m, y), N = S[w];
      if (typeof N == "number")
        return N;
    }
    return null;
  }
  function dt(m, y, w) {
    if (u)
      if (m) {
        if (Object.keys(m[0].params).length > 0)
          return {
            active: !0,
            matches: Lr(y, w, l, !0)
          };
      } else
        return {
          active: !0,
          matches: Lr(y, w, l, !0) || []
        };
    return {
      active: !1,
      matches: null
    };
  }
  async function jt(m, y, w) {
    if (!u)
      return {
        type: "success",
        matches: m
      };
    let N = m;
    for (; ; ) {
      let _ = o == null, B = o || s, K = i;
      try {
        await u({
          path: y,
          matches: N,
          patch: (x, R) => {
            w.aborted || ua(x, R, B, K, a);
          }
        });
      } catch (x) {
        return {
          type: "error",
          error: x,
          partialMatches: N
        };
      } finally {
        _ && !w.aborted && (s = [...s]);
      }
      if (w.aborted)
        return {
          type: "aborted"
        };
      let $ = ft(B, y, l);
      if ($)
        return {
          type: "success",
          matches: $
        };
      let d = Lr(B, y, l, !0);
      if (!d || N.length === d.length && N.every((x, R) => x.route.id === d[R].route.id))
        return {
          type: "success",
          matches: null
        };
      N = d;
    }
  }
  function xr(m) {
    i = {}, o = Ur(m, a, void 0, i);
  }
  function wr(m, y) {
    let w = o == null;
    ua(m, y, o || s, i, a), w && (s = [...s], pe({}));
  }
  return D = {
    get basename() {
      return l;
    },
    get future() {
      return p;
    },
    get state() {
      return g;
    },
    get routes() {
      return s;
    },
    get window() {
      return e;
    },
    initialize: yt,
    subscribe: bt,
    enableScrollRestoration: qt,
    navigate: fr,
    fetch: tn,
    revalidate: en,
    // Passthrough to history-aware createHref used by useHref so we get proper
    // hash-aware URLs in DOM paths
    createHref: (m) => t.history.createHref(m),
    encodeLocation: (m) => t.history.encodeLocation(m),
    getFetcher: Kt,
    deleteFetcher: Ht,
    dispose: Ut,
    getBlocker: nn,
    deleteBlocker: yr,
    patchRoutes: wr,
    _internalFetchControllers: ne,
    _internalActiveDeferreds: Ge,
    // TODO: Remove setRoutes, it's temporary to avoid dealing with
    // updating the tree while validating the update algorithm.
    _internalSetRoutes: xr
  }, D;
}
function Fo(t) {
  return t != null && ("formData" in t && t.formData != null || "body" in t && t.body !== void 0);
}
function bn(t, e, r, n, a, i, s, o) {
  let l, c;
  if (s) {
    l = [];
    for (let p of e)
      if (l.push(p), p.route.id === s) {
        c = p;
        break;
      }
  } else
    l = e, c = e[e.length - 1];
  let u = Wr(a || ".", Jr(l, i), ze(t.pathname, r) || t.pathname, o === "path");
  if (a == null && (u.search = t.search, u.hash = t.hash), (a == null || a === "" || a === ".") && c) {
    let p = Pn(u.search);
    if (c.route.index && !p)
      u.search = u.search ? u.search.replace(/^\?/, "?index&") : "?index";
    else if (!c.route.index && p) {
      let h = new URLSearchParams(u.search), b = h.getAll("index");
      h.delete("index"), b.filter((j) => j).forEach((j) => h.append("index", j));
      let S = h.toString();
      u.search = S ? "?" + S : "";
    }
  }
  return n && r !== "/" && (u.pathname = u.pathname === "/" ? r : Je([r, u.pathname])), st(u);
}
function sa(t, e, r, n) {
  if (!n || !Fo(n))
    return {
      path: r
    };
  if (n.formMethod && !Yo(n.formMethod))
    return {
      path: r,
      error: Re(405, {
        method: n.formMethod
      })
    };
  let a = () => ({
    path: r,
    error: Re(400, {
      type: "invalid-body"
    })
  }), i = n.formMethod || "get", s = t ? i.toUpperCase() : i.toLowerCase(), o = Wa(r);
  if (n.body !== void 0) {
    if (n.formEncType === "text/plain") {
      if (!Ve(s))
        return a();
      let h = typeof n.body == "string" ? n.body : n.body instanceof FormData || n.body instanceof URLSearchParams ? (
        // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
        Array.from(n.body.entries()).reduce((b, S) => {
          let [j, E] = S;
          return "" + b + j + "=" + E + `
`;
        }, "")
      ) : String(n.body);
      return {
        path: r,
        submission: {
          formMethod: s,
          formAction: o,
          formEncType: n.formEncType,
          formData: void 0,
          json: void 0,
          text: h
        }
      };
    } else if (n.formEncType === "application/json") {
      if (!Ve(s))
        return a();
      try {
        let h = typeof n.body == "string" ? JSON.parse(n.body) : n.body;
        return {
          path: r,
          submission: {
            formMethod: s,
            formAction: o,
            formEncType: n.formEncType,
            formData: void 0,
            json: h,
            text: void 0
          }
        };
      } catch {
        return a();
      }
    }
  }
  z(typeof FormData == "function", "FormData is not available in this environment");
  let l, c;
  if (n.formData)
    l = xn(n.formData), c = n.formData;
  else if (n.body instanceof FormData)
    l = xn(n.body), c = n.body;
  else if (n.body instanceof URLSearchParams)
    l = n.body, c = fa(l);
  else if (n.body == null)
    l = new URLSearchParams(), c = new FormData();
  else
    try {
      l = new URLSearchParams(n.body), c = fa(l);
    } catch {
      return a();
    }
  let u = {
    formMethod: s,
    formAction: o,
    formEncType: n && n.formEncType || "application/x-www-form-urlencoded",
    formData: c,
    json: void 0,
    text: void 0
  };
  if (Ve(u.formMethod))
    return {
      path: r,
      submission: u
    };
  let p = Qe(r);
  return e && p.search && Pn(p.search) && l.append("index", ""), p.search = "?" + l, {
    path: st(p),
    submission: u
  };
}
function oa(t, e, r) {
  r === void 0 && (r = !1);
  let n = t.findIndex((a) => a.route.id === e);
  return n >= 0 ? t.slice(0, r ? n + 1 : n) : t;
}
function la(t, e, r, n, a, i, s, o, l, c, u, p, h, b, S, j) {
  let E = j ? Ne(j[1]) ? j[1].error : j[1].data : void 0, P = t.createURL(e.location), v = t.createURL(a), O = r;
  i && e.errors ? O = oa(r, Object.keys(e.errors)[0], !0) : j && Ne(j[1]) && (O = oa(r, j[0]));
  let L = j ? j[1].statusCode : void 0, D = s && L && L >= 400, g = O.filter((F, I) => {
    let {
      route: U
    } = F;
    if (U.lazy)
      return !0;
    if (U.loader == null)
      return !1;
    if (i)
      return vn(U, e.loaderData, e.errors);
    if ($o(e.loaderData, e.matches[I], F) || l.some((q) => q === F.route.id))
      return !0;
    let W = e.matches[I], G = F;
    return ca(F, re({
      currentUrl: P,
      currentParams: W.params,
      nextUrl: v,
      nextParams: G.params
    }, n, {
      actionResult: E,
      actionStatus: L,
      defaultShouldRevalidate: D ? !1 : (
        // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        o || P.pathname + P.search === v.pathname + v.search || // Search params affect all loaders
        P.search !== v.search || qa(W, G)
      )
    }));
  }), T = [];
  return p.forEach((F, I) => {
    if (i || !r.some((J) => J.route.id === F.routeId) || u.has(I))
      return;
    let U = ft(b, F.path, S);
    if (!U) {
      T.push({
        key: I,
        routeId: F.routeId,
        path: F.path,
        matches: null,
        match: null,
        controller: null
      });
      return;
    }
    let W = e.fetchers.get(I), G = tr(U, F.path), q = !1;
    h.has(I) ? q = !1 : c.has(I) ? (c.delete(I), q = !0) : W && W.state !== "idle" && W.data === void 0 ? q = o : q = ca(G, re({
      currentUrl: P,
      currentParams: e.matches[e.matches.length - 1].params,
      nextUrl: v,
      nextParams: r[r.length - 1].params
    }, n, {
      actionResult: E,
      actionStatus: L,
      defaultShouldRevalidate: D ? !1 : o
    })), q && T.push({
      key: I,
      routeId: F.routeId,
      path: F.path,
      matches: U,
      match: G,
      controller: new AbortController()
    });
  }), [g, T];
}
function vn(t, e, r) {
  if (t.lazy)
    return !0;
  if (!t.loader)
    return !1;
  let n = e != null && e[t.id] !== void 0, a = r != null && r[t.id] !== void 0;
  return !n && a ? !1 : typeof t.loader == "function" && t.loader.hydrate === !0 ? !0 : !n && !a;
}
function $o(t, e, r) {
  let n = (
    // [a] -> [a, b]
    !e || // [a, b] -> [a, c]
    r.route.id !== e.route.id
  ), a = t[r.route.id] === void 0;
  return n || a;
}
function qa(t, e) {
  let r = t.route.path;
  return (
    // param change for this match, /users/123 -> /users/456
    t.pathname !== e.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    r != null && r.endsWith("*") && t.params["*"] !== e.params["*"]
  );
}
function ca(t, e) {
  if (t.route.shouldRevalidate) {
    let r = t.route.shouldRevalidate(e);
    if (typeof r == "boolean")
      return r;
  }
  return e.defaultShouldRevalidate;
}
function ua(t, e, r, n, a) {
  var i;
  let s;
  if (t) {
    let c = n[t];
    z(c, "No route found to patch children into: routeId = " + t), c.children || (c.children = []), s = c.children;
  } else
    s = r;
  let o = e.filter((c) => !s.some((u) => Ja(c, u))), l = Ur(o, a, [t || "_", "patch", String(((i = s) == null ? void 0 : i.length) || "0")], n);
  s.push(...l);
}
function Ja(t, e) {
  return "id" in t && "id" in e && t.id === e.id ? !0 : t.index === e.index && t.path === e.path && t.caseSensitive === e.caseSensitive ? (!t.children || t.children.length === 0) && (!e.children || e.children.length === 0) ? !0 : t.children.every((r, n) => {
    var a;
    return (a = e.children) == null ? void 0 : a.some((i) => Ja(r, i));
  }) : !1;
}
async function Mo(t, e, r) {
  if (!t.lazy)
    return;
  let n = await t.lazy();
  if (!t.lazy)
    return;
  let a = r[t.id];
  z(a, "No route found in manifest");
  let i = {};
  for (let s in n) {
    let l = a[s] !== void 0 && // This property isn't static since it should always be updated based
    // on the route updates
    s !== "hasErrorBoundary";
    he(!l, 'Route "' + a.id + '" has a static property "' + s + '" defined but its lazy function is also returning a value for this property. ' + ('The lazy route property "' + s + '" will be ignored.')), !l && !no.has(s) && (i[s] = n[s]);
  }
  Object.assign(a, i), Object.assign(a, re({}, e(a), {
    lazy: void 0
  }));
}
async function Uo(t) {
  let {
    matches: e
  } = t, r = e.filter((a) => a.shouldLoad);
  return (await Promise.all(r.map((a) => a.resolve()))).reduce((a, i, s) => Object.assign(a, {
    [r[s].route.id]: i
  }), {});
}
async function Vo(t, e, r, n, a, i, s, o, l, c) {
  let u = i.map((b) => b.route.lazy ? Mo(b.route, l, o) : void 0), p = i.map((b, S) => {
    let j = u[S], E = a.some((v) => v.route.id === b.route.id);
    return re({}, b, {
      shouldLoad: E,
      resolve: async (v) => (v && n.method === "GET" && (b.route.lazy || b.route.loader) && (E = !0), E ? zo(e, n, b, j, v, c) : Promise.resolve({
        type: ee.data,
        result: void 0
      }))
    });
  }), h = await t({
    matches: p,
    request: n,
    params: i[0].params,
    fetcherKey: s,
    context: c
  });
  try {
    await Promise.all(u);
  } catch {
  }
  return h;
}
async function zo(t, e, r, n, a, i) {
  let s, o, l = (c) => {
    let u, p = new Promise((S, j) => u = j);
    o = () => u(), e.signal.addEventListener("abort", o);
    let h = (S) => typeof c != "function" ? Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + t + '" [routeId: ' + r.route.id + "]"))) : c({
      request: e,
      params: r.params,
      context: i
    }, ...S !== void 0 ? [S] : []), b = (async () => {
      try {
        return {
          type: "data",
          result: await (a ? a((j) => h(j)) : h())
        };
      } catch (S) {
        return {
          type: "error",
          result: S
        };
      }
    })();
    return Promise.race([b, p]);
  };
  try {
    let c = r.route[t];
    if (n)
      if (c) {
        let u, [p] = await Promise.all([
          // If the handler throws, don't let it immediately bubble out,
          // since we need to let the lazy() execution finish so we know if this
          // route has a boundary that can handle the error
          l(c).catch((h) => {
            u = h;
          }),
          n
        ]);
        if (u !== void 0)
          throw u;
        s = p;
      } else if (await n, c = r.route[t], c)
        s = await l(c);
      else if (t === "action") {
        let u = new URL(e.url), p = u.pathname + u.search;
        throw Re(405, {
          method: e.method,
          pathname: p,
          routeId: r.route.id
        });
      } else
        return {
          type: ee.data,
          result: void 0
        };
    else if (c)
      s = await l(c);
    else {
      let u = new URL(e.url), p = u.pathname + u.search;
      throw Re(404, {
        pathname: p
      });
    }
    z(s.result !== void 0, "You defined " + (t === "action" ? "an action" : "a loader") + " for route " + ('"' + r.route.id + "\" but didn't return anything from your `" + t + "` ") + "function. Please return a value or `null`.");
  } catch (c) {
    return {
      type: ee.error,
      result: c
    };
  } finally {
    o && e.signal.removeEventListener("abort", o);
  }
  return s;
}
async function Bo(t) {
  let {
    result: e,
    type: r
  } = t;
  if (Ya(e)) {
    let c;
    try {
      let u = e.headers.get("Content-Type");
      u && /\bapplication\/json\b/.test(u) ? e.body == null ? c = null : c = await e.json() : c = await e.text();
    } catch (u) {
      return {
        type: ee.error,
        error: u
      };
    }
    return r === ee.error ? {
      type: ee.error,
      error: new zr(e.status, e.statusText, c),
      statusCode: e.status,
      headers: e.headers
    } : {
      type: ee.data,
      data: c,
      statusCode: e.status,
      headers: e.headers
    };
  }
  if (r === ee.error) {
    if (ya(e)) {
      var n;
      if (e.data instanceof Error) {
        var a;
        return {
          type: ee.error,
          error: e.data,
          statusCode: (a = e.init) == null ? void 0 : a.status
        };
      }
      e = new zr(((n = e.init) == null ? void 0 : n.status) || 500, void 0, e.data);
    }
    return {
      type: ee.error,
      error: e,
      statusCode: Yr(e) ? e.status : void 0
    };
  }
  if (Wo(e)) {
    var i, s;
    return {
      type: ee.deferred,
      deferredData: e,
      statusCode: (i = e.init) == null ? void 0 : i.status,
      headers: ((s = e.init) == null ? void 0 : s.headers) && new Headers(e.init.headers)
    };
  }
  if (ya(e)) {
    var o, l;
    return {
      type: ee.data,
      data: e.data,
      statusCode: (o = e.init) == null ? void 0 : o.status,
      headers: (l = e.init) != null && l.headers ? new Headers(e.init.headers) : void 0
    };
  }
  return {
    type: ee.data,
    data: e
  };
}
function Ko(t, e, r, n, a, i) {
  let s = t.headers.get("Location");
  if (z(s, "Redirects returned/thrown from loaders/actions must have a Location header"), !jn.test(s)) {
    let o = n.slice(0, n.findIndex((l) => l.route.id === r) + 1);
    s = bn(new URL(e.url), o, a, !0, s, i), t.headers.set("Location", s);
  }
  return t;
}
function da(t, e, r) {
  if (jn.test(t)) {
    let n = t, a = n.startsWith("//") ? new URL(e.protocol + n) : new URL(n), i = ze(a.pathname, r) != null;
    if (a.origin === e.origin && i)
      return a.pathname + a.search + a.hash;
  }
  return t;
}
function Dt(t, e, r, n) {
  let a = t.createURL(Wa(e)).toString(), i = {
    signal: r
  };
  if (n && Ve(n.formMethod)) {
    let {
      formMethod: s,
      formEncType: o
    } = n;
    i.method = s.toUpperCase(), o === "application/json" ? (i.headers = new Headers({
      "Content-Type": o
    }), i.body = JSON.stringify(n.json)) : o === "text/plain" ? i.body = n.text : o === "application/x-www-form-urlencoded" && n.formData ? i.body = xn(n.formData) : i.body = n.formData;
  }
  return new Request(a, i);
}
function xn(t) {
  let e = new URLSearchParams();
  for (let [r, n] of t.entries())
    e.append(r, typeof n == "string" ? n : n.name);
  return e;
}
function fa(t) {
  let e = new FormData();
  for (let [r, n] of t.entries())
    e.append(r, n);
  return e;
}
function Ho(t, e, r, n, a) {
  let i = {}, s = null, o, l = !1, c = {}, u = r && Ne(r[1]) ? r[1].error : void 0;
  return t.forEach((p) => {
    if (!(p.route.id in e))
      return;
    let h = p.route.id, b = e[h];
    if (z(!pt(b), "Cannot handle redirect results in processLoaderData"), Ne(b)) {
      let S = b.error;
      if (u !== void 0 && (S = u, u = void 0), s = s || {}, a)
        s[h] = S;
      else {
        let j = ht(t, h);
        s[j.route.id] == null && (s[j.route.id] = S);
      }
      i[h] = void 0, l || (l = !0, o = Yr(b.error) ? b.error.status : 500), b.headers && (c[h] = b.headers);
    } else
      it(b) ? (n.set(h, b.deferredData), i[h] = b.deferredData.data, b.statusCode != null && b.statusCode !== 200 && !l && (o = b.statusCode), b.headers && (c[h] = b.headers)) : (i[h] = b.data, b.statusCode && b.statusCode !== 200 && !l && (o = b.statusCode), b.headers && (c[h] = b.headers));
  }), u !== void 0 && r && (s = {
    [r[0]]: u
  }, i[r[0]] = void 0), {
    loaderData: i,
    errors: s,
    statusCode: o || 200,
    loaderHeaders: c
  };
}
function ha(t, e, r, n, a, i, s) {
  let {
    loaderData: o,
    errors: l
  } = Ho(
    e,
    r,
    n,
    s,
    !1
    // This method is only called client side so we always want to bubble
  );
  return a.forEach((c) => {
    let {
      key: u,
      match: p,
      controller: h
    } = c, b = i[u];
    if (z(b, "Did not find corresponding fetcher result"), !(h && h.signal.aborted))
      if (Ne(b)) {
        let S = ht(t.matches, p == null ? void 0 : p.route.id);
        l && l[S.route.id] || (l = re({}, l, {
          [S.route.id]: b.error
        })), t.fetchers.delete(u);
      } else if (pt(b))
        z(!1, "Unhandled fetcher revalidation redirect");
      else if (it(b))
        z(!1, "Unhandled fetcher deferred data");
      else {
        let S = rt(b.data);
        t.fetchers.set(u, S);
      }
  }), {
    loaderData: o,
    errors: l
  };
}
function pa(t, e, r, n) {
  let a = re({}, e);
  for (let i of r) {
    let s = i.route.id;
    if (e.hasOwnProperty(s) ? e[s] !== void 0 && (a[s] = e[s]) : t[s] !== void 0 && i.route.loader && (a[s] = t[s]), n && n.hasOwnProperty(s))
      break;
  }
  return a;
}
function ma(t) {
  return t ? Ne(t[1]) ? {
    // Clear out prior actionData on errors
    actionData: {}
  } : {
    actionData: {
      [t[0]]: t[1].data
    }
  } : {};
}
function ht(t, e) {
  return (e ? t.slice(0, t.findIndex((n) => n.route.id === e) + 1) : [...t]).reverse().find((n) => n.route.hasErrorBoundary === !0) || t[0];
}
function ga(t) {
  let e = t.length === 1 ? t[0] : t.find((r) => r.index || !r.path || r.path === "/") || {
    id: "__shim-error-route__"
  };
  return {
    matches: [{
      params: {},
      pathname: "",
      pathnameBase: "",
      route: e
    }],
    route: e
  };
}
function Re(t, e) {
  let {
    pathname: r,
    routeId: n,
    method: a,
    type: i,
    message: s
  } = e === void 0 ? {} : e, o = "Unknown Server Error", l = "Unknown @remix-run/router error";
  return t === 400 ? (o = "Bad Request", a && r && n ? l = "You made a " + a + ' request to "' + r + '" but ' + ('did not provide a `loader` for route "' + n + '", ') + "so there is no way to handle the request." : i === "defer-action" ? l = "defer() is not supported in actions" : i === "invalid-body" && (l = "Unable to encode submission body")) : t === 403 ? (o = "Forbidden", l = 'Route "' + n + '" does not match URL "' + r + '"') : t === 404 ? (o = "Not Found", l = 'No route matches URL "' + r + '"') : t === 405 && (o = "Method Not Allowed", a && r && n ? l = "You made a " + a.toUpperCase() + ' request to "' + r + '" but ' + ('did not provide an `action` for route "' + n + '", ') + "so there is no way to handle the request." : a && (l = 'Invalid request method "' + a.toUpperCase() + '"')), new zr(t || 500, o, new Error(l), !0);
}
function Sr(t) {
  let e = Object.entries(t);
  for (let r = e.length - 1; r >= 0; r--) {
    let [n, a] = e[r];
    if (pt(a))
      return {
        key: n,
        result: a
      };
  }
}
function Wa(t) {
  let e = typeof t == "string" ? Qe(t) : t;
  return st(re({}, e, {
    hash: ""
  }));
}
function qo(t, e) {
  return t.pathname !== e.pathname || t.search !== e.search ? !1 : t.hash === "" ? e.hash !== "" : t.hash === e.hash ? !0 : e.hash !== "";
}
function Jo(t) {
  return Ya(t.result) && Do.has(t.result.status);
}
function it(t) {
  return t.type === ee.deferred;
}
function Ne(t) {
  return t.type === ee.error;
}
function pt(t) {
  return (t && t.type) === ee.redirect;
}
function ya(t) {
  return typeof t == "object" && t != null && "type" in t && "data" in t && "init" in t && t.type === "DataWithResponseInit";
}
function Wo(t) {
  let e = t;
  return e && typeof e == "object" && typeof e.data == "object" && typeof e.subscribe == "function" && typeof e.cancel == "function" && typeof e.resolveData == "function";
}
function Ya(t) {
  return t != null && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.headers == "object" && typeof t.body < "u";
}
function Yo(t) {
  return Oo.has(t.toLowerCase());
}
function Ve(t) {
  return Lo.has(t.toLowerCase());
}
async function Go(t, e, r, n, a) {
  let i = Object.entries(e);
  for (let s = 0; s < i.length; s++) {
    let [o, l] = i[s], c = t.find((h) => (h == null ? void 0 : h.route.id) === o);
    if (!c)
      continue;
    let u = n.find((h) => h.route.id === c.route.id), p = u != null && !qa(u, c) && (a && a[c.route.id]) !== void 0;
    it(l) && p && await Cn(l, r, !1).then((h) => {
      h && (e[o] = h);
    });
  }
}
async function Zo(t, e, r) {
  for (let n = 0; n < r.length; n++) {
    let {
      key: a,
      routeId: i,
      controller: s
    } = r[n], o = e[a];
    t.find((c) => (c == null ? void 0 : c.route.id) === i) && it(o) && (z(s, "Expected an AbortController for revalidating fetcher deferred result"), await Cn(o, s.signal, !0).then((c) => {
      c && (e[a] = c);
    }));
  }
}
async function Cn(t, e, r) {
  if (r === void 0 && (r = !1), !await t.deferredData.resolveData(e)) {
    if (r)
      try {
        return {
          type: ee.data,
          data: t.deferredData.unwrappedData
        };
      } catch (a) {
        return {
          type: ee.error,
          error: a
        };
      }
    return {
      type: ee.data,
      data: t.deferredData.data
    };
  }
}
function Pn(t) {
  return new URLSearchParams(t).getAll("index").some((e) => e === "");
}
function tr(t, e) {
  let r = typeof e == "string" ? Qe(e).search : e.search;
  if (t[t.length - 1].route.index && Pn(r || ""))
    return t[t.length - 1];
  let n = za(t);
  return n[n.length - 1];
}
function ba(t) {
  let {
    formMethod: e,
    formAction: r,
    formEncType: n,
    text: a,
    formData: i,
    json: s
  } = t;
  if (!(!e || !r || !n)) {
    if (a != null)
      return {
        formMethod: e,
        formAction: r,
        formEncType: n,
        formData: void 0,
        json: void 0,
        text: a
      };
    if (i != null)
      return {
        formMethod: e,
        formAction: r,
        formEncType: n,
        formData: i,
        json: void 0,
        text: void 0
      };
    if (s !== void 0)
      return {
        formMethod: e,
        formAction: r,
        formEncType: n,
        formData: void 0,
        json: s,
        text: void 0
      };
  }
}
function dn(t, e) {
  return e ? {
    state: "loading",
    location: t,
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text
  } : {
    state: "loading",
    location: t,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
  };
}
function Xo(t, e) {
  return {
    state: "submitting",
    location: t,
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text
  };
}
function Xt(t, e) {
  return t ? {
    state: "loading",
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text,
    data: e
  } : {
    state: "loading",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: e
  };
}
function Qo(t, e) {
  return {
    state: "submitting",
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text,
    data: e ? e.data : void 0
  };
}
function rt(t) {
  return {
    state: "idle",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: t
  };
}
function el(t, e) {
  try {
    let r = t.sessionStorage.getItem(Ha);
    if (r) {
      let n = JSON.parse(r);
      for (let [a, i] of Object.entries(n || {}))
        i && Array.isArray(i) && e.set(a, new Set(i || []));
    }
  } catch {
  }
}
function tl(t, e) {
  if (e.size > 0) {
    let r = {};
    for (let [n, a] of e)
      r[n] = [...a];
    try {
      t.sessionStorage.setItem(Ha, JSON.stringify(r));
    } catch (n) {
      he(!1, "Failed to save applied view transitions in sessionStorage (" + n + ").");
    }
  }
}
/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, sr.apply(this, arguments);
}
const $t = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && ($t.displayName = "DataRouter");
const Gr = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (Gr.displayName = "DataRouterState");
const Br = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (Br.displayName = "Await");
const Ae = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (Ae.displayName = "Navigation");
const lr = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (lr.displayName = "Location");
const _e = /* @__PURE__ */ C.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (_e.displayName = "Route");
const Nn = /* @__PURE__ */ C.createContext(null);
process.env.NODE_ENV !== "production" && (Nn.displayName = "RouteError");
function rl(t, e) {
  let {
    relative: r
  } = e === void 0 ? {} : e;
  Mt() || (process.env.NODE_ENV !== "production" ? z(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : z(!1));
  let {
    basename: n,
    navigator: a
  } = C.useContext(Ae), {
    hash: i,
    pathname: s,
    search: o
  } = ur(t, {
    relative: r
  }), l = s;
  return n !== "/" && (l = s === "/" ? n : Je([n, s])), a.createHref({
    pathname: l,
    search: o,
    hash: i
  });
}
function Mt() {
  return C.useContext(lr) != null;
}
function We() {
  return Mt() || (process.env.NODE_ENV !== "production" ? z(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : z(!1)), C.useContext(lr).location;
}
const Ga = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Za(t) {
  C.useContext(Ae).static || C.useLayoutEffect(t);
}
function cr() {
  let {
    isDataRoute: t
  } = C.useContext(_e);
  return t ? pl() : nl();
}
function nl() {
  Mt() || (process.env.NODE_ENV !== "production" ? z(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : z(!1));
  let t = C.useContext($t), {
    basename: e,
    future: r,
    navigator: n
  } = C.useContext(Ae), {
    matches: a
  } = C.useContext(_e), {
    pathname: i
  } = We(), s = JSON.stringify(Jr(a, r.v7_relativeSplatPath)), o = C.useRef(!1);
  return Za(() => {
    o.current = !0;
  }), C.useCallback(function(c, u) {
    if (u === void 0 && (u = {}), process.env.NODE_ENV !== "production" && he(o.current, Ga), !o.current)
      return;
    if (typeof c == "number") {
      n.go(c);
      return;
    }
    let p = Wr(c, JSON.parse(s), i, u.relative === "path");
    t == null && e !== "/" && (p.pathname = p.pathname === "/" ? e : Je([e, p.pathname])), (u.replace ? n.replace : n.push)(p, u.state, u);
  }, [e, n, s, i, t]);
}
const Xa = /* @__PURE__ */ C.createContext(null);
function Ce() {
  return C.useContext(Xa);
}
function al(t) {
  let e = C.useContext(_e).outlet;
  return e && /* @__PURE__ */ C.createElement(Xa.Provider, {
    value: t
  }, e);
}
function Qa() {
  let {
    matches: t
  } = C.useContext(_e), e = t[t.length - 1];
  return e ? e.params : {};
}
function ur(t, e) {
  let {
    relative: r
  } = e === void 0 ? {} : e, {
    future: n
  } = C.useContext(Ae), {
    matches: a
  } = C.useContext(_e), {
    pathname: i
  } = We(), s = JSON.stringify(Jr(a, n.v7_relativeSplatPath));
  return C.useMemo(() => Wr(t, JSON.parse(s), i, r === "path"), [t, s, i, r]);
}
function il(t, e, r, n) {
  Mt() || (process.env.NODE_ENV !== "production" ? z(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : z(!1));
  let {
    navigator: a
  } = C.useContext(Ae), {
    matches: i
  } = C.useContext(_e), s = i[i.length - 1], o = s ? s.params : {}, l = s ? s.pathname : "/", c = s ? s.pathnameBase : "/", u = s && s.route;
  if (process.env.NODE_ENV !== "production") {
    let v = u && u.path || "";
    ni(l, !u || v.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + l + '" (under <Route path="' + v + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + v + '"> to <Route ') + ('path="' + (v === "/" ? "*" : v + "/*") + '">.'));
  }
  let p = We(), h;
  if (e) {
    var b;
    let v = typeof e == "string" ? Qe(e) : e;
    c === "/" || (b = v.pathname) != null && b.startsWith(c) || (process.env.NODE_ENV !== "production" ? z(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + c + '" ') + ('but pathname "' + v.pathname + '" was given in the `location` prop.')) : z(!1)), h = v;
  } else
    h = p;
  let S = h.pathname || "/", j = S;
  if (c !== "/") {
    let v = c.replace(/^\//, "").split("/");
    j = "/" + S.replace(/^\//, "").split("/").slice(v.length).join("/");
  }
  let E = ft(t, {
    pathname: j
  });
  process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && he(u || E != null, 'No routes matched location "' + h.pathname + h.search + h.hash + '" '), process.env.NODE_ENV !== "production" && he(E == null || E[E.length - 1].route.element !== void 0 || E[E.length - 1].route.Component !== void 0 || E[E.length - 1].route.lazy !== void 0, 'Matched leaf route at location "' + h.pathname + h.search + h.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let P = ul(E && E.map((v) => Object.assign({}, v, {
    params: Object.assign({}, o, v.params),
    pathname: Je([
      c,
      // Re-encode pathnames that were decoded inside matchRoutes
      a.encodeLocation ? a.encodeLocation(v.pathname).pathname : v.pathname
    ]),
    pathnameBase: v.pathnameBase === "/" ? c : Je([
      c,
      // Re-encode pathnames that were decoded inside matchRoutes
      a.encodeLocation ? a.encodeLocation(v.pathnameBase).pathname : v.pathnameBase
    ])
  })), i, r, n);
  return e && P ? /* @__PURE__ */ C.createElement(lr.Provider, {
    value: {
      location: sr({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, h),
      navigationType: oe.Pop
    }
  }, P) : P;
}
function sl() {
  let t = ri(), e = Yr(t) ? t.status + " " + t.statusText : t instanceof Error ? t.message : JSON.stringify(t), r = t instanceof Error ? t.stack : null, n = "rgba(200,200,200, 0.5)", a = {
    padding: "0.5rem",
    backgroundColor: n
  }, i = {
    padding: "2px 4px",
    backgroundColor: n
  }, s = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", t), s = /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ C.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ C.createElement("code", {
    style: i
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ C.createElement("code", {
    style: i
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ C.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, e), r ? /* @__PURE__ */ C.createElement("pre", {
    style: a
  }, r) : null, s);
}
const ol = /* @__PURE__ */ C.createElement(sl, null);
class ll extends C.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return {
      error: e
    };
  }
  static getDerivedStateFromProps(e, r) {
    return r.location !== e.location || r.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : r.error,
      location: r.location,
      revalidation: e.revalidation || r.revalidation
    };
  }
  componentDidCatch(e, r) {
    console.error("React Router caught the following error during render", e, r);
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ C.createElement(_e.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ C.createElement(Nn.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function cl(t) {
  let {
    routeContext: e,
    match: r,
    children: n
  } = t, a = C.useContext($t);
  return a && a.static && a.staticContext && (r.route.errorElement || r.route.ErrorBoundary) && (a.staticContext._deepestRenderedBoundaryId = r.route.id), /* @__PURE__ */ C.createElement(_e.Provider, {
    value: e
  }, n);
}
function ul(t, e, r, n) {
  var a;
  if (e === void 0 && (e = []), r === void 0 && (r = null), n === void 0 && (n = null), t == null) {
    var i;
    if (!r)
      return null;
    if (r.errors)
      t = r.matches;
    else if ((i = n) != null && i.v7_partialHydration && e.length === 0 && !r.initialized && r.matches.length > 0)
      t = r.matches;
    else
      return null;
  }
  let s = t, o = (a = r) == null ? void 0 : a.errors;
  if (o != null) {
    let u = s.findIndex((p) => p.route.id && (o == null ? void 0 : o[p.route.id]) !== void 0);
    u >= 0 || (process.env.NODE_ENV !== "production" ? z(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(o).join(",")) : z(!1)), s = s.slice(0, Math.min(s.length, u + 1));
  }
  let l = !1, c = -1;
  if (r && n && n.v7_partialHydration)
    for (let u = 0; u < s.length; u++) {
      let p = s[u];
      if ((p.route.HydrateFallback || p.route.hydrateFallbackElement) && (c = u), p.route.id) {
        let {
          loaderData: h,
          errors: b
        } = r, S = p.route.loader && h[p.route.id] === void 0 && (!b || b[p.route.id] === void 0);
        if (p.route.lazy || S) {
          l = !0, c >= 0 ? s = s.slice(0, c + 1) : s = [s[0]];
          break;
        }
      }
    }
  return s.reduceRight((u, p, h) => {
    let b, S = !1, j = null, E = null;
    r && (b = o && p.route.id ? o[p.route.id] : void 0, j = p.route.errorElement || ol, l && (c < 0 && h === 0 ? (ni("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), S = !0, E = null) : c === h && (S = !0, E = p.route.hydrateFallbackElement || null)));
    let P = e.concat(s.slice(0, h + 1)), v = () => {
      let O;
      return b ? O = j : S ? O = E : p.route.Component ? O = /* @__PURE__ */ C.createElement(p.route.Component, null) : p.route.element ? O = p.route.element : O = u, /* @__PURE__ */ C.createElement(cl, {
        match: p,
        routeContext: {
          outlet: u,
          matches: P,
          isDataRoute: r != null
        },
        children: O
      });
    };
    return r && (p.route.ErrorBoundary || p.route.errorElement || h === 0) ? /* @__PURE__ */ C.createElement(ll, {
      location: r.location,
      revalidation: r.revalidation,
      component: j,
      error: b,
      children: v(),
      routeContext: {
        outlet: null,
        matches: P,
        isDataRoute: !0
      }
    }) : v();
  }, null);
}
var ei = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t;
}(ei || {}), gt = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseLoaderData = "useLoaderData", t.UseActionData = "useActionData", t.UseRouteError = "useRouteError", t.UseNavigation = "useNavigation", t.UseRouteLoaderData = "useRouteLoaderData", t.UseMatches = "useMatches", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t.UseRouteId = "useRouteId", t;
}(gt || {});
function Ln(t) {
  return t + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function dl(t) {
  let e = C.useContext($t);
  return e || (process.env.NODE_ENV !== "production" ? z(!1, Ln(t)) : z(!1)), e;
}
function ti(t) {
  let e = C.useContext(Gr);
  return e || (process.env.NODE_ENV !== "production" ? z(!1, Ln(t)) : z(!1)), e;
}
function fl(t) {
  let e = C.useContext(_e);
  return e || (process.env.NODE_ENV !== "production" ? z(!1, Ln(t)) : z(!1)), e;
}
function Zr(t) {
  let e = fl(t), r = e.matches[e.matches.length - 1];
  return r.route.id || (process.env.NODE_ENV !== "production" ? z(!1, t + ' can only be used on routes that contain a unique "id"') : z(!1)), r.route.id;
}
function hl() {
  return Zr(gt.UseRouteId);
}
function dr() {
  let t = ti(gt.UseLoaderData), e = Zr(gt.UseLoaderData);
  if (t.errors && t.errors[e] != null) {
    console.error("You cannot `useLoaderData` in an errorElement (routeId: " + e + ")");
    return;
  }
  return t.loaderData[e];
}
function ri() {
  var t;
  let e = C.useContext(Nn), r = ti(gt.UseRouteError), n = Zr(gt.UseRouteError);
  return e !== void 0 ? e : (t = r.errors) == null ? void 0 : t[n];
}
function ye() {
  let t = C.useContext(Br);
  return t == null ? void 0 : t._data;
}
function pl() {
  let {
    router: t
  } = dl(ei.UseNavigateStable), e = Zr(gt.UseNavigateStable), r = C.useRef(!1);
  return Za(() => {
    r.current = !0;
  }), C.useCallback(function(a, i) {
    i === void 0 && (i = {}), process.env.NODE_ENV !== "production" && he(r.current, Ga), r.current && (typeof a == "number" ? t.navigate(a) : t.navigate(a, sr({
      fromRouteId: e
    }, i)));
  }, [t, e]);
}
const va = {};
function ni(t, e, r) {
  !e && !va[t] && (va[t] = !0, process.env.NODE_ENV !== "production" && he(!1, r));
}
function ml(t) {
  let {
    to: e,
    replace: r,
    state: n,
    relative: a
  } = t;
  Mt() || (process.env.NODE_ENV !== "production" ? z(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component."
  ) : z(!1));
  let {
    future: i,
    static: s
  } = C.useContext(Ae);
  process.env.NODE_ENV !== "production" && he(!s, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
  let {
    matches: o
  } = C.useContext(_e), {
    pathname: l
  } = We(), c = cr(), u = Wr(e, Jr(o, i.v7_relativeSplatPath), l, a === "path"), p = JSON.stringify(u);
  return C.useEffect(() => c(JSON.parse(p), {
    replace: r,
    state: n,
    relative: a
  }), [c, p, a, r, n]), null;
}
function gl(t) {
  return al(t.context);
}
function yl(t) {
  let {
    basename: e = "/",
    children: r = null,
    location: n,
    navigationType: a = oe.Pop,
    navigator: i,
    static: s = !1,
    future: o
  } = t;
  Mt() && (process.env.NODE_ENV !== "production" ? z(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : z(!1));
  let l = e.replace(/^\/*/, "/"), c = C.useMemo(() => ({
    basename: l,
    navigator: i,
    static: s,
    future: sr({
      v7_relativeSplatPath: !1
    }, o)
  }), [l, o, i, s]);
  typeof n == "string" && (n = Qe(n));
  let {
    pathname: u = "/",
    search: p = "",
    hash: h = "",
    state: b = null,
    key: S = "default"
  } = n, j = C.useMemo(() => {
    let E = ze(u, l);
    return E == null ? null : {
      location: {
        pathname: E,
        search: p,
        hash: h,
        state: b,
        key: S
      },
      navigationType: a
    };
  }, [l, u, p, h, b, S, a]);
  return process.env.NODE_ENV !== "production" && he(j != null, '<Router basename="' + l + '"> is not able to match the URL ' + ('"' + u + p + h + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), j == null ? null : /* @__PURE__ */ C.createElement(Ae.Provider, {
    value: c
  }, /* @__PURE__ */ C.createElement(lr.Provider, {
    children: r,
    value: j
  }));
}
function kn(t) {
  let {
    children: e,
    errorElement: r,
    resolve: n
  } = t;
  return /* @__PURE__ */ C.createElement(vl, {
    resolve: n,
    errorElement: r
  }, /* @__PURE__ */ C.createElement(xl, null, e));
}
var Oe = /* @__PURE__ */ function(t) {
  return t[t.pending = 0] = "pending", t[t.success = 1] = "success", t[t.error = 2] = "error", t;
}(Oe || {});
const bl = new Promise(() => {
});
class vl extends C.Component {
  constructor(e) {
    super(e), this.state = {
      error: null
    };
  }
  static getDerivedStateFromError(e) {
    return {
      error: e
    };
  }
  componentDidCatch(e, r) {
    console.error("<Await> caught the following error during render", e, r);
  }
  render() {
    let {
      children: e,
      errorElement: r,
      resolve: n
    } = this.props, a = null, i = Oe.pending;
    if (!(n instanceof Promise))
      i = Oe.success, a = Promise.resolve(), Object.defineProperty(a, "_tracked", {
        get: () => !0
      }), Object.defineProperty(a, "_data", {
        get: () => n
      });
    else if (this.state.error) {
      i = Oe.error;
      let s = this.state.error;
      a = Promise.reject().catch(() => {
      }), Object.defineProperty(a, "_tracked", {
        get: () => !0
      }), Object.defineProperty(a, "_error", {
        get: () => s
      });
    } else
      n._tracked ? (a = n, i = "_error" in a ? Oe.error : "_data" in a ? Oe.success : Oe.pending) : (i = Oe.pending, Object.defineProperty(n, "_tracked", {
        get: () => !0
      }), a = n.then((s) => Object.defineProperty(n, "_data", {
        get: () => s
      }), (s) => Object.defineProperty(n, "_error", {
        get: () => s
      })));
    if (i === Oe.error && a._error instanceof yn)
      throw bl;
    if (i === Oe.error && !r)
      throw a._error;
    if (i === Oe.error)
      return /* @__PURE__ */ C.createElement(Br.Provider, {
        value: a,
        children: r
      });
    if (i === Oe.success)
      return /* @__PURE__ */ C.createElement(Br.Provider, {
        value: a,
        children: e
      });
    throw a;
  }
}
function xl(t) {
  let {
    children: e
  } = t, r = ye(), n = typeof e == "function" ? e(r) : e;
  return /* @__PURE__ */ C.createElement(C.Fragment, null, n);
}
function wl(t) {
  let e = {
    // Note: this check also occurs in createRoutesFromChildren so update
    // there if you change this -- please and thank you!
    hasErrorBoundary: t.ErrorBoundary != null || t.errorElement != null
  };
  return t.Component && (process.env.NODE_ENV !== "production" && t.element && process.env.NODE_ENV !== "production" && he(!1, "You should not include both `Component` and `element` on your route - `Component` will be used."), Object.assign(e, {
    element: /* @__PURE__ */ C.createElement(t.Component),
    Component: void 0
  })), t.HydrateFallback && (process.env.NODE_ENV !== "production" && t.hydrateFallbackElement && process.env.NODE_ENV !== "production" && he(!1, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used."), Object.assign(e, {
    hydrateFallbackElement: /* @__PURE__ */ C.createElement(t.HydrateFallback),
    HydrateFallback: void 0
  })), t.ErrorBoundary && (process.env.NODE_ENV !== "production" && t.errorElement && process.env.NODE_ENV !== "production" && he(!1, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used."), Object.assign(e, {
    errorElement: /* @__PURE__ */ C.createElement(t.ErrorBoundary),
    ErrorBoundary: void 0
  })), e;
}
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ot() {
  return ot = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ot.apply(this, arguments);
}
function On(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
const kr = "get", Or = "application/x-www-form-urlencoded";
function Xr(t) {
  return t != null && typeof t.tagName == "string";
}
function El(t) {
  return Xr(t) && t.tagName.toLowerCase() === "button";
}
function Sl(t) {
  return Xr(t) && t.tagName.toLowerCase() === "form";
}
function Rl(t) {
  return Xr(t) && t.tagName.toLowerCase() === "input";
}
function jl(t) {
  return !!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
}
function Cl(t, e) {
  return t.button === 0 && // Ignore everything but left clicks
  (!e || e === "_self") && // Let browser handle "target=_blank" etc.
  !jl(t);
}
function wn(t) {
  return t === void 0 && (t = ""), new URLSearchParams(typeof t == "string" || Array.isArray(t) || t instanceof URLSearchParams ? t : Object.keys(t).reduce((e, r) => {
    let n = t[r];
    return e.concat(Array.isArray(n) ? n.map((a) => [r, a]) : [[r, n]]);
  }, []));
}
function Pl(t, e) {
  let r = wn(t);
  return e && e.forEach((n, a) => {
    r.has(a) || e.getAll(a).forEach((i) => {
      r.append(a, i);
    });
  }), r;
}
let Rr = null;
function Nl() {
  if (Rr === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Rr = !1;
    } catch {
      Rr = !0;
    }
  return Rr;
}
const Ll = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function fn(t) {
  return t != null && !Ll.has(t) ? (process.env.NODE_ENV !== "production" && he(!1, '"' + t + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + Or + '"')), null) : t;
}
function kl(t, e) {
  let r, n, a, i, s;
  if (Sl(t)) {
    let o = t.getAttribute("action");
    n = o ? ze(o, e) : null, r = t.getAttribute("method") || kr, a = fn(t.getAttribute("enctype")) || Or, i = new FormData(t);
  } else if (El(t) || Rl(t) && (t.type === "submit" || t.type === "image")) {
    let o = t.form;
    if (o == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let l = t.getAttribute("formaction") || o.getAttribute("action");
    if (n = l ? ze(l, e) : null, r = t.getAttribute("formmethod") || o.getAttribute("method") || kr, a = fn(t.getAttribute("formenctype")) || fn(o.getAttribute("enctype")) || Or, i = new FormData(o, t), !Nl()) {
      let {
        name: c,
        type: u,
        value: p
      } = t;
      if (u === "image") {
        let h = c ? c + "." : "";
        i.append(h + "x", "0"), i.append(h + "y", "0");
      } else
        c && i.append(c, p);
    }
  } else {
    if (Xr(t))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    r = kr, n = null, a = Or, s = t;
  }
  return i && a === "text/plain" && (s = i, i = void 0), {
    action: n,
    method: r.toLowerCase(),
    encType: a,
    formData: i,
    body: s
  };
}
const Ol = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], Dl = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"], Tl = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "viewTransition"], Al = "6";
try {
  window.__reactRouterVersion = Al;
} catch {
}
function _l(t, e) {
  return Io({
    basename: e == null ? void 0 : e.basename,
    future: ot({}, e == null ? void 0 : e.future, {
      v7_prependBasename: !0
    }),
    history: eo({
      window: e == null ? void 0 : e.window
    }),
    hydrationData: (e == null ? void 0 : e.hydrationData) || Il(),
    routes: t,
    mapRouteProperties: wl,
    dataStrategy: e == null ? void 0 : e.dataStrategy,
    patchRoutesOnNavigation: e == null ? void 0 : e.patchRoutesOnNavigation,
    window: e == null ? void 0 : e.window
  }).initialize();
}
function Il() {
  var t;
  let e = (t = window) == null ? void 0 : t.__staticRouterHydrationData;
  return e && e.errors && (e = ot({}, e, {
    errors: Fl(e.errors)
  })), e;
}
function Fl(t) {
  if (!t)
    return null;
  let e = Object.entries(t), r = {};
  for (let [n, a] of e)
    if (a && a.__type === "RouteErrorResponse")
      r[n] = new zr(a.status, a.statusText, a.data, a.internal === !0);
    else if (a && a.__type === "Error") {
      if (a.__subType) {
        let i = window[a.__subType];
        if (typeof i == "function")
          try {
            let s = new i(a.message);
            s.stack = "", r[n] = s;
          } catch {
          }
      }
      if (r[n] == null) {
        let i = new Error(a.message);
        i.stack = "", r[n] = i;
      }
    } else
      r[n] = a;
  return r;
}
const Dn = /* @__PURE__ */ C.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (Dn.displayName = "ViewTransition");
const ai = /* @__PURE__ */ C.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (ai.displayName = "Fetchers");
const $l = "startTransition", xa = C[$l], Ml = "flushSync", wa = Ii[Ml];
function Ul(t) {
  xa ? xa(t) : t();
}
function Qt(t) {
  wa ? wa(t) : t();
}
class Vl {
  constructor() {
    this.status = "pending", this.promise = new Promise((e, r) => {
      this.resolve = (n) => {
        this.status === "pending" && (this.status = "resolved", e(n));
      }, this.reject = (n) => {
        this.status === "pending" && (this.status = "rejected", r(n));
      };
    });
  }
}
function zl(t) {
  let {
    fallbackElement: e,
    router: r,
    future: n
  } = t, [a, i] = C.useState(r.state), [s, o] = C.useState(), [l, c] = C.useState({
    isTransitioning: !1
  }), [u, p] = C.useState(), [h, b] = C.useState(), [S, j] = C.useState(), E = C.useRef(/* @__PURE__ */ new Map()), {
    v7_startTransition: P
  } = n || {}, v = C.useCallback((F) => {
    P ? Ul(F) : F();
  }, [P]), O = C.useCallback((F, I) => {
    let {
      deletedFetchers: U,
      flushSync: W,
      viewTransitionOpts: G
    } = I;
    U.forEach((J) => E.current.delete(J)), F.fetchers.forEach((J, Z) => {
      J.data !== void 0 && E.current.set(Z, J.data);
    });
    let q = r.window == null || r.window.document == null || typeof r.window.document.startViewTransition != "function";
    if (!G || q) {
      W ? Qt(() => i(F)) : v(() => i(F));
      return;
    }
    if (W) {
      Qt(() => {
        h && (u && u.resolve(), h.skipTransition()), c({
          isTransitioning: !0,
          flushSync: !0,
          currentLocation: G.currentLocation,
          nextLocation: G.nextLocation
        });
      });
      let J = r.window.document.startViewTransition(() => {
        Qt(() => i(F));
      });
      J.finished.finally(() => {
        Qt(() => {
          p(void 0), b(void 0), o(void 0), c({
            isTransitioning: !1
          });
        });
      }), Qt(() => b(J));
      return;
    }
    h ? (u && u.resolve(), h.skipTransition(), j({
      state: F,
      currentLocation: G.currentLocation,
      nextLocation: G.nextLocation
    })) : (o(F), c({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: G.currentLocation,
      nextLocation: G.nextLocation
    }));
  }, [r.window, h, u, E, v]);
  C.useLayoutEffect(() => r.subscribe(O), [r, O]), C.useEffect(() => {
    l.isTransitioning && !l.flushSync && p(new Vl());
  }, [l]), C.useEffect(() => {
    if (u && s && r.window) {
      let F = s, I = u.promise, U = r.window.document.startViewTransition(async () => {
        v(() => i(F)), await I;
      });
      U.finished.finally(() => {
        p(void 0), b(void 0), o(void 0), c({
          isTransitioning: !1
        });
      }), b(U);
    }
  }, [v, s, u, r.window]), C.useEffect(() => {
    u && s && a.location.key === s.location.key && u.resolve();
  }, [u, h, a.location, s]), C.useEffect(() => {
    !l.isTransitioning && S && (o(S.state), c({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: S.currentLocation,
      nextLocation: S.nextLocation
    }), j(void 0));
  }, [l.isTransitioning, S]), C.useEffect(() => {
    process.env.NODE_ENV !== "production" && he(e == null || !r.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
  }, []);
  let L = C.useMemo(() => ({
    createHref: r.createHref,
    encodeLocation: r.encodeLocation,
    go: (F) => r.navigate(F),
    push: (F, I, U) => r.navigate(F, {
      state: I,
      preventScrollReset: U == null ? void 0 : U.preventScrollReset
    }),
    replace: (F, I, U) => r.navigate(F, {
      replace: !0,
      state: I,
      preventScrollReset: U == null ? void 0 : U.preventScrollReset
    })
  }), [r]), D = r.basename || "/", g = C.useMemo(() => ({
    router: r,
    navigator: L,
    static: !1,
    basename: D
  }), [r, L, D]), T = C.useMemo(() => ({
    v7_relativeSplatPath: r.future.v7_relativeSplatPath
  }), [r.future.v7_relativeSplatPath]);
  return /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement($t.Provider, {
    value: g
  }, /* @__PURE__ */ C.createElement(Gr.Provider, {
    value: a
  }, /* @__PURE__ */ C.createElement(ai.Provider, {
    value: E.current
  }, /* @__PURE__ */ C.createElement(Dn.Provider, {
    value: l
  }, /* @__PURE__ */ C.createElement(yl, {
    basename: D,
    location: a.location,
    navigationType: a.historyAction,
    navigator: L,
    future: T
  }, a.initialized || r.future.v7_partialHydration ? /* @__PURE__ */ C.createElement(Bl, {
    routes: r.routes,
    future: r.future,
    state: a
  }) : e))))), null);
}
const Bl = /* @__PURE__ */ C.memo(Kl);
function Kl(t) {
  let {
    routes: e,
    future: r,
    state: n
  } = t;
  return il(e, void 0, n, r);
}
process.env.NODE_ENV;
const Hl = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ql = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Tn = /* @__PURE__ */ C.forwardRef(function(e, r) {
  let {
    onClick: n,
    relative: a,
    reloadDocument: i,
    replace: s,
    state: o,
    target: l,
    to: c,
    preventScrollReset: u,
    viewTransition: p
  } = e, h = On(e, Ol), {
    basename: b
  } = C.useContext(Ae), S, j = !1;
  if (typeof c == "string" && ql.test(c) && (S = c, Hl))
    try {
      let O = new URL(window.location.href), L = c.startsWith("//") ? new URL(O.protocol + c) : new URL(c), D = ze(L.pathname, b);
      L.origin === O.origin && D != null ? c = D + L.search + L.hash : j = !0;
    } catch {
      process.env.NODE_ENV !== "production" && he(!1, '<Link to="' + c + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let E = rl(c, {
    relative: a
  }), P = Yl(c, {
    replace: s,
    state: o,
    target: l,
    preventScrollReset: u,
    relative: a,
    viewTransition: p
  });
  function v(O) {
    n && n(O), O.defaultPrevented || P(O);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ C.createElement("a", ot({}, h, {
      href: S || E,
      onClick: j || i ? n : v,
      ref: r,
      target: l
    }))
  );
});
process.env.NODE_ENV !== "production" && (Tn.displayName = "Link");
const Jl = /* @__PURE__ */ C.forwardRef(function(e, r) {
  let {
    "aria-current": n = "page",
    caseSensitive: a = !1,
    className: i = "",
    end: s = !1,
    style: o,
    to: l,
    viewTransition: c,
    children: u
  } = e, p = On(e, Dl), h = ur(l, {
    relative: p.relative
  }), b = We(), S = C.useContext(Gr), {
    navigator: j,
    basename: E
  } = C.useContext(Ae), P = S != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  ec(h) && c === !0, v = j.encodeLocation ? j.encodeLocation(h).pathname : h.pathname, O = b.pathname, L = S && S.navigation && S.navigation.location ? S.navigation.location.pathname : null;
  a || (O = O.toLowerCase(), L = L ? L.toLowerCase() : null, v = v.toLowerCase()), L && E && (L = ze(L, E) || L);
  const D = v !== "/" && v.endsWith("/") ? v.length - 1 : v.length;
  let g = O === v || !s && O.startsWith(v) && O.charAt(D) === "/", T = L != null && (L === v || !s && L.startsWith(v) && L.charAt(v.length) === "/"), F = {
    isActive: g,
    isPending: T,
    isTransitioning: P
  }, I = g ? n : void 0, U;
  typeof i == "function" ? U = i(F) : U = [i, g ? "active" : null, T ? "pending" : null, P ? "transitioning" : null].filter(Boolean).join(" ");
  let W = typeof o == "function" ? o(F) : o;
  return /* @__PURE__ */ C.createElement(Tn, ot({}, p, {
    "aria-current": I,
    className: U,
    ref: r,
    style: W,
    to: l,
    viewTransition: c
  }), typeof u == "function" ? u(F) : u);
});
process.env.NODE_ENV !== "production" && (Jl.displayName = "NavLink");
const ii = /* @__PURE__ */ C.forwardRef((t, e) => {
  let {
    fetcherKey: r,
    navigate: n,
    reloadDocument: a,
    replace: i,
    state: s,
    method: o = kr,
    action: l,
    onSubmit: c,
    relative: u,
    preventScrollReset: p,
    viewTransition: h
  } = t, b = On(t, Tl), S = oi(), j = Ql(l, {
    relative: u
  }), E = o.toLowerCase() === "get" ? "get" : "post", P = (v) => {
    if (c && c(v), v.defaultPrevented)
      return;
    v.preventDefault();
    let O = v.nativeEvent.submitter, L = (O == null ? void 0 : O.getAttribute("formmethod")) || o;
    S(O || v.currentTarget, {
      fetcherKey: r,
      method: L,
      navigate: n,
      replace: i,
      state: s,
      relative: u,
      preventScrollReset: p,
      viewTransition: h
    });
  };
  return /* @__PURE__ */ C.createElement("form", ot({
    ref: e,
    method: E,
    action: j,
    onSubmit: a ? c : P
  }, b));
});
process.env.NODE_ENV !== "production" && (ii.displayName = "Form");
process.env.NODE_ENV;
var Kr;
(function(t) {
  t.UseScrollRestoration = "useScrollRestoration", t.UseSubmit = "useSubmit", t.UseSubmitFetcher = "useSubmitFetcher", t.UseFetcher = "useFetcher", t.useViewTransitionState = "useViewTransitionState";
})(Kr || (Kr = {}));
var Ea;
(function(t) {
  t.UseFetcher = "useFetcher", t.UseFetchers = "useFetchers", t.UseScrollRestoration = "useScrollRestoration";
})(Ea || (Ea = {}));
function Wl(t) {
  return t + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function si(t) {
  let e = C.useContext($t);
  return e || (process.env.NODE_ENV !== "production" ? z(!1, Wl(t)) : z(!1)), e;
}
function Yl(t, e) {
  let {
    target: r,
    replace: n,
    state: a,
    preventScrollReset: i,
    relative: s,
    viewTransition: o
  } = e === void 0 ? {} : e, l = cr(), c = We(), u = ur(t, {
    relative: s
  });
  return C.useCallback((p) => {
    if (Cl(p, r)) {
      p.preventDefault();
      let h = n !== void 0 ? n : st(c) === st(u);
      l(t, {
        replace: h,
        state: a,
        preventScrollReset: i,
        relative: s,
        viewTransition: o
      });
    }
  }, [c, l, u, n, a, r, t, i, s, o]);
}
function xe(t) {
  process.env.NODE_ENV !== "production" && he(typeof URLSearchParams < "u", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let e = C.useRef(wn(t)), r = C.useRef(!1), n = We(), a = C.useMemo(() => (
    // Only merge in the defaults if we haven't yet called setSearchParams.
    // Once we call that we want those to take precedence, otherwise you can't
    // remove a param with setSearchParams({}) if it has an initial value
    Pl(n.search, r.current ? null : e.current)
  ), [n.search]), i = cr(), s = C.useCallback((o, l) => {
    const c = wn(typeof o == "function" ? o(a) : o);
    r.current = !0, i("?" + c, l);
  }, [i, a]);
  return [a, s];
}
function Gl() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let Zl = 0, Xl = () => "__" + String(++Zl) + "__";
function oi() {
  let {
    router: t
  } = si(Kr.UseSubmit), {
    basename: e
  } = C.useContext(Ae), r = hl();
  return C.useCallback(function(n, a) {
    a === void 0 && (a = {}), Gl();
    let {
      action: i,
      method: s,
      encType: o,
      formData: l,
      body: c
    } = kl(n, e);
    if (a.navigate === !1) {
      let u = a.fetcherKey || Xl();
      t.fetch(u, r, a.action || i, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: c,
        formMethod: a.method || s,
        formEncType: a.encType || o,
        flushSync: a.flushSync
      });
    } else
      t.navigate(a.action || i, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: c,
        formMethod: a.method || s,
        formEncType: a.encType || o,
        replace: a.replace,
        state: a.state,
        fromRouteId: r,
        flushSync: a.flushSync,
        viewTransition: a.viewTransition
      });
  }, [t, e, r]);
}
function Ql(t, e) {
  let {
    relative: r
  } = e === void 0 ? {} : e, {
    basename: n
  } = C.useContext(Ae), a = C.useContext(_e);
  a || (process.env.NODE_ENV !== "production" ? z(!1, "useFormAction must be used inside a RouteContext") : z(!1));
  let [i] = a.matches.slice(-1), s = ot({}, ur(t || ".", {
    relative: r
  })), o = We();
  if (t == null) {
    s.search = o.search;
    let l = new URLSearchParams(s.search), c = l.getAll("index");
    if (c.some((p) => p === "")) {
      l.delete("index"), c.filter((h) => h).forEach((h) => l.append("index", h));
      let p = l.toString();
      s.search = p ? "?" + p : "";
    }
  }
  return (!t || t === ".") && i.route.index && (s.search = s.search ? s.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (s.pathname = s.pathname === "/" ? n : Je([n, s.pathname])), st(s);
}
function ec(t, e) {
  e === void 0 && (e = {});
  let r = C.useContext(Dn);
  r == null && (process.env.NODE_ENV !== "production" ? z(!1, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : z(!1));
  let {
    basename: n
  } = si(Kr.useViewTransitionState), a = ur(t, {
    relative: e.relative
  });
  if (!r.isTransitioning)
    return !1;
  let i = ze(r.currentLocation.pathname, n) || r.currentLocation.pathname, s = ze(r.nextLocation.pathname, n) || r.nextLocation.pathname;
  return Vr(a.pathname, s) != null || Vr(a.pathname, i) != null;
}
var rr = {}, er = Fi;
if (process.env.NODE_ENV === "production")
  rr.createRoot = er.createRoot, rr.hydrateRoot = er.hydrateRoot;
else {
  var jr = er.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  rr.createRoot = function(t, e) {
    jr.usingClientEntryPoint = !0;
    try {
      return er.createRoot(t, e);
    } finally {
      jr.usingClientEntryPoint = !1;
    }
  }, rr.hydrateRoot = function(t, e, r) {
    jr.usingClientEntryPoint = !0;
    try {
      return er.hydrateRoot(t, e, r);
    } finally {
      jr.usingClientEntryPoint = !1;
    }
  };
}
const tc = ({ ty: t }) => {
  const {
    data: { hiddenPosition: e, referralEnabled: r, title: n }
  } = ye(), { t: a } = le("header"), i = () => {
    switch (!0) {
      case e:
        return "hiddenPosition";
      case r:
        return "referralEnabled";
      default:
        return "generic";
    }
  };
  return /* @__PURE__ */ f.jsxs("header", { className: "jobs-header grid items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        className: "jobs-header__img col-start-1 col-span-1 row-start-1 row-span-1 overflow-hidden h-full object-right-top",
        src: "https://dam-media.reply.com/production/8/8/668cc55f-b55b-78aa-54cf-c8e061664c64/4e801eb2-eb9c-41d2-a196-469de1e74fea.jpg",
        width: "100%"
      }
    ),
    /* @__PURE__ */ f.jsxs("div", { className: "grid-w/padding col-start-1 col-span-1 row-start-1 row-span-1", children: [
      /* @__PURE__ */ f.jsx("h1", { className: "h1--light text-white col-span-full lg:col-start-3 lg:col-end-11 text-center mb-6", children: a(t ? "thankyou" : `application.${i()}`).toLocaleUpperCase() }),
      /* @__PURE__ */ f.jsx("h2", { className: "h3--light text-white col-span-full lg:col-start-3 lg:col-end-11 text-center", children: n })
    ] })
  ] });
}, rc = () => {
  const {
    data: { primary_role: t, title: e }
  } = ye();
  let r;
  switch (t == null ? void 0 : t.key) {
    case "career_starter":
      r = "https://dam-media.reply.com/production/17/81/df66d657-58c2-63e7-eecf-e2b7792954f0/e5979e97-0040-42c9-9752-1eea39b44864.jpg";
      break;
    case "student":
      r = "https://dam-media.reply.com/production/5/5/4403a094-361a-e375-3fe2-5ae4834e90e9/68421431-f2c4-4589-a1fe-c0c09db11d96.jpg";
      break;
    case "professional":
      r = "https://dam-media.reply.com/production/17/81/195820c7-4df3-08ea-f047-81e42fabb5c6/5766c3f8-b67d-4946-8533-4289c2aeafac.jpg";
      break;
    default:
      r = "";
  }
  return /* @__PURE__ */ f.jsxs("header", { className: "jobs-header grid items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        className: "jobs-header__img col-start-1 col-span-1 row-start-1 row-span-1 overflow-hidden h-full object-right-top",
        src: r,
        width: "100%",
        alt: ""
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: "grid-w/padding col-start-1 col-span-1 row-start-1 row-span-1", children: /* @__PURE__ */ f.jsx("h1", { className: "text-c0k7h text-white col-span-full lg:col-start-3 lg:col-end-11 text-center", children: e }) })
  ] });
}, nc = () => {
  const [t] = xe();
  let e;
  const r = t.get("city");
  r && (e = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        className: "col-start-1 col-span-1 row-start-1 row-span-1 overflow-hidden",
        src: `/contents/careers_city_${r}.jpeg`,
        alt: "",
        onLoad: (i) => {
          i.currentTarget.style.height = "100%", i.currentTarget.style.width = "100%", i.currentTarget.nextElementSibling && (i.currentTarget.nextElementSibling.style.height = "100%", i.currentTarget.nextElementSibling.style.width = "100%");
        },
        onError: (i) => {
          i.currentTarget.style.height = "0", i.currentTarget.style.width = "0", i.currentTarget.nextElementSibling && (i.currentTarget.nextElementSibling.style.height = "0", i.currentTarget.nextElementSibling.style.width = "0");
        }
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: "jobs-header__dark-layer col-start-1 col-span-1 row-start-1 row-span-1" })
  ] }));
  let n;
  const a = t.get("company");
  return a && (n = /* @__PURE__ */ f.jsx(
    "img",
    {
      className: "jobs-header__logo col-start-1 col-span-1 row-start-1 row-span-1 justify-self-center self-start top-1/4 md:top-[20%]",
      src: `/contents/careers_logo_${a}.png`,
      alt: ""
    }
  )), /* @__PURE__ */ f.jsxs("header", { className: "jobs-header jobs-header--search grid items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        className: "col-start-1 col-span-1 row-start-1 row-span-1 overflow-hidden h-full w-full object-right-top",
        src: "https://dam-media.reply.com/production/8/8/668cc55f-b55b-78aa-54cf-c8e061664c64/4e801eb2-eb9c-41d2-a196-469de1e74fea.jpg",
        alt: ""
      }
    ),
    e,
    n,
    /* @__PURE__ */ f.jsx("div", { className: "grid-w/padding col-start-1 col-span-1 row-start-1 row-span-1", children: /* @__PURE__ */ f.jsxs("h1", { className: "text-white col-span-full lg:col-start-3 lg:col-end-11 text-center leading-none text-6xl md:text-7xl xl:text-8xl", children: [
      "Prototype the future",
      /* @__PURE__ */ f.jsx("br", {}),
      "with us"
    ] }) })
  ] });
};
const An = ({ type: t, ty: e }) => {
  switch (t) {
    case "search":
      return /* @__PURE__ */ f.jsx(nc, {});
    case "details":
      return /* @__PURE__ */ f.jsx(rc, {});
    case "application":
      return /* @__PURE__ */ f.jsx(tc, { ty: e });
    default:
      return null;
  }
}, li = Hr(new URLSearchParams()), ci = Hr(() => {
}), ac = ({ children: t }) => {
  const [e, r] = je(new URLSearchParams());
  return /* @__PURE__ */ f.jsx(li.Provider, { value: e, children: /* @__PURE__ */ f.jsx(ci.Provider, { value: r, children: t }) });
}, ic = () => or(li), sc = () => or(ci), _n = {
  country: {
    options: [
      {
        key: "at",
        label: "Austria"
      },
      {
        key: "be",
        label: "Belgium"
      },
      {
        key: "br",
        label: "Brazil"
      },
      {
        key: "hr",
        label: "Croatia"
      },
      {
        key: "fr",
        label: "France"
      },
      {
        key: "de",
        label: "Germany"
      },
      {
        key: "in",
        label: "India"
      },
      {
        key: "it",
        label: "Italy"
      },
      {
        key: "lu",
        label: "Luxembourg"
      },
      {
        key: "pl",
        label: "Poland"
      },
      {
        key: "ro",
        label: "Romania"
      },
      {
        key: "uk",
        label: "UK"
      },
      {
        key: "us",
        label: "USA"
      }
    ]
  },
  city: {
    options: []
  },
  company: {
    options: []
  },
  role: {
    options: [
      {
        key: "student",
        label: "student"
      },
      {
        key: "career_starter",
        label: "career_starter"
      },
      {
        key: "professional",
        label: "professional"
      }
    ]
  },
  area: {
    options: [
      {
        key: "technology",
        label: "Technology"
      },
      {
        key: "creative",
        label: "Creative"
      },
      {
        key: "consulting",
        label: "Consulting"
      }
    ]
  },
  interest: {
    options: [
      {
        key: "agile_development",
        label: "Agile Development"
      },
      {
        key: "ai_machine_learning",
        label: "AI & Machine Learning"
      },
      {
        key: "gamification",
        label: "AR/VR & Gamification"
      },
      {
        key: "bd_analytics",
        label: "Big Data & Analytics"
      },
      {
        key: "cloud_computing",
        label: "Cloud Computing"
      },
      {
        key: "data_driven_marketing",
        label: "Data Driven Marketing"
      },
      {
        key: "digital_experience",
        label: "Digital Experience"
      },
      {
        key: "digital_service",
        label: "Digital Services"
      },
      {
        key: "finance",
        label: "Finance"
      },
      {
        key: "industry",
        label: "Industry 4.0"
      },
      {
        key: "iot",
        label: "Internet of Things (IoT)"
      },
      {
        key: "process_automation",
        label: "Process Automation"
      },
      {
        key: "risk_management",
        label: "Risk Management & Financial Services Consulting"
      },
      {
        key: "security",
        label: "Security"
      },
      {
        key: "sustainablity",
        label: "Sustainability"
      },
      {
        key: "ux_ui",
        label: "UX/UI"
      }
    ]
  }
}, _t = (t) => {
  var r, n;
  let e;
  switch (t.type) {
    case "city":
    case "company":
      e = t.list.map(({ code: a, value: i }) => ({ key: a, label: i }));
      break;
    default:
      e = (r = _n[t.type]) == null ? void 0 : r.options;
  }
  return (n = e.find(({ key: a }) => a === t.key)) == null ? void 0 : n.label;
}, nt = (t) => {
  const [e] = xe(), { cities: r, companies: n } = dr(), a = e.get(t);
  let i;
  switch (t) {
    case "city":
      i = _t({ key: a, list: r, type: t });
      break;
    case "company":
      i = _t({ key: a, list: n, type: t });
      break;
    default:
      i = _t({ key: a, type: t });
  }
  if (a && !i) {
    console.error(`There's no option with key "${a}" inside "${t}"`);
    return;
  }
  return i;
}, oc = () => {
  const t = nt("city"), e = nt("company"), r = nt("country"), n = nt("role"), a = nt("area"), i = nt("interest");
  return { area: a, city: t, company: e, country: r, interest: i, role: n };
}, ui = (t, e, r, n, a) => {
  const { language: i } = Ce(), s = nt("country");
  return () => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      event: "jobPositionClick",
      title: a,
      language: i,
      country: s,
      jobId: r,
      reply_company: (e == null ? void 0 : e.label) || "not_present",
      job_level: n == null ? void 0 : n.label,
      job_location: t.map(({ label: o }) => o).join(", ")
    }), window.dataLayer.push({
      event: "jobFunnelLanding",
      title: a,
      language: i,
      country: s,
      jobId: r,
      reply_company: (e == null ? void 0 : e.label) || "not_present",
      job_level: n == null ? void 0 : n.label,
      job_location: t.map(({ label: o }) => o).join(", "),
      page_type: "Job position click"
    });
  };
}, lc = ({ city: t, company: e, external_job_link: r, id: n, primary_role: a, title: i }) => {
  const s = ui(t, e, n, a, i);
  return /* @__PURE__ */ f.jsx(
    "a",
    {
      href: r,
      className: "job-result",
      target: "_blank",
      rel: "noopener",
      title: i,
      onClick: () => s(),
      children: /* @__PURE__ */ f.jsxs("article", { className: "jobs-table__row grid py-6 px-4", children: [
        /* @__PURE__ */ f.jsx("h3", { className: "jobs-table__col-1 paragraph-02--medium", children: i.toLocaleUpperCase() }),
        /* @__PURE__ */ f.jsx("div", { className: "jobs-table__col-2 paragraph-02--light", children: t.map(({ label: o }) => o).join(", ") }),
        /* @__PURE__ */ f.jsx("div", { className: "jobs-table__col-3 paragraph-02--medium", children: e == null ? void 0 : e.label })
      ] })
    }
  );
}, cc = ({ city: t, company: e, id: r, primary_role: n, title: a }) => {
  const i = ui(t, e, r, n, a), [s] = xe(), o = sc();
  return /* @__PURE__ */ f.jsx(
    Tn,
    {
      to: `/job-details/${r}?${s}`,
      className: "job-result",
      title: a,
      onClick: () => {
        o(s), i();
      },
      children: /* @__PURE__ */ f.jsxs("article", { className: "jobs-table__row grid py-6 px-4", children: [
        /* @__PURE__ */ f.jsx("h3", { className: "jobs-table__col-1 paragraph-02--medium", children: a.toLocaleUpperCase() }),
        /* @__PURE__ */ f.jsx("div", { className: "jobs-table__col-2 paragraph-02--light", children: t.map(({ label: l }) => l).join(", ") }),
        /* @__PURE__ */ f.jsx("div", { className: "jobs-table__col-3 paragraph-02--medium", children: e == null ? void 0 : e.label })
      ] })
    }
  );
};
const uc = () => {
  const {
    data: {
      total: { value: t }
    }
  } = ye(), [e] = xe(), r = Number(e.get("page")) || 1, n = Math.ceil(t / 10);
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      "aria-label": "Next page",
      name: "page",
      value: r + 1,
      disabled: r === n,
      className: "border-none p-0 bg-transparent",
      children: /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", height: "24", width: "24", children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "m16.15 7.65 4 4 .35.35-.35.35-4 4-.71-.7 3.15-3.15H4.29v-1h14.3l-3.15-3.15.7-.7Z",
          clipRule: "evenodd"
        }
      ) })
    }
  );
}, Cr = ({ value: t }) => {
  const [e] = xe(), r = Number(e.get("page")) || 1;
  return /* @__PURE__ */ f.jsx(
    "input",
    {
      type: "submit",
      name: "page",
      value: t,
      className: `bg-transparent border-none font-normal${r === t ? " active" : ""}`
    }
  );
}, dc = () => {
  const [t] = xe(), e = Number(t.get("page")) || 1;
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      "aria-label": "Previous page",
      name: "page",
      value: e - 1,
      disabled: e < 2,
      className: "border-none p-0 bg-transparent",
      children: /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", height: "24", width: "24", children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "m8.65 7.65-4 4-.36.35.36.35 4 4 .7-.7-3.14-3.15H20.5v-1H6.2l3.15-3.15-.7-.7Z",
          clipRule: "evenodd"
        }
      ) })
    }
  );
}, fc = () => {
  const {
    data: { total: t }
  } = ye();
  return Math.ceil((t == null ? void 0 : t.value) / 10 || 0) <= 1 ? null : /* @__PURE__ */ f.jsxs("div", { className: "serp__paginator paragraph-01--medium flex gap-x-4 mx-auto", children: [
    /* @__PURE__ */ f.jsx(dc, {}),
    /* @__PURE__ */ f.jsx("div", { className: "flex gap-x-2", children: /* @__PURE__ */ f.jsx(hc, {}) }),
    /* @__PURE__ */ f.jsx(uc, {})
  ] });
}, hc = () => {
  const {
    data: {
      total: { value: t }
    }
  } = ye(), e = Math.ceil(t / 10), [r] = xe(), n = Number(r.get("page")) || 1;
  return e <= 3 ? /* @__PURE__ */ f.jsx(f.Fragment, { children: Array(e).fill(1).map((a, i) => /* @__PURE__ */ f.jsx(Cr, { value: i + 1 }, i)) }) : n <= 2 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    Array(Math.max(3, n + 1)).fill(1).map((a, i) => /* @__PURE__ */ f.jsx(Cr, { value: i + 1 }, i)),
    /* @__PURE__ */ f.jsx(Pr, {})
  ] }) : n >= e - 1 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(Pr, {}),
    Array(Math.max(3, e - n + 1)).fill(1).map((a, i) => /* @__PURE__ */ f.jsx(Cr, { value: e - i }, i)).reverse()
  ] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(Pr, {}),
    [n - 1, n, n + 1].map((a, i) => /* @__PURE__ */ f.jsx(Cr, { value: a }, i)),
    /* @__PURE__ */ f.jsx(Pr, {})
  ] });
}, Pr = () => /* @__PURE__ */ f.jsx("div", { className: "!leading-6 !cursor-default", children: "…" }), pc = () => {
  const {
    data: { items: t, total: e }
  } = ye(), [r] = xe(), n = ve(!0), a = ve([]), { area: i, city: s, company: o, country: l, interest: c, role: u } = oc();
  return a.current !== t && (a.current = t, window.dataLayer = window.dataLayer || [], window.dataLayer.push({
    event: n.current ? "job_listing_page_landing" : "job_position_search_listing_page",
    eventCategory: "Job search landing page",
    eventAction: `${l} - ${s || "not_present"}`,
    eventLabel: o || "All Reply Companies",
    keyword: r.get("q") || "not_present",
    senority: u || "All Senority Levels",
    areas: i || "All Areas",
    interests: c || "All Interest",
    numberResults: e == null ? void 0 : e.value
  }), n.current && (n.current = !1)), t;
}, mc = () => {
  const t = pc(), { t: e } = le("jobSearch", { keyPrefix: "results" });
  return t.length ? /* @__PURE__ */ f.jsxs("div", { className: "xl:col-start-2 xl:col-end-12 -mx-4 flex flex-col gap-y-6 md:gap-y-14", children: [
    /* @__PURE__ */ f.jsxs("div", { children: [
      /* @__PURE__ */ f.jsxs("div", { className: "jobs-table__row hidden md:grid mb-6 px-4", children: [
        /* @__PURE__ */ f.jsx("h2", { className: "jobs-table__col-1 label--xsmall-upcase color-70", children: e("opportunities") }),
        /* @__PURE__ */ f.jsx("h2", { className: "jobs-table__col-2 label--xsmall-upcase color-70", children: e("locations") }),
        /* @__PURE__ */ f.jsx("h2", { className: "jobs-table__col-3 label--xsmall-upcase color-70", children: e("companies") })
      ] }),
      t.map((r) => r.external_job_link ? /* @__PURE__ */ f.jsx(lc, { ...r }, r.id) : /* @__PURE__ */ f.jsx(cc, { ...r }, r.id))
    ] }),
    /* @__PURE__ */ f.jsx(fc, {})
  ] }) : /* @__PURE__ */ f.jsx("div", { className: "xl:col-start-2 xl:col-end-12", children: /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--medium", children: e("noResults") }) });
}, In = ({ className: t = "", scaleFactor: e = "100" }) => /* @__PURE__ */ f.jsxs("div", { className: `${t} lds-spinner scale-${e}`, children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] }), gc = () => /* @__PURE__ */ f.jsx("section", { className: "block col-span-full text-center", children: /* @__PURE__ */ f.jsx(In, { scaleFactor: "150" }) }), di = () => /* @__PURE__ */ f.jsx("section", { className: "full-page-spinner grid place-items-center", children: /* @__PURE__ */ f.jsx(In, { scaleFactor: "250" }) }), yc = () => {
  const { results: t } = dr();
  return /* @__PURE__ */ f.jsx(Sn, { fallback: /* @__PURE__ */ f.jsx(gc, {}), children: /* @__PURE__ */ f.jsx(kn, { resolve: t, children: /* @__PURE__ */ f.jsx(mc, {}) }) });
}, bc = ({ onClick: t }) => /* @__PURE__ */ f.jsx("button", { type: "submit", className: "bg-transparent border-none p-0", onClick: t, children: /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "#8D99A5", viewBox: "0 0 24 24", width: "24", height: "24", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "m12 13.41-6.93 6.93-1.41-1.41L10.59 12 3.66 5.07l1.41-1.41L12 10.59l6.93-6.93 1.41 1.41L13.41 12l6.93 6.93-1.41 1.41L12 13.41Z",
    clipRule: "evenodd"
  }
) }) }), vc = ka((t, e) => /* @__PURE__ */ f.jsx("button", { ref: e, type: "submit", className: "bg-transparent border-none p-0 job-search__search-icon", children: /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "#151F27", viewBox: "0 0 18 18", width: "22", height: "22", children: /* @__PURE__ */ f.jsx("path", { d: "m14.03 12.85 3.56 3.57-1.17 1.17-3.57-3.56a7.5 7.5 0 1 1 1.18-1.18Zm-1.68-.62a5.83 5.83 0 1 0-.13.13l.13-.13Z" }) }) })), xc = () => {
  const t = It(), e = ve(null), [r, n] = xe(), [a, i] = je(r.get("q") || ""), { t: s } = le("jobSearch");
  return /* @__PURE__ */ f.jsx("div", { className: "job-search flex flex-col items-start gap-y-6 md:gap-y-8 lg:gap-y-10 p-0", children: /* @__PURE__ */ f.jsxs("div", { className: "mb-0 w-full pb-2 flex justify-between items-center", children: [
    /* @__PURE__ */ f.jsx(
      "input",
      {
        id: t,
        className: "h5--light p-0 appearance-none bg-transparent grow",
        type: "search",
        placeholder: s("placeholder"),
        autoComplete: "new-password",
        value: a,
        onChange: ({ target: o }) => i(o.value),
        onKeyDown: (o) => {
          var l;
          o.keyCode === 13 && (o.preventDefault(), (l = e.current) == null || l.click());
        },
        name: "q"
      }
    ),
    /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-x-4", children: [
      a && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(
          bc,
          {
            onClick: () => {
              i(""), n((o) => (o.delete("query"), o));
            }
          }
        ),
        /* @__PURE__ */ f.jsx("div", { "aria-hidden": "true", className: "h-7 w-px bg-30" })
      ] }),
      /* @__PURE__ */ f.jsx(vc, { ref: e })
    ] })
  ] }) });
}, wc = ({ id: t, open: e, setOpen: r }) => {
  const { t: n } = le("jobSearch", { keyPrefix: "filters" });
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      "aria-expanded": e,
      "aria-controls": t,
      className: "filters-toggle mb-0 cursor-pointer lg:hidden border-none bg-transparent",
      onClick: () => r((a) => !a),
      children: e ? /* @__PURE__ */ f.jsxs("span", { className: "flex items-end gap-x-2", children: [
        /* @__PURE__ */ f.jsx("i", { className: "icon icon-3g-uq-p", "aria-hidden": "true" }),
        /* @__PURE__ */ f.jsx("span", { className: "paragraph-02--medium", children: n("close") })
      ] }) : /* @__PURE__ */ f.jsxs("span", { className: "flex items-end gap-x-2", children: [
        /* @__PURE__ */ f.jsx("i", { className: "icon icon-2-fz-vz", "aria-hidden": "true" }),
        /* @__PURE__ */ f.jsx("span", { className: "paragraph-02--medium", children: n("open") })
      ] })
    }
  );
}, fi = () => {
  const [t, e] = je(!1), r = ve(null);
  return Te(() => {
    const n = r.current, a = ({ currentTarget: i, relatedTarget: s }) => {
      i != null && i.contains(s) || e(!1);
    };
    return t && (n == null || n.addEventListener("focusout", a)), () => n == null ? void 0 : n.removeEventListener("focusout", a);
  }, [t]), [t, e, r];
};
var mt = /* @__PURE__ */ ((t) => (t.POSITIVE = "button-aulya", t.TRANSPARENT = "button-4cibs", t.NEGATIVE = "button-dfsvv", t.POSITIVE_S = "button-1cehk", t.CAREERS = "button-tmwm1", t.STUDENT = "button-52ule", t.STARTER = "button-5oetw", t.PROFESSIONAL = "button-lna4o", t))(mt || {});
const Fn = ({
  animateLoading: t = !1,
  classes: e,
  icon: r,
  label: n,
  onClick: a = () => {
  },
  style: i,
  type: s = "button"
}) => {
  let o = "border-none button " + i;
  return e && (o += ` ${e}`), /* @__PURE__ */ f.jsxs("button", { type: s, className: o, onClick: a, children: [
    r && /* @__PURE__ */ f.jsx("i", { className: "icon " + r }),
    /* @__PURE__ */ f.jsx("span", { children: n }),
    t && /* @__PURE__ */ f.jsxs("div", { className: "lds-ellipsis", children: [
      /* @__PURE__ */ f.jsx("div", {}),
      /* @__PURE__ */ f.jsx("div", {}),
      /* @__PURE__ */ f.jsx("div", {}),
      /* @__PURE__ */ f.jsx("div", {})
    ] })
  ] });
}, Sa = {
  en: [
    "lu",
    "by",
    "be",
    "hr",
    "in",
    "nz",
    "pl",
    "ro",
    "uk",
    "us"
  ],
  de: [
    "at",
    "de",
    "ch"
  ],
  it: [
    "it"
  ],
  pt: [
    "br"
  ],
  fr: [
    "fr"
  ]
}, Ec = (t) => {
  for (const e in Sa)
    if (Sa[e].includes(t))
      return e;
}, Sc = ({ localActive: t, setOpen: e, type: r }) => {
  const { basePath: n } = Ce(), [a] = xe(), { t: i } = le("generic"), s = () => {
    const o = new URLSearchParams(a);
    o.delete("city"), o.delete("company"), o.delete("page"), o.set("country", t);
    const l = Ec(t), c = n.split("/").filter((u) => u.length);
    return c[0] = l, c[c.length - 1] = t, `/${c.join("/")}/job-search?${o.toString()}`;
  };
  return r !== "country" || t === a.get("country") ? /* @__PURE__ */ f.jsx(
    Fn,
    {
      type: "submit",
      style: mt.POSITIVE_S,
      label: i("apply"),
      classes: "w-full mt-6 md:mt-1",
      onClick: () => e(!1)
    }
  ) : /* @__PURE__ */ f.jsx("a", { href: s(), className: "border-none button button-1cehk w-full mt-6 md:mt-1", children: /* @__PURE__ */ f.jsx("span", { children: i("apply") }) });
}, hi = ({
  id: t,
  open: e,
  options: r,
  reset: n,
  setOpen: a,
  type: i
}) => {
  const [s] = xe(), o = ve(s.get("country")), [l, c] = je(s.get(i)), u = ve(null), p = ve(null), h = or(vi), b = oi();
  Te(() => {
    var P;
    c(s.get(i)), e && ["city", "company"].includes(i) && o.current !== s.get("country") && ((P = u.current) == null || P.scrollTo(0, 0), o.current = s.get("country"));
  }, [e, s, i]);
  const { t: S } = le("jobSearch"), j = e ? "show" : "", E = { key: "", label: S(`filters.all.${i}`) };
  return Te(() => {
    e && setTimeout(() => {
      var P;
      return (P = p.current) == null ? void 0 : P.focus();
    }, 200);
  }, [e]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      id: t,
      className: `filter-dropdown flex flex-col items-center overflow-hidden dropdown ${j}`,
      role: "listbox",
      children: [
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--medium !mb-6 md:hidden", children: S(`filters.select.${i}`) }),
        /* @__PURE__ */ f.jsx(
          "ul",
          {
            className: "list-none overflow-auto w-full mb-0 pl-0 flex flex-col gap-y-3 md:gap-y-0",
            ref: u,
            tabIndex: -1,
            children: (n ? [E, ...r] : r).map(({ key: P, label: v }) => {
              const O = P === l || P === "" && !l, L = O ? " selected" : "", D = i === "role" && P !== "" ? S(`filters.role.${v}`) : v;
              return /* @__PURE__ */ f.jsx("li", { role: "none", children: /* @__PURE__ */ f.jsxs(
                "label",
                {
                  "aria-selected": O,
                  className: `p-2 rounded cursor-pointer w-full mb-0 flex items-center gap-x-2${L} has-[:focus-visible]:outline -outline-offset-2 outline-2`,
                  role: "option",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "input",
                      {
                        "aria-hidden": "true",
                        className: "appearance-none absolute focus-visible:outline-0",
                        checked: O,
                        name: i,
                        onChange: () => c(P),
                        onKeyDown: ({ key: g }) => {
                          g === " " && b(h);
                        },
                        ref: O ? p : void 0,
                        type: "radio",
                        value: P
                      }
                    ),
                    /* @__PURE__ */ f.jsx("span", { className: "dot w-2 h-2 rounded-full shrink-0" }),
                    /* @__PURE__ */ f.jsx("span", { children: D })
                  ]
                }
              ) }, P || "all");
            })
          }
        ),
        /* @__PURE__ */ f.jsx(Sc, { localActive: l, setOpen: a, type: i })
      ]
    }
  );
}, Rc = (t) => {
  const [e] = xe(), { t: r } = le("jobSearch");
  let n = nt(t);
  return n ? t === "role" && (n = r(`filters.role.${n}`)) : n = r(`filters.all.${t}`), [e.get(t) ? "active" : "", n];
}, jc = (t) => {
  const { cities: e, companies: r } = dr();
  switch (t) {
    case "city":
      return e.map(({ code: n, value: a }) => ({ key: n, label: a }));
    case "company":
      return r.map(({ code: n, value: a }) => ({ key: n, label: a }));
  }
}, pi = ({ id: t, onOpen: e, open: r, setOpen: n, type: a }) => {
  const [i, s] = Rc(a);
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      className: `job-search__trigger flex items-center justify-between cursor-pointer ${i}`,
      "aria-expanded": r ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-controls": t,
      role: "combobox",
      onClick: () => {
        r === !1 && (e == null || e()), n((o) => !o);
      },
      onKeyDown: (o) => {
        o.key === "ArrowDown" && (o.preventDefault(), n(!0));
      },
      children: [
        /* @__PURE__ */ f.jsx("span", { className: "paragraph-02--medium", children: s }),
        /* @__PURE__ */ f.jsx("i", { className: "icon icon-upk8-c" })
      ]
    }
  );
}, Cc = ({ reset: t = !0, type: e }) => {
  switch (e) {
    case "city":
    case "company":
      return /* @__PURE__ */ f.jsx(Nc, { reset: t, type: e });
    default:
      return /* @__PURE__ */ f.jsx(Pc, { reset: t, type: e });
  }
}, Pc = ({ reset: t, type: e }) => {
  const [r, n, a] = fi(), i = It(), s = _n[e].options;
  return /* @__PURE__ */ f.jsxs("div", { className: "filter max-w-full", ref: a, children: [
    /* @__PURE__ */ f.jsx(pi, { id: i, open: r, setOpen: n, type: e }),
    /* @__PURE__ */ f.jsx(
      hi,
      {
        id: i,
        open: r,
        options: s,
        reset: t,
        setOpen: n,
        type: e
      }
    )
  ] });
}, Nc = ({ reset: t, type: e }) => {
  const [r, n, a] = fi(), i = It(), s = jc(e);
  return /* @__PURE__ */ f.jsxs("div", { className: "filter max-w-full", ref: a, children: [
    /* @__PURE__ */ f.jsx(pi, { id: i, open: r, setOpen: n, type: e }),
    /* @__PURE__ */ f.jsx(
      hi,
      {
        id: i,
        open: r,
        options: s,
        reset: t,
        setOpen: n,
        type: e
      }
    )
  ] });
}, Lc = () => {
  const [t, e] = xe(), { t: r } = le("jobSearch", { keyPrefix: "filters" }), n = new URLSearchParams(t);
  return n.delete("country"), n.toString().length ? /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      className: "flex items-center gap-x-2 self-end shrink-0 border-none bg-transparent cursor-pointer h-10",
      onClick: () => e((a) => new URLSearchParams(`country=${a.get("country")}`)),
      children: [
        /* @__PURE__ */ f.jsx("i", { "aria-hidden": "true", className: "icon icon-dombj" }),
        /* @__PURE__ */ f.jsx("span", { className: "paragraph-02--medium", children: r("clearAll") })
      ]
    }
  ) : null;
};
const kc = () => {
  const { t } = le("jobSearch"), [e, r] = je(!1), n = It();
  return /* @__PURE__ */ f.jsx("div", { className: "xl:col-start-2 xl:col-end-12", children: /* @__PURE__ */ f.jsxs("div", { "aria-label": t("filters.ariaLabel"), className: "flex flex-col gap-y-10 md:gap-y-8 lg:gap-y-14", children: [
    /* @__PURE__ */ f.jsx(xc, {}),
    /* @__PURE__ */ f.jsxs("div", { className: "job-filters", children: [
      /* @__PURE__ */ f.jsx(wc, { id: n, open: e, setOpen: r }),
      /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "filters-container filters-container--job flex flex-col md:flex-row justify-between gap-y-8 lg:pt-3 lg:pb-2",
          id: n,
          children: [
            /* @__PURE__ */ f.jsx("div", { className: "flex flex-col md:flex-row flex-wrap gap-y-8 md:gap-y-3 md:gap-x-6 lg:gap-x-8", children: Object.keys(_n).map((a) => /* @__PURE__ */ f.jsx(Cc, { type: a, reset: a !== "country" }, a)) }),
            /* @__PURE__ */ f.jsx(Lc, {})
          ]
        }
      )
    ] })
  ] }) });
}, mi = ["og:title", "twitter:title"], gi = ["description", "og:description", "twitter:description"], yi = ["og:url", "twitter:url"], He = (t, e) => {
  let r = document.head.querySelector(`meta[name="${t}"], meta[property="${t}"]`);
  r ? r.setAttribute("content", e) : (r = document.createElement("meta"), t.startsWith("og:") ? r.setAttribute("property", t) : r.name = t, r.content = e, document.head.appendChild(r));
}, Oc = () => {
  const t = We(), { t: e } = le("jobSearch", { keyPrefix: "meta" });
  Te(() => {
    document.title = e("title"), mi.forEach((r) => He(r, e("title"))), gi.forEach((r) => He(r, e("description"))), He("keywords", e("keywords")), He("twitter:card", "summary");
  }, [e]), Te(() => {
    yi.forEach((r) => He(r, window.location.href));
  }, [t]);
}, bi = () => {
  const {
    data: { abstract: t, country: e, job_offer_keywords: r, publicationDate: n, title: a }
  } = ye();
  Te(() => {
    document.title = a, mi.forEach((i) => He(i, a)), gi.forEach((i) => He(i, t)), He("keywords", (r == null ? void 0 : r.join(", ")) || ""), He("twitter:card", "summary"), yi.forEach((i) => He(i, window.location.href));
  }, [t, e, r, n, a]);
}, vi = Hr(null), Dc = () => {
  Oc();
  const t = ve(null);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(An, { type: "search" }),
    /* @__PURE__ */ f.jsxs(ii, { method: "get", className: "p-0", ref: t, children: [
      /* @__PURE__ */ f.jsx("section", { className: "section-w/max-w bg-20", children: /* @__PURE__ */ f.jsx("div", { className: "pt-8 md:pt-12 lg:pt-14 pb-6 md:pb-8 lg:pb-12 px-10 md:px-16 xl:grid xl:grid-cols-12 xl:gap-x-10", children: /* @__PURE__ */ f.jsx(vi.Provider, { value: t.current, children: /* @__PURE__ */ f.jsx(kc, {}) }) }) }),
      /* @__PURE__ */ f.jsx("section", { className: "section-w/max-w", children: /* @__PURE__ */ f.jsx("div", { className: "pt-10 pb-12 md:pt-14 md:pb-20 lg:pb-24 px-10 md:px-16 xl:grid xl:grid-cols-12 xl:gap-x-10", children: /* @__PURE__ */ f.jsx(yc, {}) }) })
    ] })
  ] });
}, xi = ({ classes: t, label: e, onClick: r, style: n, type: a = "button" }) => {
  let i = "border-none button " + n;
  return t && (i += ` ${t}`), /* @__PURE__ */ f.jsx("button", { type: a, className: i, onClick: r, children: /* @__PURE__ */ f.jsx("span", { children: e }) });
}, Tc = (t, e) => {
  const r = new URLSearchParams(e), n = Number(r.get("page"));
  return n && r.set("page", (n > 0 ? n - 1 : 0).toString()), Ft.get(`${t}/jobpost2`, {
    params: r
  });
}, Ra = (t, e, r) => {
  const n = {
    metaKey: "job_post_country",
    code: t,
    depMetaKey: `job_post_${r}`
  };
  return Ft.get(`${e}/content-meta-values-relations/job_post`, { params: n });
}, Ac = (t, e) => Ft.get(`${t}/jobpost2/${e}`), _c = async ({
  attachmentType: t,
  challenge: e,
  contentType: r,
  endpoint: n
}) => {
  const a = t === "cv" ? "cv" : "other", { data: i } = await Ft.post(`${n}/attachment/${a}`, {
    challenge: e,
    contentType: r
  });
  return i;
}, Ic = async ({ url: t, fields: e, file: r }) => {
  const n = new FormData();
  for (const [a, i] of Object.entries(e))
    n.append(a, i);
  n.append("Content-Type", r.type), n.append("x-amz-meta-filename", r.name), n.append("file", r), await Ft.post(t, n, {
    onUploadProgress: console.info,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}, Fc = async (t, e, r, n, a) => {
  let i, s;
  try {
    i = sessionStorage.getItem("s"), s = sessionStorage.getItem("k");
  } catch {
  }
  const o = {
    ...r,
    challenge: t,
    country: a.get("country"),
    source: a.get("s") || i || "reply website",
    medium: a.get("k") || s || "careerpage"
  };
  await Ft.post(`${e}/jobapplication/${n}`, o);
}, $c = () => {
  const { reCaptchaSiteKey: t } = Ce();
  Te(() => {
    if (!document.head.querySelector("script[src*=recaptcha]")) {
      const e = document.createElement("script");
      e.src = `https://www.google.com/recaptcha/api.js?render=${t}`, e.async = !0, document.head.insertAdjacentElement("beforeend", e);
    }
  }, [t]);
}, wi = () => {
  const { reCaptchaSiteKey: t } = Ce(), e = En(() => new Promise((r) => {
    window.grecaptcha ? grecaptcha.ready(r) : r();
  }), []);
  return [t, e];
}, Mc = () => {
  const [t, e] = je({}), r = En((n) => {
    const a = Object.fromEntries(new FormData(n));
    for (const i in a)
      a[i] instanceof File && (a[i].name ? a[i] = n.elements[i].dataset.key.replace("u/", "") : delete a[i]);
    e(a);
  }, []);
  return [t, r];
}, Uc = (t, e) => {
  const { country: r, jobappEndpoint: n } = Ce(), a = cr(), [i] = xe(), { id: s } = Qa(), { t: o } = le(["jobApplication", "generic"]), [l, c] = Mc(), [u, p] = je(""), [h, b] = je(!1), {
    data: { unlisted: S }
  } = ye(), j = Dr("jobApplicationStep2"), E = Dr("jobClickSubmission"), P = Dr("jobFunnelSubmission"), v = Ci(), [O, L] = wi();
  let D;
  switch (r) {
    case "pl":
      D = "jobs.polska@reply.com";
      break;
    case "de":
    case "at":
      D = "job@reply.de";
      break;
  }
  switch (t) {
    case fe.COMPILE:
      return {
        primary: {
          label: o("apply1", { ns: "jobApplication" }),
          onClick: ({ currentTarget: g }) => {
            var U, W;
            const T = g.closest("form"), F = (U = T.elements.cv) == null ? void 0 : U.parentElement, I = (W = T.elements.otherDoc) == null ? void 0 : W.parentElement;
            if (T.reportValidity() && !(F != null && F.classList.contains("loading")) && !(I != null && I.classList.contains("loading")))
              j(), c(T), e(2);
            else {
              const G = Array.from(T.elements).reduce(
                (q, J) => J.checkValidity() ? q : q.length ? q + ", " + J.name : J.name,
                ""
              );
              v({ errorMessage: G, errorType: "Invalid fields" });
            }
          }
        },
        secondary: {
          label: o("back", { ns: "generic" }),
          onClick: () => a(S ? `/job-search?${i}` : `/job-details/${s}?${i}`)
        }
      };
    case fe.RECAP:
      return {
        alreadyApplied: h,
        email: D,
        error: u,
        primary: {
          animateLoading: !0,
          label: o("apply2", { ns: "jobApplication" }),
          onClick: async ({ currentTarget: g }) => {
            E(), g.classList.add("loading"), g.setAttribute("disabled", "disabled"), p(""), b(!1), await L();
            try {
              const T = window.grecaptcha ? await grecaptcha.execute(O, { action: "submit" }) : null;
              try {
                await Fc(T, n, l, s, i), e(3), P();
              } catch (F) {
                const { message: I, response: U } = F;
                (U == null ? void 0 : U.status) === 429 ? b(!0) : (console.error("[Application] Submit went wrong: ", F), p(I));
              }
            } catch (T) {
              console.error("[Application] reCAPTCHA execution went wrong: ", T), p(JSON.stringify(T));
            } finally {
              g.classList.remove("loading"), g.removeAttribute("disabled");
            }
          }
        },
        secondary: {
          label: o("modify", { ns: "jobApplication" }),
          onClick: () => {
            e(1), p(""), b(!1);
          }
        }
      };
    case fe.TY:
      return {
        primary: {
          label: o("back", { ns: "generic" }),
          onClick: () => a(`/job-search?${i}`)
        },
        secondary: {
          label: o("careers", { ns: "generic" }),
          onClick: () => a("/")
        }
      };
  }
}, Vc = ({ setStep: t, step: e }) => {
  const { alreadyApplied: r, email: n, error: a, primary: i, secondary: s } = Uc(e, t), { t: o } = le("jobApplication");
  return /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-y-6 items-center mt-20", children: [
    /* @__PURE__ */ f.jsx("small", { className: "absolute -top-8 error-red footer-text--medium text-center", children: a }),
    r && n && /* @__PURE__ */ f.jsxs("div", { className: "absolute bottom-10 md:bottom-14 xl:bottom-[4.5rem] footer-text--medium text-center rounded-[4px] py-2 px-4 border-[#FFD138] border-2 border-solid bg-white z-[1]", children: [
      /* @__PURE__ */ f.jsx("i", { className: "icon icon-yxkur !text-[1rem] leading-none top-[-1px] pr-1" }),
      /* @__PURE__ */ f.jsx("span", { children: o("alreadyAppliedFeedback") }),
      " ",
      /* @__PURE__ */ f.jsx("a", { href: `mailto:${n}`, className: "underline", children: n }),
      "."
    ] }),
    /* @__PURE__ */ f.jsx(Fn, { style: mt.CAREERS, ...i }),
    /* @__PURE__ */ f.jsx(xi, { style: "button-gdwj3", ...s })
  ] });
}, zc = ({ step: t }) => {
  const [e] = xe(), r = e.get("country"), { t: n } = le("jobApplication");
  let a = "";
  switch (r) {
    case "nz":
      a = "jobsnz@reply.com";
      break;
    case "hr":
      a = "careers.zg@reply.de";
      break;
    case "ro":
      a = "tecro.recruiting@reply.com";
      break;
    case "us":
    case "lu":
    case "in":
    case "br":
    case "uk":
      a = "jobusa@reply.com";
      break;
    case "at":
    case "de":
      a = "job@reply.de";
      break;
    case "pl":
      a = "jobs.polska@reply.com";
      break;
  }
  const {
    data: { hiddenPosition: i, referralEnabled: s }
  } = ye(), o = () => {
    switch (!0) {
      case i:
        return "hiddenPosition";
      case s:
        return "referralEnabled";
      default:
        return "generic";
    }
  };
  switch (t) {
    case fe.COMPILE:
    case fe.RECAP:
      return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light text-center max-w-3xl mx-auto", children: /* @__PURE__ */ f.jsxs(gn, { t: n, i18nKey: `info.${o()}`, children: [
          "Thank you for your interest in our job opportunity!",
          /* @__PURE__ */ f.jsx("br", {}),
          "We look forward to receiving your application including your resume and relevant documents (references, certificates, optionally a cover letter). Upon receipt of your resume, if it is a match, we look forward to meeting you in a first interview. In the interview you will learn more about the opportunity and business area to provide you a comprehensive insight into your area of responsibility, the technologies and our company."
        ] }) }),
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light text-center !mt-10", children: n("requiredInfo") })
      ] });
    case fe.TY:
      return /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light text-center max-w-3xl mx-auto", children: /* @__PURE__ */ f.jsxs(gn, { t: n, i18nKey: "end.info", email: a, children: [
        "Thank you very much for your application!",
        /* @__PURE__ */ f.jsx("br", {}),
        "Please check in your e-mail box whether you have received the confirmation of receipt with the next steps. If you have not received a confirmation, please contact ",
        { email: a },
        ". We will carefully review your application and get back to you as soon as possible. We appreciate your patience with our process as we receive an increased number of applications."
      ] }) });
  }
};
var de = /* @__PURE__ */ ((t) => (t.NAME = "firstName", t.SURNAME = "lastName", t.EMAIL = "email", t.PHONE = "telephone", t.LINKEDIN = "linkedin", t.XING = "xing", t.CV = "cv", t.OTHER_DOC = "otherDoc", t.CONSENT = "consent", t.DI_CONSENT = "diConsent", t.REPLY_REFERENT = "replyReferent", t.CANDIDATE_PREFERENCES = "candidatePreferences", t))(de || {}), Pe = /* @__PURE__ */ ((t) => (t.EMPTY = "", t.LOADING = "filled loading", t.ERROR = "filled error", t.VALID = "filled valid", t))(Pe || {});
const Ei = ({ label: t, name: e, value: r }) => {
  const n = It();
  return /* @__PURE__ */ f.jsxs("div", { className: "form__radio flex gap-x-2", children: [
    /* @__PURE__ */ f.jsx("input", { type: "checkbox", name: e, value: r, required: !0, id: n, className: "top-1" }),
    /* @__PURE__ */ f.jsx("label", { className: "paragraph-01--medium", htmlFor: n, children: t })
  ] });
}, Bc = ({ step: t }) => {
  const { t: e } = le("jobApplication"), { language: r } = Ce();
  if (r !== "en")
    return null;
  switch (t) {
    case fe.COMPILE:
      return /* @__PURE__ */ f.jsxs("div", { className: "w-full mt-16 md:mt-20", children: [
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--medium !mb-2", children: e("DIStatement.title", { required: !0 }).toLocaleUpperCase() }),
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light !mb-6", children: e("DIStatement.info") }),
        /* @__PURE__ */ f.jsx("div", { className: "flex gap-x-12 ml-1", children: /* @__PURE__ */ f.jsx(Ei, { value: "true", label: e("privacy.consent"), name: de.DI_CONSENT }) })
      ] });
    case fe.RECAP:
    case fe.TY:
      return null;
  }
}, Kc = 104857600, Si = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
], Ri = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png"
], Hc = [
  {
    type: "text",
    name: de.NAME,
    autoComplete: "given-name",
    required: !0,
    maxLength: 50,
    columnClass: "md:col-start-1"
  },
  {
    type: "text",
    name: de.SURNAME,
    autoComplete: "family-name",
    required: !0,
    maxLength: 50,
    columnClass: "md:col-start-2"
  },
  {
    type: "email",
    name: de.EMAIL,
    autoComplete: "email",
    required: !0,
    maxLength: 100,
    columnClass: "md:col-start-1"
  },
  {
    type: "tel",
    name: de.PHONE,
    autoComplete: "tel",
    required: !0,
    maxLength: 31,
    pattern: "\\+[ \\d]{1,30}",
    columnClass: "md:col-start-2"
  },
  {
    type: "text",
    //url
    name: de.LINKEDIN,
    autoComplete: "new-password",
    required: !1,
    maxLength: 250,
    columnClass: "md:col-start-1"
  },
  {
    type: "text",
    // url
    name: de.XING,
    autoComplete: "new-password",
    required: !1,
    maxLength: 250,
    columnClass: "md:col-start-2"
  },
  {
    type: "file",
    name: de.CV,
    accept: Si.join(","),
    required: !0,
    columnClass: "md:col-start-1"
  },
  {
    type: "file",
    name: de.OTHER_DOC,
    accept: Ri.join(","),
    required: !1,
    columnClass: "md:col-start-2"
  },
  {
    type: "text",
    name: de.REPLY_REFERENT,
    autoComplete: "new-password",
    required: !0,
    maxLength: 200,
    columnClass: "md:col-start-1"
  },
  {
    type: "textarea",
    name: de.CANDIDATE_PREFERENCES,
    autoComplete: "new-password",
    required: !0,
    maxLength: 1e3,
    columnClass: "md:col-start-2"
  }
], qc = ({
  children: t,
  dataKey: e,
  errorText: r,
  info: { accept: n, columnClass: a, name: i, required: s, type: o, ...l },
  onChange: c,
  recap: u,
  status: p,
  value: h
}, b) => {
  const S = It(), { t: j } = le("jobApplication"), E = u ? "recap" : "", P = o === "textarea" ? "form__textarea" : "form__input";
  return /* @__PURE__ */ f.jsxs(
    "label",
    {
      className: `${P} ${a} p-4 mb-0 rounded bg-white flex ${p} ${E}`,
      title: j(i, { required: s }),
      htmlFor: S,
      children: [
        o === "textarea" ? /* @__PURE__ */ f.jsx(
          "textarea",
          {
            "data-key": e,
            id: S,
            name: i,
            placeholder: j(i, { required: s }),
            required: s,
            value: h,
            onChange: c,
            ref: b,
            ...l,
            disabled: u
          }
        ) : /* @__PURE__ */ f.jsx(
          "input",
          {
            "data-key": e,
            accept: n,
            id: S,
            name: i,
            placeholder: j(i, { required: s }),
            required: s,
            value: h,
            onChange: c,
            ref: b,
            type: o,
            ...l,
            disabled: u
          }
        ),
        t,
        /* @__PURE__ */ f.jsx("i", { className: "form__ok-ko-icon icon" }),
        /* @__PURE__ */ f.jsx("small", { className: "footer-text--light error-red absolute", children: r })
      ]
    }
  );
}, ji = ka(qc), Jc = (t, e) => {
  switch (t) {
    case de.CV:
      return Si.includes(e);
    case de.OTHER_DOC:
      return Ri.includes(e);
  }
}, Wc = (t) => {
  const { jobappEndpoint: e } = Ce(), [r, n] = je({ label: Pe.EMPTY }), [a, i] = je(""), [s, o] = je(""), l = ve(null), { t: c } = le("jobApplication"), [u, p] = wi(), h = Ci(), b = t === de.CV ? "CV submission" : "Document submission";
  return { attachmentHandler: async (j) => {
    var P, v, O, L, D, g, T;
    const E = j.target;
    if ((P = E.files) != null && P.length) {
      const F = E.files[0], { name: I, size: U, type: W } = F;
      if (i(I), U > Kc)
        n({
          label: Pe.ERROR,
          type: "size"
          /* SIZE */
        }), (v = l.current) == null || v.setCustomValidity(c("file.error.size")), h({ errorMessage: "Invalid size", errorType: b });
      else if (!Jc(E.name, W))
        n({
          label: Pe.ERROR,
          type: "format"
          /* FORMAT */
        }), (O = l.current) == null || O.setCustomValidity(c("file.error.format")), h({ errorMessage: "Invalid format", errorType: b });
      else {
        n({ label: Pe.LOADING }), await p();
        try {
          const G = window.grecaptcha ? await grecaptcha.execute(u, { action: "submit" }) : null;
          try {
            const { url: q, fields: J } = await _c({
              attachmentType: t,
              challenge: G,
              contentType: W,
              endpoint: e
            });
            o(J.key), await Ic({ url: q, fields: J, file: F }), n({ label: Pe.VALID }), (L = l.current) == null || L.setCustomValidity("");
          } catch (q) {
            console.error(`[Form file "${I}"] Attachment submit went wrong: `, q), n({
              label: Pe.ERROR,
              type: "generic"
              /* GENERIC */
            }), (D = l.current) == null || D.setCustomValidity(c("file.error.generic")), h({ errorMessage: "Server error", errorType: b });
          }
        } catch (G) {
          console.error(`[Form file "${I}"] reCAPTCHA execution went wrong: `, G), n({
            label: Pe.ERROR,
            type: "generic"
            /* GENERIC */
          }), (g = l.current) == null || g.setCustomValidity(c("file.error.generic"));
        }
      }
    } else
      n({ label: Pe.EMPTY }), i(""), (T = l.current) == null || T.setCustomValidity("");
  }, key: s, inputRef: l, status: r, t: c, title: a };
}, Yc = (t) => {
  const { name: e, required: r } = t.info, { attachmentHandler: n, key: a, inputRef: i, status: s, t: o, title: l } = Wc(e);
  return /* @__PURE__ */ f.jsxs(
    ji,
    {
      dataKey: a,
      errorText: s.label === Pe.ERROR ? o(`file.error.${s.type}`) : "",
      onChange: n,
      ref: i,
      status: s.label,
      ...t,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: "form__fake-placeholder whitespace-nowrap text-ellipsis overflow-hidden w-full", children: l || o(e, { required: r }) }),
        !t.recap && /* @__PURE__ */ f.jsx("i", { className: "form__attachment-icon icon icon-o-qo-qe" }),
        /* @__PURE__ */ f.jsx(In, { className: "form__input-spinner", scaleFactor: "100" })
      ]
    }
  );
}, Gc = (t) => {
  var s;
  const [e, r] = je(""), n = ve(null), { t: a } = le("jobApplication");
  let i;
  return e.length ? (s = n.current) != null && s.checkValidity() ? i = Pe.VALID : i = Pe.ERROR : i = Pe.EMPTY, /* @__PURE__ */ f.jsx(
    ji,
    {
      errorText: a("textError"),
      onChange: ({ target: o }) => r(o.value),
      ref: n,
      status: i,
      ...t
    }
  );
};
const Zc = (t) => {
  switch (t.info.type) {
    case "file":
      return /* @__PURE__ */ f.jsx(Yc, { ...t });
    case "text":
    case "email":
    case "tel":
    case "textarea":
    case "url":
    default:
      return /* @__PURE__ */ f.jsx(Gc, { ...t });
  }
}, Xc = ({ step: t }) => {
  const { country: e } = Ce(), {
    data: { hiddenPosition: r, referralEnabled: n }
  } = ye();
  let a = Hc;
  switch (t) {
    case fe.COMPILE:
    case fe.RECAP:
      if (["at", "de"].includes(e) || (a = a.filter((i) => i.name !== de.XING)), n || (a = a.filter((i) => ![
        de.REPLY_REFERENT
      ].includes(i.name))), !n && !r && (a = a.filter((i) => ![
        de.CANDIDATE_PREFERENCES
      ].includes(i.name))), r) {
        const i = a.find((s) => s.name === de.CANDIDATE_PREFERENCES);
        i && (i.columnClass = "md:col-start-1");
      }
      return /* @__PURE__ */ f.jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8 mt-16", children: a.map((i, s) => /* @__PURE__ */ f.jsx(Zc, { info: i, recap: t === fe.RECAP }, s)) });
    case fe.TY:
      return null;
  }
}, Qc = () => {
  const { language: t, country: e } = Ce();
  let r = `https://www.reply.com/${t}/privacy-notice-candidate`;
  e === "pl" ? r = "https://www.reply.com/en/privacy-notice-candidate-pl" : t === "pt" && (r = "https://www.reply.com/pt/privacy-notice-candidate-LGPD");
  const n = `https://www.reply.com/${t}/privacy-policy`;
  return [r, n];
}, eu = ({ step: t }) => {
  const { t: e } = le("jobApplication"), [r, n] = Qc(), { country: a } = Ce();
  switch (t) {
    case fe.COMPILE:
      const i = a === "pl" ? "privacy.info.pl" : "privacy.info.generic";
      return /* @__PURE__ */ f.jsxs("div", { className: "w-full mt-16 md:mt-20", children: [
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--medium !mb-2", children: e("privacy.title", { required: !0 }).toLocaleUpperCase() }),
        /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light !mb-6", children: /* @__PURE__ */ f.jsxs(gn, { t: e, i18nKey: i, children: [
          "I hereby declare that I have read and understood the",
          /* @__PURE__ */ f.jsx(
            "a",
            {
              href: r,
              className: "paragraph-01--medium underline hover:underline cursor-pointer",
              target: "_blank",
              rel: "noopener",
              children: "Privacy Policy"
            }
          ),
          "and the",
          /* @__PURE__ */ f.jsx(
            "a",
            {
              href: n,
              className: "paragraph-01--medium underline hover:underline cursor-pointer",
              target: "_blank",
              rel: "noopener",
              children: "Global Privacy and Cookie Policy"
            }
          ),
          "."
        ] }) }),
        /* @__PURE__ */ f.jsx("div", { className: "flex gap-x-12 ml-1", children: /* @__PURE__ */ f.jsx(Ei, { value: "true", label: e("privacy.consent"), name: de.CONSENT }) })
      ] });
    case fe.RECAP:
    case fe.TY:
      return null;
  }
}, tu = ({ setStep: t, step: e }) => {
  const { t: r } = le("jobApplication");
  return bi(), au(e), /* @__PURE__ */ f.jsxs("form", { method: "dialog", className: "lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11", children: [
    /* @__PURE__ */ f.jsx("h3", { className: "text-9d6ht text-center mb-16", children: r("step", { count: e }) }),
    /* @__PURE__ */ f.jsx(zc, { step: e }),
    /* @__PURE__ */ f.jsx(Xc, { step: e }),
    /* @__PURE__ */ f.jsx(eu, { step: e }),
    /* @__PURE__ */ f.jsx(Bc, { step: e }),
    /* @__PURE__ */ f.jsx(Vc, { step: e, setStep: t })
  ] });
};
var fe = /* @__PURE__ */ ((t) => (t[t.COMPILE = 1] = "COMPILE", t[t.RECAP = 2] = "RECAP", t[t.TY = 3] = "TY", t))(fe || {});
const ru = () => {
  const { data: t } = dr(), [e, r] = je(1);
  return $c(), /* @__PURE__ */ f.jsx(Sn, { fallback: /* @__PURE__ */ f.jsx(di, {}), children: /* @__PURE__ */ f.jsxs(kn, { resolve: t, children: [
    /* @__PURE__ */ f.jsx(An, {
      type: "application",
      ty: e === 3
      /* TY */
    }),
    /* @__PURE__ */ f.jsx("section", { className: "section-w/max-w bg-20 min-h-full-header", children: /* @__PURE__ */ f.jsx("div", { className: "py-20 px-10 md:px-16 lg:grid lg:grid-cols-12 lg:gap-x-10", children: /* @__PURE__ */ f.jsx(tu, { step: e, setStep: r }) }) })
  ] }) });
}, Dr = (t) => {
  const { country: e, language: r } = Ce(), {
    data: { city: n, company: a, id: i, primary_role: s, title: o }
  } = ye();
  return () => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      event: t,
      title: o,
      language: r,
      country: _t({ key: e, type: "country" }),
      jobId: i,
      reply_company: a == null ? void 0 : a.label,
      job_level: s == null ? void 0 : s.label,
      job_location: n.map(({ label: l }) => l).join(", ")
    });
  };
}, Tr = (t) => {
  const { city: e, company: r, country: n, id: a, language: i, pageType: s, primary_role: o, title: l } = t;
  let c = 0;
  switch (s) {
    case "Job detail page":
      c = 5e3;
      break;
    case "Job application form":
      c = 8e3;
      break;
  }
  return setTimeout(() => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      event: "jobFunnelLanding",
      title: l,
      language: i,
      country: _t({ key: n, type: "country" }),
      jobId: a,
      reply_company: r == null ? void 0 : r.label,
      job_level: o == null ? void 0 : o.label,
      job_location: e.map(({ label: u }) => u).join(", "),
      page_type: s
    });
  }, c);
}, nu = () => {
  const { country: t, language: e } = Ce(), {
    data: { city: r, company: n, id: a, primary_role: i, title: s }
  } = ye(), o = { city: r, company: n, country: t, id: a, language: e, primary_role: i, title: s }, l = ve(!0);
  l.current && Object.values(o).every((c) => !!c) && (Tr({
    ...o,
    pageType: "Job detail page"
  }), l.current = !1);
}, au = (t) => {
  const { country: e, language: r } = Ce(), {
    data: { city: n, company: a, id: i, primary_role: s, title: o }
  } = ye(), l = { city: n, company: a, country: e, id: i, language: r, primary_role: s, title: o }, c = ve();
  if (t !== c.current && Object.values(l).every((u) => !!u)) {
    switch (t) {
      case fe.COMPILE:
        Tr({ ...l, pageType: "Job application form" });
        break;
      case fe.RECAP:
        Tr({ ...l, pageType: "Job application review" });
        break;
      case fe.TY:
        Tr({ ...l, pageType: "Job application typ" });
        break;
    }
    c.current = t;
  }
}, Ci = () => {
  const { country: t, language: e } = Ce(), {
    data: { city: r, company: n, id: a, primary_role: i, title: s }
  } = ye();
  return ({ errorType: o, errorMessage: l }) => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      event: "Error",
      title: s,
      language: e,
      country: _t({ key: t, type: "country" }),
      jobId: a,
      reply_company: n == null ? void 0 : n.label,
      job_level: i == null ? void 0 : i.label,
      job_location: r.map(({ label: c }) => c).join(", "),
      errorType: o,
      errorMessage: l
    });
  };
}, Qr = (t) => {
  const {
    data: { primary_role: e }
  } = ye();
  switch (t) {
    case "button":
      switch (e == null ? void 0 : e.key) {
        case "student":
          return mt.STUDENT;
        case "career_starter":
          return mt.STARTER;
        case "professional":
          return mt.PROFESSIONAL;
        default:
          return mt.CAREERS;
      }
    case "color":
    default:
      switch (e == null ? void 0 : e.key) {
        case "student":
          return `${t}-student`;
        case "career_starter":
          return `${t}-starter`;
        case "professional":
          return `${t}-professional`;
        default:
          return `${t}-careers`;
      }
  }
}, Pi = ({ id: t, prepend: e }) => {
  const r = ve(null);
  return Te(() => {
    var i, s;
    const n = document.querySelector(`#${t}`), a = n == null ? void 0 : n.content.cloneNode(!0);
    a && (e ? (i = r.current) == null || i.prepend(a) : (s = r.current) == null || s.append(a));
  }, [t, e]), r;
}, iu = ({ tag: { iconClass: t, label: e } }) => {
  const r = Qr("color");
  return /* @__PURE__ */ f.jsx("li", { className: "basis-full md:basis-1/6", children: /* @__PURE__ */ f.jsxs("figure", { className: "flex flex-col gap-y-6 mb-0 items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: `/careers/benefits/${t}.svg`,
        alt: "",
        width: "64",
        height: "64",
        className: "object-contain"
      }
    ),
    /* @__PURE__ */ f.jsx("figcaption", { className: `paragraph-01--medium text-center ${r}`, children: e })
  ] }) });
}, ja = ({ children: t, section: e }) => {
  const { content: r, title: n } = e, a = Qr("color");
  return /* @__PURE__ */ f.jsxs("article", { className: "job-details__section -mx-2 px-4 py-12 md:px-8 md:py-16 lg:-mx-10 lg:px-10", children: [
    /* @__PURE__ */ f.jsx("h2", { className: `h3--medium text-center ${a} mb-8 md:mb-10`, children: n }),
    t,
    /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--light", dangerouslySetInnerHTML: { __html: r } })
  ] });
};
const su = ({ section: t }) => {
  var e;
  switch (t.type) {
    case "benefits":
      return /* @__PURE__ */ f.jsx(ja, { section: t, children: /* @__PURE__ */ f.jsx("ul", { className: "job-details__section--benefits__list list-none p-0 mb-8 flex flex-wrap md:flex-nowrap gap-y-8 gap-x-6 justify-evenly items-baseline", children: (e = t.tags) == null ? void 0 : e.map((r) => /* @__PURE__ */ f.jsx(iu, { tag: r }, r.iconClass)) }) });
    default:
      return /* @__PURE__ */ f.jsx(ja, { section: t });
  }
}, Ca = ["tasks", "benefits", "requirements", "detail", "company_info"], ou = () => {
  const {
    data: { city: t, sections: e }
  } = ye(), { id: r } = Qa(), n = ic(), [a] = xe(), i = cr(), s = Dr("jobApplicationStep1");
  bi();
  const o = Pi({ id: "socialsharetemplate", prepend: !0 }), { t: l } = le("jobDetails"), c = Qr("button"), u = Ai(() => {
    if (e)
      return [...e].sort(function(p, h) {
        const b = p.type, S = h.type, j = Ca.indexOf(b), E = Ca.indexOf(S);
        return j - E;
      });
  }, [e]);
  return /* @__PURE__ */ f.jsxs("div", { className: "lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11", ref: o, children: [
    /* @__PURE__ */ f.jsx("h3", { className: "h5--medium text-center color-70 mt-10 md:mt-6", children: t.map(({ label: p }) => p).join(", ").toLocaleUpperCase() }),
    u == null ? void 0 : u.map((p, h) => /* @__PURE__ */ f.jsx(su, { section: p }, h)),
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-y-6 items-center mt-4", children: [
      /* @__PURE__ */ f.jsx(
        Fn,
        {
          label: l("apply"),
          style: c,
          onClick: () => {
            i(`/job-application/${r}?${a}`), s();
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        xi,
        {
          label: l("back"),
          style: "button-gdwj3",
          onClick: () => i(`/job-search?${n}&${a}`)
        }
      )
    ] })
  ] });
}, lu = () => {
  const { data: t } = dr();
  return /* @__PURE__ */ f.jsx(Sn, { fallback: /* @__PURE__ */ f.jsx(di, {}), children: /* @__PURE__ */ f.jsx(kn, { resolve: t, children: /* @__PURE__ */ f.jsx(cu, {}) }) });
}, cu = () => {
  const t = Pi({ id: "slidertemplate" }), e = Qr("role");
  return nu(), /* @__PURE__ */ f.jsxs("div", { className: e, ref: t, children: [
    /* @__PURE__ */ f.jsx(An, { type: "details" }),
    /* @__PURE__ */ f.jsx("section", { className: "section-w/max-w", children: /* @__PURE__ */ f.jsx("div", { className: "pt-10 pb-20 md:pt-16 md:pb-24 px-10 md:px-16 lg:grid lg:grid-cols-12 lg:gap-x-10", children: /* @__PURE__ */ f.jsx(ou, {}) }) })
  ] });
}, uu = async ({ request: t }) => {
  const e = new URL(t.url), r = new URLSearchParams(e.searchParams), n = e.pathname.indexOf("job-");
  if (!r.get("country")) {
    const i = e.pathname.substring(n - 3, n - 1);
    r.set("country", i);
  }
  for (const [i, s] of r.entries())
    s ? r.set(i, s.toLowerCase()) : r.delete(i);
  return e.searchParams.toString() !== r.toString() ? No(`/${e.pathname.substring(n)}?${r.toString()}`) : Ro("", { status: 200 });
}, du = async ({
  publicEndpoint: t,
  request: e,
  searchEndpoint: r
}) => {
  const n = new URL(e.url), a = new URLSearchParams(n.searchParams), [i, s] = await Promise.all([
    Ra(a.get("country"), t, "city"),
    Ra(a.get("country"), t, "company")
  ]), o = Tc(r, a);
  return Ba({
    cities: i.data.filter(({ count: l }) => l ? l > 0 : !0),
    companies: s.data.filter(({ count: l }) => l ? l > 0 : !0),
    results: o
  });
}, Pa = async ({ endpoint: t, params: e }) => {
  const r = Ac(t, e.id);
  return Ba({ data: r });
}, fu = () => {
  const { message: t, response: e } = ri();
  return console.log(t), (e == null ? void 0 : e.status) === 404 ? /* @__PURE__ */ f.jsx(ml, { to: "/job-search", replace: !0 }) : /* @__PURE__ */ f.jsx("div", { className: "xl:col-start-2 xl:col-end-12 grid place-items-center my-40", children: /* @__PURE__ */ f.jsx("p", { className: "paragraph-01--medium", children: "Something went wrong" }) });
}, hu = () => {
  const t = We(), e = ve(t);
  return _i(() => {
    t.pathname !== e.current.pathname && window.scrollTo(0, 0), e.current = t;
  }, [t]), null;
}, pu = ({ basePath: t, country: e, jobappEndpoint: r, language: n, reCaptchaSiteKey: a, searchEndpoint: i }) => {
  const { i18n: s } = le();
  return Te(() => {
    (async () => await s.changeLanguage(n))();
  }, [n, s]), /* @__PURE__ */ f.jsxs(ac, { children: [
    /* @__PURE__ */ f.jsx(
      gl,
      {
        context: {
          basePath: t,
          country: e,
          jobappEndpoint: r,
          language: n,
          reCaptchaSiteKey: a,
          searchEndpoint: i
        }
      }
    ),
    /* @__PURE__ */ f.jsx(hu, {})
  ] });
}, mu = (t) => _l(
  [
    {
      path: "/",
      element: /* @__PURE__ */ f.jsx(pu, { ...t }),
      errorElement: /* @__PURE__ */ f.jsx(fu, {}),
      loader: uu,
      children: [
        {
          path: "job-search",
          element: /* @__PURE__ */ f.jsx(Dc, {}),
          loader: ({ request: e }) => du({
            publicEndpoint: t.publicEndpoint,
            request: e,
            searchEndpoint: t.searchEndpoint
          })
        },
        {
          path: "job-details/:id",
          element: /* @__PURE__ */ f.jsx(lu, {}),
          loader: ({ params: e }) => Pa({ endpoint: t.searchEndpoint, params: e })
        },
        {
          path: "job-application/:id",
          element: /* @__PURE__ */ f.jsx(ru, {}),
          loader: ({ params: e }) => Pa({ endpoint: t.searchEndpoint, params: e })
        }
      ]
    }
  ],
  { basename: t.basePath }
), gu = (t) => /* @__PURE__ */ f.jsx(zl, { router: mu(t) }), wu = (t, e) => {
  const r = rr.createRoot(t, {
    identifierPrefix: "reply-jobs-"
  });
  return r.render(at(gu, e)), r;
};
export {
  wu as mount
};
